import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { IceNavService } from '../../../../icemedx-lib/src/components/ice-nav/ice-nav.service';
import { IcepanelComponent } from '../../../../icemedx-lib/src/components/icepanel/icepanel.component';
import { IcepanelContainerComponent } from '../../../../icemedx-lib/src/components/icepanel/icepanelcontainer.component';
import { IcepanelDialog } from '../../../../icemedx-lib/src/components/icepaneldialog/icepaneldialog';
import { IcecontrolSettings, IcepanelsectionSettings, IcepanelSettings } from '../../../../icemedx-lib/src/components/models/icesettings';
import { userTypes } from '../../../../icemedx-lib/src/login/login.config';
import { LoginService } from '../../../../icemedx-lib/src/login/login.service';
import { chargehistory } from '../../../../icemedx-lib/src/models/accounting/chargehistory';
import { claim } from '../../../../icemedx-lib/src/models/accounting/claim/claim';
import { claimambulance } from '../../../../icemedx-lib/src/models/accounting/claim/claimambulance';
import { claimbucket } from '../../../../icemedx-lib/src/models/accounting/claim/claimbucket';
import { claimbucketindex } from '../../../../icemedx-lib/src/models/accounting/claim/claimbucketindex';
import { claimcontract } from '../../../../icemedx-lib/src/models/accounting/claim/claimcontract';
import { claimindex } from '../../../../icemedx-lib/src/models/accounting/claim/claimindex';
import { claimnote } from '../../../../icemedx-lib/src/models/accounting/claim/claimnote';
import { claimsupplementalinformation } from '../../../../icemedx-lib/src/models/accounting/claim/claimsupplementalinformation';
import { medicalservice } from '../../../../icemedx-lib/src/models/accounting/medservice/medicalservice';
import { superbillcharges } from '../../../../icemedx-lib/src/models/accounting/medservice/superbillcharges';
import { payment } from '../../../../icemedx-lib/src/models/accounting/payment';
import { address } from '../../../../icemedx-lib/src/models/common/address';
import { entity } from '../../../../icemedx-lib/src/models/common/entity';
import { identification } from '../../../../icemedx-lib/src/models/common/identification';
import { patient } from '../../../../icemedx-lib/src/models/domain/patient';
import { pharmacy } from '../../../../icemedx-lib/src/models/domain/pharmacy';
import { provider } from '../../../../icemedx-lib/src/models/domain/provider';
import { provider_index } from '../../../../icemedx-lib/src/models/domain/provider_index';
import { provider_reference } from '../../../../icemedx-lib/src/models/domain/provider_reference';
import { subscriber } from '../../../../icemedx-lib/src/models/domain/subscriber';
import { diagnosis } from '../../../../icemedx-lib/src/models/ehr/diagnosis';
import { encounterprogressnotes } from '../../../../icemedx-lib/src/models/ehr/encounterprogressnotes';
import { externaldata } from '../../../../icemedx-lib/src/models/ehr/externaldata';
import { referral } from '../../../../icemedx-lib/src/models/ehr/referral';
import { amount } from '../../../../icemedx-lib/src/models/ehr/subs/amount';
import { basecode } from '../../../../icemedx-lib/src/models/ehr/subs/basecode';
import { coverage } from '../../../../icemedx-lib/src/models/ehr/subs/coverage';
import { observation } from '../../../../icemedx-lib/src/models/ehr/subs/observation';
import { referenceidentification } from '../../../../icemedx-lib/src/models/ehr/subs/referenceidentification';
import { referralreference } from '../../../../icemedx-lib/src/models/ehr/subs/referralreference';
import { relatedcause } from '../../../../icemedx-lib/src/models/ehr/subs/relatedcause';
import { servicedate } from '../../../../icemedx-lib/src/models/ehr/subs/servicedate';
import { subscriberreference } from '../../../../icemedx-lib/src/models/ehr/subs/subscriberreference';
import { IceTypes } from '../../../../icemedx-lib/src/models/icetypes';
import { AccountingService } from '../../../../icemedx-lib/src/services/accounting/accounting.service';
import { DomainService } from '../../../../icemedx-lib/src/services/domain/domain.service';
import { Iceutility } from '../../../../icemedx-lib/src/services/iceutility';
import { MedicalcodesService } from '../../../../icemedx-lib/src/services/medicalcodes/medicalcodes.service';
import { MessageService } from '../../../../icemedx-lib/src/services/message/message.service';
import { PatientService } from '../../../../icemedx-lib/src/services/patient/patient.service';
import { ProviderService } from '../../../../icemedx-lib/src/services/provider/provider.service';
import { AppService } from '../app.service';
import { BreadcrumType } from '../../../../icemedx-lib/src/services/baseapp.service';
import { BreadcrumbService } from '../../../../icemedx-lib/src/services/breadcrumb/breadcrumb.service';
import { AppConstants } from '../app-constants';

const csDetails = 1;
const csSummary = 2;

class claimbucketdata {
  claim: claim = null;
  service: medicalservice = null;
  history: claim[] = [];
  constructor(svc: medicalservice, clm: claim, hist: claim[]) {
    this.service = svc;
    this.claim = clm;
    this.history = hist;
  }
}

class payerbucket {
  partyKey: string = "";
  buckets: claimbucket[] = [];
  data: claimbucketdata[] = [];
  coverage_details: any[] = [];

  processingInterval: any = -1;
  processingTimeout: any = 60;
  processingColor: string = "primary";
  percentComplete: number = 0;

  constructor(pKey: string, svc: medicalservice, clm: claim, hist: claim[]) {
    this.partyKey = pKey;
    this.adddata(svc, clm, hist);
  }

  addbucket(cbkt: claimbucket): void {
    this.buckets.push(cbkt);
  }
  getbucket(clmBucketKey: string): claimbucket {
    let fndCB = this.buckets.filter(b => b.claim_bucket_key == clmBucketKey);
    if (fndCB.length > 0) return fndCB[0];
    return null;
  }

  adddata(svc: medicalservice, clm: claim, hist: claim[]): void {
    if (this.data!= null) {
      this.data.push(new claimbucketdata(svc, clm, hist));
    }
  }

  addcoverage(cDtl: any) {
    if (this.coverage_details != null) {
      this.coverage_details.push(cDtl);
    }
  }
}

@Component({
  selector: 'app-claimsbucket',
  templateUrl: './claimsbucket.component.html',
  styleUrls: ['./claimsbucket.component.scss'],
  providers: [AppService, IceNavService, IcepanelComponent, IcepanelContainerComponent]
})
export class ClaimsbucketComponent implements OnInit {
  // Data Members
  serviceCharges: superbillcharges = null;
  chargeList: medicalservice[] = [];
  payerBuckets: payerbucket[] = [];
  payerBucketMap: any = {};

  practiceObj: provider = null;
  patientObj: patient = null;
  responsibleParties: any[] = [];
  chargeHistory: chargehistory = new chargehistory(null);
  panelSync: IcepanelSettings = new IcepanelSettings("", "", "", "", []);

  patientSubRefs: subscriberreference[] = [];
  listOfPayerResponsibities: basecode[] = [];
  listOfRelationshipCodes: basecode[] = [];
  listOfInsuranceTypes: basecode[] = [];
  insuranceTypeOptions: any[] = [];
  listOfFilingIndicator: basecode[] = [];
  filingIndicatorOptions: any[] = [];
  listOfPlaceofService: basecode[] = [];
  placeOfServiceOptions: any[] = [];
  listOfROI: basecode[] = [];
  ROIOptions: any[] = [];
  listOfModifiers: basecode[] = [];
  listOfDateQualifiers: basecode[] = [];
  dateQualOptions: any[] = [];

  practiceProviders: provider_index[] = [];

  allProviders: provider_index[] = [];
  listOfFacilities: any[] = [];

  allDiagnoses: diagnosis[] = [];
  allNotes: encounterprogressnotes[] = [];
  allAttachments: externaldata[] = [];
  allReferrals: referral[] = [];

  relatedCauseOptions: any[] = [
    { value: "AA", name: "Auto Accident" },
    { value: "EM", name: "Employment" },
    { value: "OA", name: "Other Accident" }
  ];

  claimOtherReferenceOptions: any[] = [
    { value: "D9", name: "Claim ID number for Transmission Intermediaries" },
    { value: "X4", name: "CLIA Number" },
    { value: "LX", name: "Investigational Device Exemption Number" },
    { value: "EW", name: "Mammography Certification Number" },
    { value: "EA", name: "Medical Record Number" },
    { value: "F5", name: "Medicare Section 4081 Crossover Indicator" },
    { value: "G1", name: "Prior Authorization Number" },
    { value: "F8", name: "Payer Claim Control Number" },
    { value: "9F", name: "Referral Number" },
    { value: "9A", name: "Repriced Claim Number" },
    { value: "9C", name: "Repriced(Adjusted) Claim Number" },
    { value: "4N", name: "Service Authorization Exception Code" },
  ];

  claimServiceAuthorizationExceptionCodeOptions: any[] = [
    { value: "1", name: "Immediate / Urgent Care" },
    { value: "2", name: "Services Rendered in a Retroactive Period" },
    { value: "3", name: "Emergency Care" },
    { value: "4", name: "Client as Temporary Medicaid" },
    { value: "5", name: "Request from County for Second Opinion to Recipient can Work" },
    { value: "6", name: "Request for Override Pending" },
    { value: "7", name: "Special Handling" },
  ];

  claimMandatoryMedicareSectionCrossoverIndicatorOptions: any[] = [
    { value: "Y", name: "4081" },
    { value: "N", name: "Regular Crossover" },
  ];

  claimAmounts: any[] = [
    { value: "D", name: "COB Payer Paid Amount" },
    { value: "A8", name: "COB Total Non - Covered Amount" },
    { value: "F5", name: "Patient Amount Paid" },
    { value: "EAF", name: "Remaining Patient Liability" },
  ];

  itemAmounts: any[] = [
    { value: "F4", name: "Postage Claimed" },
    { value: "T", name: "Tax" },
  ];

  listOfTransports: basecode[] = [];
  transportReasonOptions: any[] = [];

  contractTypeCodeOptions: any[] = [
    { value: "01", name: "Diagnosis Related Group(DRG)" },
    { value: "02", name: "Per Diem" },
    { value: "03", name: "Variable Per Diem" },
    { value: "04", name: "Flat" },
    { value: "05", name: "Capitated" },
    { value: "06", name: "Percent" },
    { value: "09", name: "Other" }
  ];

  attachmentReportTypeOptions: any[] = [
    { value: "03", name: "Report Justifying Treatment Beyond Utilization Guidelines" },
    { value: "04", name: "Drugs Administered" },
    { value: "05", name: "Treatment Diagnosis" },
    { value: "06", name: "Initial Assessment" },
    { value: "07", name: "Functional Goals" },
    { value: "08", name: "Plan of Treatment" },
    { value: "09", name: "Progress Report" },
    { value: "10", name: "Continued Treatment" },
    { value: "11", name: "Chemical Analysis" },
    { value: "13", name: "Certified Test Report" },
    { value: "15", name: "Justification for Admission" },
    { value: "21", name: "Recovery Plan" },
    { value: "A3", name: "Allergies / Sensitivities Document" },
    { value: "A4", name: "Autopsy Report" },
    { value: "AM", name: "Ambulance Certification" },
    { value: "AS", name: "Admission Summary" },
    { value: "B2", name: "Prescription" },
    { value: "B3", name: "Physician Order" },
    { value: "B4", name: "Referral Form" },
    { value: "BR", name: "Benchmark Testing Results" },
    { value: "BS", name: "Baseline" },
    { value: "BT", name: "Blanket Test Results" },
    { value: "CB", name: "Chiropractic Justification" },
    { value: "CK", name: "Consent Form(s)" },
    { value: "CT", name: "Certification" },
    { value: "D2", name: "Drug Profile Document" },
    { value: "DA", name: "Dental Models" },
    { value: "DB", name: "Durable Medical Equipment Prescription" },
    { value: "DG", name: "Diagnostic Report" },
    { value: "DJ", name: "Discharge Monitoring Report" },
    { value: "DS", name: "Discharge Summary" },
    { value: "EB", name: "Explanation of Benefits(Coordination of Benefits or Medicare Secondary Payer)" },
    { value: "HC", name: "Health Certificate" },
    { value: "HR", name: "Health Clinic Records" },
    { value: "I5", name: "Immunization Record" },
    { value: "IR", name: "State School Immunization Records" },
    { value: "LA", name: "Laboratory Results" },
    { value: "M1", name: "Medical Record Attachment" },
    { value: "MT", name: "Models" },
    { value: "NN", name: "Nursing Notes" },
    { value: "OB", name: "Operative Note" },
    { value: "OC", name: "Oxygen Content Averaging Report" },
    { value: "OD", name: "Orders and Treatments Document" },
    { value: "OE", name: "Objective Physical Examination(including vital signs) Document" },
    { value: "OX", name: "Oxygen Therapy Certification" },
    { value: "OZ", name: "Support Data for Claim" },
    { value: "P4", name: "Pathology Report" },
    { value: "P5", name: "Patient Medical History Document" },
    { value: "PE", name: "Parenteral or Enteral Certification" },
    { value: "PN", name: "Physical Therapy Notes" },
    { value: "PO", name: "Prosthetics or Orthotic Certification" },
    { value: "PQ", name: "Paramedical Results" },
    { value: "PY", name: "Physician’s Report" },
    { value: "PZ", name: "Physical Therapy Certification" },
    { value: "RB", name: "Radiology Films" },
    { value: "RR", name: "Radiology Reports" },
    { value: "RT", name: "Report of Tests and Analysis Report" },
    { value: "RX", name: "Renewable Oxygen Content Averaging Report" },
    { value: "SG", name: "Symptoms Document" },
    { value: "V5", name: "Death Notification" },
    { value: "XP", name: "Photographs" },
  ];

  reportTransmissionCodeOptions: any[] = [
    { value: "AA", name: "Available on Request at Provider Site" },
    { value: "FX", name: "By Fax" },
    { value: "BM", name: "By Mail" },
    { value: "EM", name: "E-Mail" },
    { value: "EL", name: "Electronically Only" },
    { value: "FT", name: "File Transfer" },
  ];

  claimEncounterIdentifierTypeOptions: any[] = [
    { value: "31", name: "Subrogation Demand" },
    { value: "CH", name: "Chargeable - Only Fee-for-service claims" },
    { value: "RP", name: "Reporting - Only Encounters" },
  ];

  // Nav
  step: number = csDetails;

  bucketHeader: IcepanelSettings = null;
  bucketFormGrp: FormGroup = null;

  editAction: any = {
    name: IceTypes.recordQuickActionEdit.name,
    value: IceTypes.recordQuickActionEdit.value,
    iconClass: { "fas": true, "fa-edit": true }
  };

  deleteAction: any = {
    name: IceTypes.recordQuickActionRemove.name,
    value: IceTypes.recordQuickActionRemove.value,
    iconClass: { "fas": true, "fa-trash": true }
  };

  allRelatedStatus: any[] = MessageService.getAccountItemStatues();

  // Claim controls
  claimBucketStatus: any = {};
  claimBucketControl: any = {};
  claimInsuranceType: any = {};
  claimFilingIndicator: any = {};
  claimOtherSubscriberListCtrl: any = {};
  claimProviderListCtrl: any = {};
  claimRelatedCausesListCtrl: any = {};
  claimPlaceOfService: any = {};
  claimEncounterType: any = {};
  claimTotal: any = {};
  facilityCode: any = {};
  providerSignatureOnFile: any = {};
  patientAssignmentOfBenefits: any = {};
  providerAcceptAssignment: any = {};
  releaseOfInformation: any = {};
  patientSignatureSource: any = {};
  claimDatesofEventsListCtrl: any = {};
  claimRemittanceDatesListCtrl: any = {};
  claimReferralAuthorizationListCtrl: any = {};
  claimReferenceIDListCtrl: any = {};
  claimAmountsListCtrl: any = {};
  claimAmbulanceTransportListCtrl: any = {};
  claimContractInformationListCtrl: any = {};
  claimAttachmentsListCtrl: any = {};
  claimNotesListCtrl: any = {};

  itemExpanded: any = {};
  itemStatusButtonCtrl: any = {};
  itemControl: any = {};
  itemDatesofEventsListCtrl: any = {};
  itemReferralAuthorizationListCtrl: any = {};
  itemReferenceIDListCtrl: any = {};
  itemAmountsListCtrl: any = {};
  itemProviderListCtrl: any = {};
  itemAttachmentsListCtrl: any = {};
  itemNotesListCtrl: any = {};

  // Popup dialogs
  otherSubscriberDialogRef: any = null;
  relatedCauseDialogRef: any = null;
  dateDialogRef: any = null;
  referralAuthDialogRef: any = null;
  otherReferenceDialogRef: any = null;
  amountValueDialogRef: any = null;
  providerValueDialogRef: MatDialogRef<any> = null;
  transportValueDialogRef: any = null;

  previousPage: string = "";
  billKey: string = "";
  navOptions: { fragment: string };

  constructor(private appSvc: AppService,
    private loginSvc: LoginService,
    private navSvc: IceNavService,
    private domainSvc: DomainService,
    private ptSvc: PatientService,
    private proSvc: ProviderService,
    private acctSvc: AccountingService,
    private medCodeSvc: MedicalcodesService,
    private breadcrumbService: BreadcrumbService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public dialog: MatDialog) {

    this.appSvc.defaultMenus();
    this.addBreadcrumbs();

    let feaAccess = this.appSvc.getPermission(userTypes.USER_FEATURES.ufAccountingJournals).default_access;
    if (feaAccess == userTypes.USER_FEATURE_ACCESS.ufaNone) {
      this.domainSvc.logMessage(IceTypes.LOGTYPE.ltError, "You do not have access to view this data.");
      return;
    }

    this.medCodeSvc.getCodes("PAYER_RESPONSIBILITY_SEQUENCE_NUMBER", "", "", "").subscribe(
      data => {
        if (data && data.length > 0) {
          this.listOfPayerResponsibities = <basecode[]>data;
        }
      },
      error => {
        // To do
      });
 
    this.medCodeSvc.getCodes("INDIVIDUAL_RELATIONSHIP_CODE", "", "", "").subscribe(
      data => {
        if (data && data.length > 0) {
          this.listOfRelationshipCodes = <basecode[]>data;
        }
      },
      error => {
        // To do
      });

    this.medCodeSvc.getCodes("INSURANCE_TYPE", "", "", "").subscribe(
      data => {
        if (data && data.length > 0) {
          this.listOfInsuranceTypes = <basecode[]>data;
          this.insuranceTypeOptions = this.listOfInsuranceTypes.map((bc) => { return { value: bc.code, name: bc.code + " - " + bc.title } });
          this.insuranceTypeOptions.unshift({ value: "", name: "N/A" });
        }
      },
      error => {
        // To do
      });

    this.medCodeSvc.getCodes("CLAIM_FILING_INDICATOR_CODE", "", "", "").subscribe(
      data => {
        if (data && data.length > 0) {
          this.listOfFilingIndicator = <basecode[]>data;
          this.filingIndicatorOptions = this.listOfFilingIndicator.map((bc) => { return { value: bc.code, name: bc.code + " - " + bc.title } });
          this.filingIndicatorOptions.unshift({ value: "", name: "N/A" });
        }
      },
      error => {
        // To do
      });

    this.medCodeSvc.getCodes("FACILITY_TYPE_CODE", "", "", "").subscribe(
      data => {
        if (data && data.length > 0) {
          this.listOfPlaceofService = <basecode[]>data;
          this.placeOfServiceOptions = this.listOfPlaceofService.map((bc) => { return { value: bc.code, name: bc.code + " - " + bc.title } });
          this.placeOfServiceOptions.unshift({ value: "", name: "N/A" });
        }
      },
      error => {
        // To do
      });
 
    this.medCodeSvc.getCodes("RELEASE_OF_INFORMATION_CODE", "", "", "").subscribe(
      data => {
        if (data && data.length > 0) {
          this.listOfROI = <basecode[]>data;
          this.ROIOptions = this.listOfROI.map((bc) => { return { value: bc.code, name: bc.code + " - " + bc.title } });
          this.ROIOptions.unshift({ value: "", name: "N/A" });
        }
      },
      error => {
        // To do
      });

    this.medCodeSvc.getCodes("MODIFIER_CODE", "", "", "").subscribe(
      data => {
        if (data && data.length > 0) {
          this.listOfModifiers = <basecode[]>data;
        }
      },
      error => {
        console.log(JSON.stringify(this.medCodeSvc.getLastErrors()));
      });
 
    this.medCodeSvc.getCodes("DATETIME_QUALIFIER", "", "", "").subscribe(
      data => {
        if (data && data.length > 0) {
          this.listOfDateQualifiers = <basecode[]>data;
          this.dateQualOptions = this.listOfDateQualifiers.map((bc) => { return { value: bc.code, name: bc.code + " - " + bc.title } });
        }
      },
      error => {
        console.log(JSON.stringify(this.medCodeSvc.getLastErrors()));
      });
    
    this.medCodeSvc.getCodes("AMBULANCE_TRANSPORT_REASON_CODE", "", "", "").subscribe(
      data => {
        if (data && data.length > 0) {
          this.listOfTransports = <basecode[]>data;
          this.transportReasonOptions = this.listOfTransports.map((bc) => { return { value: bc.code, name: bc.code + " - " + bc.title } });
        }
      },
      error => {
        console.log(JSON.stringify(this.medCodeSvc.getLastErrors()));
      });

    this.proSvc.getPracticeProviders(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), "").subscribe(
      data => {
        if (data != null) {
          this.practiceProviders = <provider_index[]>data;
        }
      },
      error => {
        // To do error
      }
    );

    this.proSvc.getProviders().subscribe(
      data => {
        if (data != null) {
          this.allProviders = <provider_index[]>data;
          for (let ipro = 0; ipro < this.allProviders.length; ipro++) {

            if (Iceutility.toLong(this.allProviders[ipro].account_type) == IceTypes.ACCOUNT_TYPE.actFacility)
              this.listOfFacilities.push({ name: this.allProviders[ipro].getdisplayname(true), value: this.allProviders[ipro].trans_account });

          }
        }
      },
      error => {
        // To do error
      }
    );

    this.domainSvc.getProvider(this.appSvc.getCurrentAccount()).subscribe(
      data => {
        if (data != null && data.length > 0) {
          this.practiceObj = data[0];
        }
      },
      error => {
        console.log(JSON.stringify(this.domainSvc.getLastErrors()));
      });

    this.attachmentReportTypeOptions.sort(function (a, b) { return a.name.localeCompare(b.name) });

    this.activatedRoute.params.subscribe(next => {
      this.payerBucketMap = {};
      this.billKey = next.key;

      this.acctSvc.getClaimBucketsByBill(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), this.billKey).subscribe(
        data => {
          if (data == null || data.length == 0) return;

          this.serviceCharges = <superbillcharges>data[0];
          if (this.serviceCharges == null) return;

          // Get Patient
          this.domainSvc.getPatient(this.serviceCharges.to_trans_account, this.serviceCharges.from_trans_account).subscribe(
            data => {
              if (data != null && data.length > 0) this.patientObj = <patient>data[0];
            },
            error => {
              console.log(JSON.stringify(this.domainSvc.getLastErrors()));
            });

          this.ptSvc.getProblems(this.serviceCharges.to_trans_account).subscribe(
            data => {
              if (data == null || data.length == 0) return;
              this.allDiagnoses = <diagnosis[]>data;
            },
            error => {
              console.log(JSON.stringify(this.domainSvc.getLastErrors()));
            });

          this.ptSvc.getReferralCertifications(this.serviceCharges.to_trans_account, this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), "").subscribe(
            data => {
              if (data == null || data.length == 0) return;

              for (let iObj = 0; iObj < data.length; iObj++) {
                let obj = data[iObj];
                if (obj == null || Iceutility.isfunction(obj.gettablename) == false) continue;

                let tbName = obj.gettablename();
                if (tbName == "REFERRAL") {
                  this.allReferrals.push(obj);
                }
              }
            },
            error => {
              console.log(JSON.stringify(this.domainSvc.getLastErrors()));
            });


          this.ptSvc.getNotesList(this.serviceCharges.to_trans_account, this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(),
            "", "", "", "").subscribe(
              data => {
                if (data == null || data.length == 0) return;
                this.allNotes = <encounterprogressnotes[]>data;
              },
              error => {
                // To do
              });

          this.domainSvc.getDocuments("patients",
            this.serviceCharges.to_trans_account,
            appSvc.getCurrentAccountType()/*more params will be added here to only pull from patient's cur provider*/,
            IceTypes.SourceType.srcUndefined).subscribe(
              data => {
                if (data && data.length > 0) {
                  this.allAttachments = <externaldata[]>data;
                }
              },
              error => {
              });

          let headerCtrls = {};
          //headerCtrls[this.claimBucketStatus.getControlName()] = this.claimBucketStatus.getFormControl();

          this.bucketFormGrp = new FormGroup(headerCtrls);

          let fncCreate: Function = (prtyBucketKey: string, cbucket?: claimbucket) => {
            if(this.claimBucketControl[prtyBucketKey] == null) {
              this.claimBucketControl[prtyBucketKey] = new IcecontrolSettings("iceselect", { menuItems: [], width: "100%" }, null, null, "ClaimBucket" + prtyBucketKey, "Claim Bucket")
                .setControlName("ClaimBucket" + prtyBucketKey)
                .createFormControl("", []);
            }

            if (cbucket != null && this.claimBucketStatus[prtyBucketKey] == null) {
              let thisStatus = Iceutility.toLong(cbucket.trans_status);
              let theseOpts = this.getNextStatusStates(thisStatus, thisStatus);

              this.claimBucketStatus[prtyBucketKey] = new IcecontrolSettings("iceselect", { menuItems: [], width: "100%" }, null, null, "BucketStatus", "Status of Claim Bucket")
                .setControlName("BucketStatus")
                .setOptions(theseOpts)
                .createFormControl(thisStatus, [Validators.required]);
            }
          };

          for (let iObj = 1; iObj < data.length; iObj++) {
            let obj = data[iObj];
            if (obj == null || Iceutility.isfunction(obj.gettablename) == false) continue;

            let tbName = obj.gettablename();
            if (tbName == "MEDICAL_SERVICE") {
              let svc: medicalservice = <medicalservice>data[iObj];
              this.chargeList.push(svc);

              if (svc.subscriber_key == "" || svc.payer_key == "") continue;
              let partyBucketKey = AccountingService.getPartyBucketKey(svc);
              let pyrBucket: payerbucket = this.payerBucketMap[partyBucketKey];
              if (pyrBucket == null) {
                this.payerBucketMap[partyBucketKey] = new payerbucket(partyBucketKey, svc, null, []);
                this.payerBuckets.push(this.payerBucketMap[partyBucketKey]);
                pyrBucket = this.payerBucketMap[partyBucketKey];
              }
              else {
                pyrBucket.adddata(svc, null, []);
              }
              fncCreate(partyBucketKey);
            }
            else if (tbName == "CLAIM_BUCKET") {
              let clmB: claimbucket = <claimbucket>data[iObj];

              if (clmB.subscriber_key == "" || clmB.payer_key == "") continue;
              let partyBucketKey = AccountingService.getPartyBucketKeyEx(clmB.subscriber_key, clmB.coverage_key, clmB.payer_key);
              let pyrBucket: payerbucket = this.payerBucketMap[partyBucketKey];
              if (pyrBucket == null) {
                this.payerBucketMap[partyBucketKey] = new payerbucket(partyBucketKey, null, null, []);
                this.payerBuckets.push(this.payerBucketMap[partyBucketKey]);
              }

              pyrBucket.addbucket(clmB);
              fncCreate(partyBucketKey, clmB);
            }
          }

          
          for (let ipB = 0; ipB < this.payerBuckets.length; ipB++) {
            let pyrBucket: payerbucket = this.payerBuckets[ipB];
            let defaultKey = "";

            let cbCtrl: IcecontrolSettings = this.claimBucketControl[pyrBucket.partyKey];
            let opts = [];
            for (let icB = 0; icB < pyrBucket.buckets.length; icB++) {
              let cBucket = pyrBucket.buckets[icB];
              if (defaultKey.length == 0) {
                if (cBucket.trans_status == IceTypes.trans_status.isReadyToSend)
                  defaultKey = cBucket.claim_bucket_key;
                if (cBucket.trans_status == IceTypes.trans_status.isReadyToPrint)
                  defaultKey = cBucket.claim_bucket_key;
                if (cBucket.trans_status == IceTypes.trans_status.isScrubbed)
                  defaultKey = cBucket.claim_bucket_key;
                if (cBucket.trans_status == IceTypes.trans_status.isNone)
                  defaultKey = cBucket.claim_bucket_key;
              }
              opts.push({ name: this.getClaimDDLTitle(cBucket.created, Iceutility.toLong(cBucket.trans_status)), value: cBucket.claim_bucket_key });
            }
            cbCtrl.setOptions(opts);
            if (defaultKey.length > 0) {
              cbCtrl.getFormControl().setValue(defaultKey);
            }
            else if (opts.length > 0) {
              cbCtrl.getFormControl().setValue(opts[opts.length - 1].value);
              defaultKey = opts[opts.length - 1].value;
            }

            if (defaultKey.length > 0) {
              let statusCtrl: IcecontrolSettings = this.claimBucketStatus[pyrBucket.partyKey];
              let fndBuck = pyrBucket.buckets.filter(b => b.claim_bucket_key == defaultKey);
              if (statusCtrl != null && fndBuck.length > 0) {
                let thisStatus = Iceutility.toLong(fndBuck[0].trans_status);
                let theseOpts = this.getNextStatusStates(thisStatus, thisStatus);
                statusCtrl.setOptions(theseOpts);
                statusCtrl.getFormControl().setValue(thisStatus);
              }
            }
          }

          let optForBillTo = this.serviceCharges.bill_to + " (" + DomainService.getDomainType(Iceutility.toLong(this.serviceCharges.to_account_type)) + ", Cash Pay)";
          this.responsibleParties = [{ name: optForBillTo, value: "", summary: [] }];

          this.ptSvc.getPatientSubscriberRefs(this.serviceCharges.to_trans_account, appSvc.getCurrentAccount(), appSvc.getCurrentAccountType()).subscribe(
            data => {
              if (data != null) {
                this.patientSubRefs = data;
                this.ptSvc.getPatientSubscribers(this.serviceCharges.to_trans_account, appSvc.getCurrentAccount(), appSvc.getCurrentAccountType()).subscribe(
                  subdata => {
                    if (subdata != null) {
                      for (let isub = 0; isub < subdata.length; isub++) {
                        let sub: subscriber = subdata[isub];
                        if (sub.COVGS.length > 0) {
                          let pyrCovs = this.ptSvc.getPayerCoverageBenefits(sub, true, this.patientSubRefs, this.listOfPayerResponsibities);
                          if (pyrCovs != null) {
                            for (let icov = 0; icov < pyrCovs.length; icov++) {
                              let covDtl = pyrCovs[icov];

                              let pyrBucket: payerbucket = this.payerBucketMap[covDtl["payer_id"]];
                              if (pyrBucket != null) {
                                pyrBucket.addcoverage(covDtl);
                              }

                              this.responsibleParties.push({
                                name: covDtl["payer_name"],
                                value: covDtl["payer_id"],
                                summary: covDtl.summary
                              });
                            }
                          }
                        }
                      }

                      for (let ipyr = 0; ipyr < this.payerBuckets.length; ipyr++) {
                        let pyrBucket = this.payerBuckets[ipyr];
                        this.loadClaimOtherSubscriberListControl(pyrBucket);
                        this.loadClaimProviderListControl(pyrBucket);
                        this.loadClaimRelatedCausesListControl(pyrBucket);
                        this.loadClaimDatesofEventsListControl(pyrBucket);
                        this.loadClaimRemittanceDatesListControl(pyrBucket);
                        this.loadClaimReferralAuthorizationListControl(pyrBucket);
                        this.loadClaimReferenceIDListControl(pyrBucket);
                        this.loadClaimAmountsListControl(pyrBucket);
                        this.loadClaimAmbulanceTransportListControl(pyrBucket);
                        this.loadClaimContractInformationListControl(pyrBucket);
                        this.loadClaimAttachmentsListControl(pyrBucket);
                        this.loadClaimNotesListControl(pyrBucket);

                        this.loadClaimItems(pyrBucket);
                      }
                    }
                  },
                  error => {
                    console.log(error);
                  });
              }
            },
            err => {

            });

          /*
          this.acctSvc.getClaimBucketsByBill(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), next.key).subscribe(
            claimData => {
              debugger;
              if (claimData == null || claimData.length == 0) {
                return;
              }

              //1) initialized (Ready) allow edits
              // These are all ready only statuses for claims
              //2) Pre - Process - Waiting
              //3) Process - Pending
              //4) Sent – Sent / Printed
              //5) Status – Accepted / Received
              //S6-Sn) are all readonly edits/corrections will initialized into new buckets
              //  Whereas user could A). Clone B). Clone and Refresh 

              this.claimBucket = <claimbucket[]>data;
              if (this.claimBucket == null) return;
            },
            error => {
              console.log(JSON.stringify(this.acctSvc.getLastErrors()));
            });
          */
        },
        error => {
          console.log(JSON.stringify(this.acctSvc.getLastErrors()));
        });
    });

    this.activatedRoute.fragment.subscribe(fragment => {
      if (Iceutility.isdefined(fragment)) {
        this.previousPage = fragment;

        if (fragment == AppConstants.LedgerPage) {
          this.breadcrumbService.updateBreadcrumb(BreadcrumType.btBranch.toString(), {
            display: "Ledger - Claim Bucket",
            data: null,
            active: true,
            link: "",
            history: []
          });
        } else if (fragment == AppConstants.ServiceChargeHistoryPage) {
          this.breadcrumbService.updateBreadcrumb(BreadcrumType.btBranch.toString(), {
            display: "Service Charge History - Claim Bucket",
            data: null,
            active: true,
            link: "",
            history: []
          });
        }

        this.navOptions = { fragment: fragment };
      }
    });
  }

  ngOnInit() {
    this.appSvc.refreshMenus();
  }

  addBreadcrumbs() {
    this.breadcrumbService.updateBreadcrumbs({
      TREE: { display: "Accounting", data: null, active: true, link: "/accounting/summary", history: [] },
      BRANCH: { display: "Outstanding - Claim Bucket", data: null, active: true, link: "", history: [] }
    });
  }

  getBucketHeaderGroup(): FormGroup {
    return this.bucketFormGrp;
  }

  getClaimDDLTitle(claimDate: any, status: IceTypes.trans_status): string {
    return "Created on " + claimDate + " Status: " + MessageService.getStatus(status, IceTypes.SourceType.srcStatement);
  }

  getProviderObject(): any {
    let ret = null;
    let farm = this.appSvc.getBreadcrumFarm();
    if (farm != null) {
      switch (this.appSvc.getCurrentAccountType()) {
        case IceTypes.ACCOUNT_TYPE.actFacility:
        case IceTypes.ACCOUNT_TYPE.actProvider:
            ret = <provider>farm;
            break;
        case IceTypes.ACCOUNT_TYPE.actPharmacy:
          ret = <pharmacy>farm;
          break;
      }
    }
    return ret;
  }

  getBillingProviderName(): string {
    let ret = "";
    let pro = this.getProviderObject();
    if (pro != null && Iceutility.isfunction(pro.getdisplayname)) {
      ret = pro.getdisplayname(this.appSvc.getCurrentAccountType() != IceTypes.ACCOUNT_TYPE.actProvider);
    }
    return ret;
  }

  getBillingProviderAddress(): string {
    let ret = "";
    let pro = this.getProviderObject();
    if (pro != null && Iceutility.isdefined(pro.address_key) && Iceutility.isdefined(pro.ADS)) {
      let ads: address[] = <address[]>pro.ADS;
      let fAdr = ads.filter(a => a.address_key == pro.address_key);
      if (fAdr.length > 0) {
        ret = fAdr[0].street1 + " " + fAdr[0].street2;
      }
    }
    return ret;
  }

  getBillingProviderCityStateZip(): string {
    let ret = "";
    let pro = this.getProviderObject();
    if (pro != null && Iceutility.isdefined(pro.address_key) && Iceutility.isdefined(pro.ADS)) {
      let ads: address[] = <address[]>pro.ADS;
      let fAdr = ads.filter(a => a.address_key == pro.address_key);
      if (fAdr.length > 0) {
        ret = fAdr[0].city + ", " + fAdr[0].state_id + " " + fAdr[0].postal_code;
      }
    }
    return ret;
  }

  getBillingProviderTaxonomyCode(): string {
    let ret = "";
    let pro = this.getProviderObject();
    if (pro != null && Iceutility.isdefined(pro.taxonomy_code)) {
      ret = pro.taxonomy_code;
    }
    return ret;
  }

  getPatientName(): string {
    let ret = "";
    let pt = this.patientObj;
    if (pt != null) {
      ret = pt.getName();
    }
    return ret;
  }

  getPatientAddress(): string {
    let ret = "";
    let pt = this.patientObj;
    if (pt != null && Iceutility.isdefined(pt.ADS)) {
      let ads: address[] = <address[]>pt.ADS;
      let fAdr = ads.filter(a => a.address_key == pt.address_key);
      if (fAdr.length > 0) {
        ret = fAdr[0].street1 + " " + fAdr[0].street2;
      }
    }
    return ret;
  }

  getPatientCityStateZip(): string {
    let ret = "";
    let pt = this.patientObj;
    if (pt != null && Iceutility.isdefined(pt.ADS)) {
      let ads: address[] = <address[]>pt.ADS;
      let fAdr = ads.filter(a => a.address_key == pt.address_key);
      if (fAdr.length > 0) {
        ret = fAdr[0].city + ", " + fAdr[0].state_id + " " + fAdr[0].postal_code;
      }
    }
    return ret;
  }

  getPatientDOB(): string {
    let ret = "";
    let pt = this.patientObj;
    if (pt != null && Iceutility.isdefined(pt.ENTS)) {
      let ents: entity[] = <entity[]>pt.ENTS;
      let fEnt = ents.filter(e => e.entity_key == pt.entity_key);
      if (fEnt.length > 0) {
        let dob_utc = fEnt[0]["dob_utc"];
        ret = Iceutility.getDateTextEx(dob_utc != null && dob_utc.length > 0 ? dob_utc : Iceutility.ConvertFromDotNetServerTime(fEnt[0].dob), null, false);
      }
    }
    return ret;
  }

  getPayerBuckets(): payerbucket[] {
    return this.payerBuckets.filter(pb => pb.buckets.length > 0);
  }

  getNewPayerBuckets(): payerbucket[] {
    return this.payerBuckets.filter(pb => pb.buckets.length == 0);
  }

  getPayerBucketByPartyKey(key: string): payerbucket { 
    let ret = this.payerBuckets.filter(bk => bk.partyKey == key);
    if (ret.length > 0) return ret[0];
    return null;
  }

  getSelectedClaimBucket(pyrBucket: payerbucket): claimbucket {
    let cbCtrl: IcecontrolSettings = this.claimBucketControl[pyrBucket.partyKey];
    if (cbCtrl == null) return null;

    let cbucket = pyrBucket.getbucket(cbCtrl.getFormControl().value);
    return cbucket;
  }

  getPayerBucketCoverages(pyrBucket: payerbucket): any[] {
    if (pyrBucket.coverage_details == null) return [];
    let covDtls: any[] = pyrBucket.coverage_details;
    return covDtls;
  }

  getPayerName(pyrBucket: payerbucket): string {
    let covDtls: any[] = this.getPayerBucketCoverages(pyrBucket);
    if (covDtls.length == 0) return "";
    if (covDtls[0]["payer_name"] == null) return "";
    return covDtls[0]["payer_name"];
  }

  getPayerID(pyrBucket: payerbucket): string {
    if (pyrBucket == null) return "";
    let covDtls: any[] = this.getPayerBucketCoverages(pyrBucket);
    if (covDtls.length == 0) return "";
    if (covDtls[0] == null) return "";

    let cov: coverage = covDtls[0].cov;
    return this.getPayerIDByCoverage(cov);
  }

  getPayerIDByCoverage(cov: coverage): string {
    if (cov == null) return "";
    let ret = "Unknown";
    if (cov.payer_identification.length > 0) {
      ret = cov.payer_id_code_qualifier + " - " + cov.payer_identification;
    }
    return ret;
  }

  getPayerBucketKey(pyrBucket: payerbucket): string {
    let covDtls: any[] = this.getPayerBucketCoverages(pyrBucket);
    if (covDtls.length == 0) return "";
    if (covDtls[0]["payer_id"] == null) return "";
    return covDtls[0]["payer_id"];
  }

  getPayerResponsibility(pyrBucket: payerbucket): string {
    let ret = "";
    if (pyrBucket == null) return ret;
    let claimsData = pyrBucket.data;
    if (claimsData != null && claimsData.length > 0) {
      let svc: medicalservice = claimsData[0].service;
      let fndRef = this.patientSubRefs.filter(ref => ref.coverage_key == svc.coverage_key);
      if (fndRef.length > 0) {
        let foundCode = this.listOfPayerResponsibities.filter(c => c.code == fndRef[0].payer_responsibility_code);
        if (foundCode.length > 0) {
          ret = foundCode[0].title;
        }
      }
    }
    return ret;
  }

  getSubscriberName(pyrBucket: payerbucket): string {
    if (pyrBucket == null) return "";
    let covDtls: any[] = this.getPayerBucketCoverages(pyrBucket);
    if (covDtls.length == 0) return "";
    let sub: subscriber = covDtls[0].sub;
    if (sub == null) return ""; 
    return sub.getName();
  }

  getSubscriberAddress(pyrBucket: payerbucket): string {
    if (pyrBucket == null) return "";
    let covDtls: any[] = this.getPayerBucketCoverages(pyrBucket);
    if (covDtls.length == 0) return "";
    if (covDtls[0] == null) return "";

    let sub: subscriber = covDtls[0].sub;
    let cov: coverage = covDtls[0].cov;
    if (cov == null) return "";

    let ret = "";
    if (cov.subscriber_onfile_address_key.length > 0 && Iceutility.isdefined(cov.ADS)) {
      let ads: address[] = <address[]>cov.ADS;
      let fAds = ads.filter(a => a.address_key == cov.subscriber_onfile_address_key);
      if (fAds.length > 0) {
        ret = fAds[0].street1 + " " + fAds[0].street2 + fAds[0].city + ", " + fAds[0].state_id + " " + fAds[0].postal_code;
        if (fAds[0].country_id.length > 0)
          ret += ", " + fAds[0].country_id;
      }
    }
    else if (sub && sub.address_key.length > 0 && Iceutility.isdefined(sub.ADS)) {
      let ads: address[] = <address[]>sub.ADS;
      let fAds = ads.filter(a => a.address_key == sub.address_key);
      if (fAds.length > 0) {
        ret = fAds[0].street1 + " " + fAds[0].street2 + fAds[0].city + ", " + fAds[0].state_id + " " + fAds[0].postal_code;
        if (fAds[0].country_id.length > 0)
          ret += ", " + fAds[0].country_id;
      }
    }
    return ret;
  }

  getSubscriberDOB(pyrBucket: payerbucket): string {
    if (pyrBucket == null) return "";
    let covDtls: any[] = this.getPayerBucketCoverages(pyrBucket);
    if (covDtls.length == 0) return "";
    let sub: subscriber = covDtls[0].sub;
    if (sub == null) return "";

    let ret = "";
    if (Iceutility.isdefined(sub.ENTS)) {
      let ents: entity[] = <entity[]>sub.ENTS;
      let fEnt = ents.filter(e => e.entity_key == sub.entity_key);
      if (fEnt.length > 0) {
        let dob_utc = fEnt[0]["dob_utc"];
        ret = Iceutility.getDateTextEx(dob_utc != null && dob_utc.length > 0 ? dob_utc : Iceutility.ConvertFromDotNetServerTime(fEnt[0].dob), null, false);
      }
    }
    return ret;
  }

  getSubscriberSSN(pyrBucket: payerbucket): string {
    if (pyrBucket == null) return "";
    let covDtls: any[] = this.getPayerBucketCoverages(pyrBucket);
    if (covDtls.length == 0) return "";
    if (covDtls[0] == null) return "";

    let sub: subscriber = covDtls[0].sub;
    let cov: coverage = covDtls[0].cov;
    if (cov == null) return "";

    let ret = "Unknown";
    if (Iceutility.isdefined(cov.IDS)) {
      let ids: identification[] = <identification[]>cov.IDS;
      let fIds = ids.filter(i => i.identification_code_qualifier == "SY");
      if (fIds.length > 0) {
        ret = fIds[0].identification_code;
      }
    }
    else if (sub && Iceutility.isdefined(sub.IDS)) {
      let ids: identification[] = <identification[]>sub.IDS;
      let fIds = ids.filter(i => i.identification_code_qualifier == "SY");
      if (fIds.length > 0) {
        ret = fIds[0].identification_code;
      }
    }
    return ret;
  }

  getSubscriberGroupNumber(pyrBucket: payerbucket): string {
    let ret = "Unknown";
    if (pyrBucket == null) return ret;
    let covDtls: any[] = this.getPayerBucketCoverages(pyrBucket);
    if (covDtls.length == 0) return ret;
    if (covDtls[0] == null) return ret;
    return covDtls[0].group_num;
  }

  getSubscriberMINumber(pyrBucket: payerbucket): string {
    let ret = "Unknown";
    if (pyrBucket == null) return ret;
    let covDtls: any[] = this.getPayerBucketCoverages(pyrBucket);
    if (covDtls.length == 0) return ret;
    if (covDtls[0] == null) return ret;
    return covDtls[0].mi_num;
  }

  getSubscriberPlanName(pyrBucket: payerbucket): string {
    let ret = "Unknown";
    if (pyrBucket == null) return ret;
    let covDtls: any[] = this.getPayerBucketCoverages(pyrBucket);
    if (covDtls.length == 0) return ret;
    if (covDtls[0] == null) return ret;
    return covDtls[0].plan_name;
  }

  getSubscriberInsuranceType(pyrBucket: payerbucket): string {
    let ret = "";
    if (pyrBucket == null) return ret;
    let covDtls: any[] = this.getPayerBucketCoverages(pyrBucket);
    if (covDtls.length == 0) return ret;
    if (covDtls[0] == null) return ret;
    let cov: coverage = covDtls[0].cov;
    if (cov == null || cov.insurance_type_code.length == 0) return ret;
    return cov.insurance_type_code;
  }

  getSubscriberFilingIndicator(pyrBucket: payerbucket): string {
    let ret = "";
    if (pyrBucket == null) return ret;
    let covDtls: any[] = this.getPayerBucketCoverages(pyrBucket);
    if (covDtls.length == 0) return ret;
    if (covDtls[0] == null) return ret;
    let cov: coverage = covDtls[0].cov;
    if (cov == null || cov.claim_filing_indicator_code.length == 0) return ret;
    return cov.claim_filing_indicator_code;
  }

  getSubscriberPatientRelationship(pyrBucket: payerbucket): string {
    if (pyrBucket == null) return "";
    let covDtls: any[] = this.getPayerBucketCoverages(pyrBucket);
    if (covDtls.length == 0) return "";
    let sub: subscriber = covDtls[0].sub;
    if (sub == null) return "";

    let ret = "";
    let fndCode = this.listOfRelationshipCodes.filter(c => c.code == sub.relationship_code);
    if (fndCode.length > 0) {
      ret = fndCode[0].title;
    }

    return ret;
  }

  initializePanelSync(clm: any) {
    setTimeout(() => {
      if (this.panelSync != null) {
        if (this.panelSync.getInitializeEvent() != null) {
          this.panelSync.getInitializeEvent().emit(clm);
        }
      }
    });
  }

  getBucketActions(pyrBucket: payerbucket): any[] {
    let actions: any[] = [];

    let cbucket = this.getSelectedClaimBucket(pyrBucket);
    if (cbucket == null) {
      return actions;
    }

    switch (Iceutility.toLong(cbucket.trans_status)) {
      case IceTypes.trans_status.isNone:
      case IceTypes.trans_status.isTentative:
      case IceTypes.trans_status.isError:
        actions.push(IceTypes.recordQuickActionRemove);
        actions.push(IceTypes.recordQuickActionRefresh);
        break;
      case IceTypes.trans_status.isScrubbed:
        actions.push(IceTypes.recordQuickActionSend);
        actions.push(IceTypes.recordQuickActionCloudDownload);
        break;
      case IceTypes.trans_status.isReadyToPrint:
        actions.push(IceTypes.recordQuickActionCloudDownload);
        break;
    }

    actions.push(IceTypes.recordQuickActionClone);
    return actions;
  }

  getBucketActionClass(pyrBucket: payerbucket, action: any): any {
    if (action == null)
      return { "fas": true, "fa-question": true, "fa-3x": true };

    return action.iconClass;
  }
  //getBucketActionStyle(pyrBucket, action)
  getBucketActionColor(pyrBucket: payerbucket, action: any): any {
    let ret = { "color": "black" };
    let cbucket = this.getSelectedClaimBucket(pyrBucket);
    if (cbucket == null || action == null)
      return ret;

    switch (Iceutility.toLong(cbucket.trans_status)) {
      case IceTypes.trans_status.isScrubbed:
        if (IceTypes.recordQuickActionSend.value == action.value
          || IceTypes.recordQuickActionCloudDownload.value == action.value )
          ret = { "color": "green" };
        break;
      case IceTypes.trans_status.isReadyToPrint:
        if (IceTypes.recordQuickActionCloudDownload.value == action.value)
          ret = { "color": "green" };
        break;
    }

    return ret;
  }

  getNewBucketActionClass(pyrBucket: payerbucket): any {
    return IceTypes.recordQuickActionRefresh.iconClass;
  }

  getItemActions(pyrBucket: payerbucket, clm: claim): any[] {
    let actions: any[] = [];

    let cbucket = this.getSelectedClaimBucket(pyrBucket);
    if (cbucket == null || clm == null) {
      return actions;
    }

    switch (Iceutility.toLong(clm.trans_status)) {
      case IceTypes.trans_status.isNone:
      case IceTypes.trans_status.isTentative:
      case IceTypes.trans_status.isError:
        actions.push(IceTypes.recordQuickActionRemove);
        actions.push(IceTypes.recordQuickActionRefresh);
        break;
    }

    actions.push(IceTypes.recordQuickActionClone);
    return actions;
  }

  getItemActionClass(pyrBucket: payerbucket, clm: claim, action: any): any {
    if (action == null)
      return { "fas": true, "fa-question": true, "fa-3x": true };

    return action.iconClass;
  }

  getClaimInformation(pyrBucket: payerbucket): string {
    let cbucket = this.getSelectedClaimBucket(pyrBucket);
    if (cbucket == null) return "";

    let ret = this.getPayerResponsibility(pyrBucket);
    let payerName = this.getPayerName(pyrBucket);
    ret = payerName + ", Payer ID: " + this.getPayerID(pyrBucket);
    ret += " - " + AccountingService.getResponsiblePartyShortName(payerName);

    let insType = this.getSubscriberInsuranceType(pyrBucket);
    let filIndicator = this.getSubscriberFilingIndicator(pyrBucket);
    ret += ", Subscriber: " + this.getSubscriberName(pyrBucket);
    ret += " - " + this.getSubscriberPatientRelationship(pyrBucket);
    ret += ", DOB: " + this.getSubscriberDOB(pyrBucket);
    ret += ", MI: " + this.getSubscriberMINumber(pyrBucket);
    ret += ", GP: " + this.getSubscriberGroupNumber(pyrBucket);
    ret += ", SSN: " + this.getSubscriberSSN(pyrBucket);
    ret += ", Plan Name: " + this.getSubscriberPlanName(pyrBucket);
    ret += ", Type: " + insType == "" ? "N/A" : insType;
    ret += ", Filing: " + filIndicator == "" ? "N/A" : filIndicator;
    ret += ", Address: " + this.getSubscriberAddress(pyrBucket);

    if (this.claimInsuranceType[pyrBucket.partyKey] == null) {
      this.claimInsuranceType[pyrBucket.partyKey] = new IcecontrolSettings("iceselect", { menuItems: [], width: "100%" }, null, null, "InsuranceType" + pyrBucket.partyKey, "Insurance Type")
        .setControlName("InsuranceType" + pyrBucket.partyKey)
        .createFormControl(cbucket.insurance_type_code, [])
        .setOptions(this.insuranceTypeOptions);
    }
    else {
      this.setDisabled(pyrBucket, <IcecontrolSettings>this.claimInsuranceType[pyrBucket.partyKey]);
    }


    if (this.claimFilingIndicator[pyrBucket.partyKey] == null) {
      this.claimFilingIndicator[pyrBucket.partyKey] = new IcecontrolSettings("iceselect", { menuItems: [], width: "100%" }, null, null, "FilingIndicator" + pyrBucket.partyKey, "Filing Indicator")
        .setControlName("FilingIndicator" + pyrBucket.partyKey)
        .createFormControl(cbucket.claim_filing_indicator_code, [])
        .setOptions(this.filingIndicatorOptions);
    }
    else {
      this.setDisabled(pyrBucket, <IcecontrolSettings>this.claimFilingIndicator[pyrBucket.partyKey]);
    }
    
    if (this.claimEncounterType[pyrBucket.partyKey] == null) {
      this.claimEncounterType[pyrBucket.partyKey] = new IcecontrolSettings("iceselect", { menuItems: [], width: "100%" }, null, null, "ClaimEncounterType" + pyrBucket.partyKey, "Claim or Encounter")
        .setControlName("ClaimEncounterType" + pyrBucket.partyKey)
        .createFormControl(cbucket.claim_encounter_type, [])
        .setOptions(this.claimEncounterIdentifierTypeOptions);
    }
    else {
      this.setDisabled(pyrBucket, <IcecontrolSettings>this.claimEncounterType[pyrBucket.partyKey]);
    }

    if (this.claimPlaceOfService[pyrBucket.partyKey] == null) {
      this.claimPlaceOfService[pyrBucket.partyKey] = new IcecontrolSettings("iceselect", { menuItems: [], width: "100%" }, null, null, "PlaceOfService" + pyrBucket.partyKey, "Place of Service")
        .setControlName("PlaceOfService" + pyrBucket.partyKey)
        .createFormControl(cbucket.place_of_service_code, [])
        .setOptions(this.placeOfServiceOptions);
    }
    else {
      this.setDisabled(pyrBucket, <IcecontrolSettings>this.claimPlaceOfService[pyrBucket.partyKey]);
    }

    if (this.claimTotal[pyrBucket.partyKey] == null) {
      this.claimTotal[pyrBucket.partyKey] = new IcecontrolSettings("icelabel", { value: "Total Claim:", width: "100%" }, null, null, "ClaimTotal" + pyrBucket.partyKey, "Claim Total")
        .setControlName("ClaimTotal" + pyrBucket.partyKey)
        .createFormControl(this.getClaimTotal(pyrBucket), []);
    }

    if (this.facilityCode[pyrBucket.partyKey] == null) {
      this.facilityCode[pyrBucket.partyKey] = new IcecontrolSettings("icelabel", { value: "Fac. Code:", width: "100%" }, null, null, "FacilityCode" + pyrBucket.partyKey, "Facility Code")
        .setControlName("FacilityCode" + pyrBucket.partyKey)
        .createFormControl(cbucket.facility_code_qualifier, []);
    }

    if (this.providerSignatureOnFile[pyrBucket.partyKey] == null) {
      this.providerSignatureOnFile[pyrBucket.partyKey] = new IcecontrolSettings("icecheckbox", { width: "50px", cursor: 'pointer', label: "Provider Signature on File" }, null, null, "ProviderSignature" + pyrBucket.partyKey)
        .setControlName("ProviderSignature" + pyrBucket.partyKey)
        .createFormControl(cbucket.provider_signature_code == 'Y' ? true : false, []);
    }
    else {
      this.setDisabled(pyrBucket, <IcecontrolSettings>this.providerSignatureOnFile[pyrBucket.partyKey]);
    }

    if (this.patientAssignmentOfBenefits[pyrBucket.partyKey] == null) {
      this.patientAssignmentOfBenefits[pyrBucket.partyKey] = new IcecontrolSettings("iceselect", { menuItems: [], width: "100%" }, null, null, "PatientAssignmentOfBenefits" + pyrBucket.partyKey, "Patient Assignment Of Benefits")
        .setControlName("PatientAssignmentOfBenefits" + pyrBucket.partyKey)
        .createFormControl(cbucket.assignment_of_benefits_code == "" ? "N" : cbucket.assignment_of_benefits_code, [])
        .setOptions([
          { value: "N", name: "No" },
          { value: "Y", name: "Yes" },
          { value: "W", name: "Not Applicable (patient refuses to sign)" }
        ]);
    }
    else {
      this.setDisabled(pyrBucket, <IcecontrolSettings>this.patientAssignmentOfBenefits[pyrBucket.partyKey]);
    }

    if (this.providerAcceptAssignment[pyrBucket.partyKey] == null) {
      this.providerAcceptAssignment[pyrBucket.partyKey] = new IcecontrolSettings("iceselect", { menuItems: [], width: "100%" }, null, null, "ProviderAcceptAssignment" + pyrBucket.partyKey, "Provider Accepts Assignment")
        .setControlName("ProviderAcceptAssignment" + pyrBucket.partyKey)
        .createFormControl(cbucket.provider_accepts_assignment_code == "" ? "C" : cbucket.provider_accepts_assignment_code, [])
        .setOptions([
          { value: "A", name: "Assigned" },
          { value: "B", name: "Assignment Accepted on Clinical Lab Services Only" },
          { value: "C", name: "Not Assigned" }
        ]);
    }
    else {
      this.setDisabled(pyrBucket, <IcecontrolSettings>this.providerAcceptAssignment[pyrBucket.partyKey]);
    }

    if (this.releaseOfInformation[pyrBucket.partyKey] == null) {
      this.releaseOfInformation[pyrBucket.partyKey] = new IcecontrolSettings("iceselect", { menuItems: [], width: "100%" }, null, null, "ROI" + pyrBucket.partyKey, "Release of Information")
        .setControlName("ROI" + pyrBucket.partyKey)
        .createFormControl(cbucket.release_of_information_code, [])
        .setOptions(this.ROIOptions);
    }
    else {
      this.setDisabled(pyrBucket, <IcecontrolSettings>this.releaseOfInformation[pyrBucket.partyKey]);
    }

    if (this.patientSignatureSource[pyrBucket.partyKey] == null) {
      this.patientSignatureSource[pyrBucket.partyKey] = new IcecontrolSettings("iceselect", { menuItems: [], width: "100%" }, null, null, "PatientSignatureSource" + pyrBucket.partyKey, "Patient Signature Source")
        .setControlName("PatientSignatureSource" + pyrBucket.partyKey)
        .createFormControl(cbucket.patient_signature_code, [])
        .setOptions([
          { value: "", name: "N/A" },
          { value: "P", name: "Signature generated by provider" },
        ]);
    }
    else {
      this.setDisabled(pyrBucket, <IcecontrolSettings>this.patientSignatureSource[pyrBucket.partyKey]);
    }

    return ret;
  }

  updateSelectedClaimBucket(pyrBucket: payerbucket, cbucket: claimbucket): void {
    if (pyrBucket == null || cbucket == null) return;

    if (this.claimBucketStatus[pyrBucket.partyKey] != null) {
      let ctrl: IcecontrolSettings = this.claimBucketStatus[pyrBucket.partyKey];
      let thisStatus = Iceutility.toLong(cbucket.trans_status);
      ctrl.getFormControl().setValue(Iceutility.toLong(cbucket.trans_status));
      let theseOpts = this.getNextStatusStates(thisStatus, thisStatus);
      ctrl.setOptions(theseOpts);
    }

    if (this.claimInsuranceType[pyrBucket.partyKey] != null) {
      let ctrl: IcecontrolSettings = this.claimInsuranceType[pyrBucket.partyKey];
      ctrl.getFormControl().setValue(cbucket.insurance_type_code);
    }

    if (this.claimFilingIndicator[pyrBucket.partyKey] != null) {
      let ctrl: IcecontrolSettings = this.claimFilingIndicator[pyrBucket.partyKey];
      ctrl.getFormControl().setValue(cbucket.claim_filing_indicator_code);
    }

    if (this.claimEncounterType[pyrBucket.partyKey] != null) {
      let ctrl: IcecontrolSettings = this.claimEncounterType[pyrBucket.partyKey];
      ctrl.getFormControl().setValue(cbucket.claim_encounter_type);
    }

    if (this.claimPlaceOfService[pyrBucket.partyKey] != null) {
      let ctrl: IcecontrolSettings = this.claimPlaceOfService[pyrBucket.partyKey];
      ctrl.getFormControl().setValue(cbucket.place_of_service_code);
    }

    if (this.claimTotal[pyrBucket.partyKey] != null) {
      let ctrl: IcecontrolSettings = this.claimTotal[pyrBucket.partyKey];
      ctrl.getFormControl().setValue(this.getClaimTotal(pyrBucket));
    }

    if (this.facilityCode[pyrBucket.partyKey] != null) {
      let ctrl: IcecontrolSettings = this.facilityCode[pyrBucket.partyKey];
      ctrl.getFormControl().setValue(cbucket.facility_code_qualifier);
    }

    if (this.providerSignatureOnFile[pyrBucket.partyKey] != null) {
      let ctrl: IcecontrolSettings = this.providerSignatureOnFile[pyrBucket.partyKey];
      ctrl.getFormControl().setValue(cbucket.provider_signature_code == 'Y' ? true : false);
    }

    if (this.patientAssignmentOfBenefits[pyrBucket.partyKey] != null) {
      let ctrl: IcecontrolSettings = this.patientAssignmentOfBenefits[pyrBucket.partyKey];
      ctrl.getFormControl().setValue(cbucket.assignment_of_benefits_code == "" ? "N" : cbucket.assignment_of_benefits_code);
    }

    if (this.providerAcceptAssignment[pyrBucket.partyKey] != null) {
      let ctrl: IcecontrolSettings = this.providerAcceptAssignment[pyrBucket.partyKey];
      ctrl.getFormControl().setValue(cbucket.provider_accepts_assignment_code == "" ? "C" : cbucket.provider_accepts_assignment_code);
    }

    if (this.releaseOfInformation[pyrBucket.partyKey] != null) {
      let ctrl: IcecontrolSettings = this.releaseOfInformation[pyrBucket.partyKey];
      ctrl.getFormControl().setValue(cbucket.release_of_information_code);
    }

    if (this.patientSignatureSource[pyrBucket.partyKey] != null) {
      let ctrl: IcecontrolSettings = this.patientSignatureSource[pyrBucket.partyKey];
      ctrl.getFormControl().setValue(cbucket.patient_signature_code);
    }

    this.loadClaimOtherSubscriberListControl(pyrBucket);
    this.loadClaimProviderListControl(pyrBucket);
    this.loadClaimRelatedCausesListControl(pyrBucket);
    this.loadClaimDatesofEventsListControl(pyrBucket);
    this.loadClaimRemittanceDatesListControl(pyrBucket);
    this.loadClaimReferralAuthorizationListControl(pyrBucket);
    this.loadClaimReferenceIDListControl(pyrBucket);
    this.loadClaimAmountsListControl(pyrBucket);
    this.loadClaimAmbulanceTransportListControl(pyrBucket);
    this.loadClaimContractInformationListControl(pyrBucket);
    this.loadClaimAttachmentsListControl(pyrBucket);
    this.loadClaimNotesListControl(pyrBucket);

    this.loadClaimItems(pyrBucket);
  }

  setReadonly(pyrBucket: payerbucket, ctrl: IcecontrolSettings) {
    if (pyrBucket == null || ctrl == null) return;

    let cbucket = this.getSelectedClaimBucket(pyrBucket);
    if (this.isReadonlyStatus(Iceutility.toLong(cbucket.trans_status))) ctrl.setReadonly(true);
    else ctrl.setReadonly(false);
  }

  setDisabled(pyrBucket: payerbucket, ctrl: IcecontrolSettings) {
    if (pyrBucket == null || ctrl == null) return;

    let cbucket = this.getSelectedClaimBucket(pyrBucket);
    if (this.isReadonlyStatus(Iceutility.toLong(cbucket.trans_status))) ctrl.setDisabled(true);
    else ctrl.setDisabled(false);
  }

  getClaimOtherSubscriberListControl(pyrBucket: payerbucket): IcecontrolSettings {
    if (this.claimOtherSubscriberListCtrl[pyrBucket.partyKey] == null) {
      this.claimOtherSubscriberListCtrl[pyrBucket.partyKey]
        = new IcecontrolSettings("claimOtherSubscriber" + pyrBucket.partyKey, {}, null, null, "", "Other Subscriber")
          .setOptions([])
          .setActionItems([
            this.editAction, this.deleteAction
          ]);
    }
    else {
      this.setReadonly(pyrBucket, <IcecontrolSettings>this.claimOtherSubscriberListCtrl[pyrBucket.partyKey]);
    }
    return this.claimOtherSubscriberListCtrl[pyrBucket.partyKey];
  }

  loadClaimOtherSubscriberListControl(pyrBucket: payerbucket) {
    if (pyrBucket == null) return;
    let otherSubListCtrl: IcecontrolSettings = this.claimOtherSubscriberListCtrl[pyrBucket.partyKey];
    if (otherSubListCtrl == null) return;

    let cbucket = this.getSelectedClaimBucket(pyrBucket);
    if (cbucket != null) {
      let opts = [];
      for (let isub = 0; isub < cbucket.SUBS.length; isub++) {
        let subref = cbucket.SUBS[isub];
        let partyKey = AccountingService.getPartyBucketKeyEx(subref.subscriber_key, subref.coverage_key, subref.payer_key);
        let fndParty = this.responsibleParties.filter(r => r.value == partyKey);
        if (fndParty.length > 0) {
          opts.push(fndParty[0]);
        }
      }
      otherSubListCtrl.setOptions(opts);
    }
  }

  getClaimProviderListControl(pyrBucket: payerbucket): IcecontrolSettings {
    if (this.claimProviderListCtrl[pyrBucket.partyKey] == null) {
      this.claimProviderListCtrl[pyrBucket.partyKey]
        = new IcecontrolSettings("claimProvider" + pyrBucket.partyKey, {}, null, null, "", "Providers")
          .setOptions([])
          .setActionItems([
            this.editAction, this.deleteAction
          ]);
    }
    else {
      this.setReadonly(pyrBucket, <IcecontrolSettings>this.claimProviderListCtrl[pyrBucket.partyKey]);
    }

    return this.claimProviderListCtrl[pyrBucket.partyKey];
  }

  loadProvider(pro: provider_index, proRef: provider_reference): string {
    if (pro == null || proRef == null) return "";
    let name = pro.getdisplayname(false);
    let role = "";
    let proRole = this.proSvc.getProviderCodeList().filter(c => c.value == proRef.provider_code);
    if (proRole.length > 0) {
      role = " - " + proRole[0].name;
    }
    return name + role;
  }

  loadClaimProviderListControl(pyrBucket: payerbucket): void {
    if (pyrBucket == null) return ;
    let cbucket = this.getSelectedClaimBucket(pyrBucket);
    if (cbucket == null) return ;

    let proListCtrl: IcecontrolSettings = this.claimProviderListCtrl[pyrBucket.partyKey];
    if (proListCtrl == null) return;

    let opts = [];
    for (let ipro = 0; ipro < cbucket.PROS.length; ipro++) {
      let proref = cbucket.PROS[ipro];
      let fndPro = this.practiceProviders.filter(p => p.trans_account == proref.trans_account);
      if (fndPro.length > 0) {
        opts.push({ name: this.loadProvider(fndPro[0], proref), value: proref.provider_reference_key });
      }
    }
    proListCtrl.setOptions(opts);
  }

  getClaimRelatedCausesListControl(pyrBucket: payerbucket): IcecontrolSettings {
    if (this.claimRelatedCausesListCtrl[pyrBucket.partyKey] == null) {
      this.claimRelatedCausesListCtrl[pyrBucket.partyKey]
        = new IcecontrolSettings("claimRelatedCauses" + pyrBucket.partyKey, {}, null, null, "", "Related Causes")
          .setOptions([])
          .setActionItems([
            this.editAction, this.deleteAction
          ]);
    }
    else {
      this.setReadonly(pyrBucket, <IcecontrolSettings>this.claimRelatedCausesListCtrl[pyrBucket.partyKey]);
    }

    return this.claimRelatedCausesListCtrl[pyrBucket.partyKey];
  }

  loadClaimRelatedCausesListControl(pyrBucket: payerbucket): void {
    if (pyrBucket == null) return;
    let cbucket = this.getSelectedClaimBucket(pyrBucket);
    if (cbucket == null) return;

    let relCauseListCtrl: IcecontrolSettings = this.claimRelatedCausesListCtrl[pyrBucket.partyKey];
    if (relCauseListCtrl == null) return;

    let opts = [];
    for (let irelC = 0; irelC < cbucket.CAUSES.length; irelC++) {
      let relcau = cbucket.CAUSES[irelC];

      let desc = "";
      let fndRelCode = this.relatedCauseOptions.filter(c => c.value == relcau.related_cause_code);
      if (fndRelCode.length > 0) {
        desc = fndRelCode[0].name;
      }

      opts.push({ name: desc + " Country: " + relcau.country_id + " State: " + relcau.state_id, value: relcau.related_cause_key });
    }
    relCauseListCtrl.setOptions(opts);
  }

  getClaimDatesofEventsListControl(pyrBucket: payerbucket): IcecontrolSettings {
    if (this.claimDatesofEventsListCtrl[pyrBucket.partyKey] == null) {
      this.claimDatesofEventsListCtrl[pyrBucket.partyKey]
        = new IcecontrolSettings("claimDatesofEvents" + pyrBucket.partyKey, {}, null, null, "", "Dates of Events")
          .setOptions([])
          .setActionItems([
            this.editAction, this.deleteAction
          ]);
    }
    else {
      this.setReadonly(pyrBucket, <IcecontrolSettings>this.claimDatesofEventsListCtrl[pyrBucket.partyKey]);
    }

    return this.claimDatesofEventsListCtrl[pyrBucket.partyKey];
  }

  loadDatesofEvents(svcDt: servicedate): string {
    if (svcDt == null) return "";

    let desc = Iceutility.getDateTextEx(svcDt.date_required, null, false);
    if (svcDt.datetime_qualifier == "472" && svcDt.end_date_required) {
      desc += " - " + Iceutility.getDateTextEx(svcDt.end_date_required, null, false);
    }

    let fndDateCode = this.dateQualOptions.filter(c => c.value == svcDt.datetime_qualifier);
    if (fndDateCode.length > 0) {
      desc += " " + fndDateCode[0].name;
    }
    return desc;
  }

  loadClaimDatesofEventsListControl(pyrBucket: payerbucket): void {
    if (pyrBucket == null) return;
    let cbucket = this.getSelectedClaimBucket(pyrBucket);
    if (cbucket == null) return;

    let datesOfEvtsListCtrl: IcecontrolSettings = this.claimDatesofEventsListCtrl[pyrBucket.partyKey];
    if (datesOfEvtsListCtrl == null) return;

    let opts = [];
    for (let idtCode = 0; idtCode < cbucket.SVCDTS.length; idtCode++) {
      let dtCode = cbucket.SVCDTS[idtCode];
      if (dtCode.datetime_qualifier == "573") continue;

      let desc = this.loadDatesofEvents(dtCode);
      opts.push({ name: desc, value: dtCode.service_date_key });
    }
    datesOfEvtsListCtrl.setOptions(opts);
  }

  getClaimRemittanceDatesListControl(pyrBucket: payerbucket): IcecontrolSettings {
    if (this.claimRemittanceDatesListCtrl[pyrBucket.partyKey] == null) {
      this.claimRemittanceDatesListCtrl[pyrBucket.partyKey]
        = new IcecontrolSettings("claimRemittanceDates" + pyrBucket.partyKey, {}, null, null, "", "Remittance Dates")
          .setOptions([])
          .setActionItems([
            this.editAction, this.deleteAction
          ]);
    }
    else {
      this.setReadonly(pyrBucket, <IcecontrolSettings>this.claimRemittanceDatesListCtrl[pyrBucket.partyKey]);
    }

    return this.claimRemittanceDatesListCtrl[pyrBucket.partyKey];
  }

  loadClaimRemittanceDatesListControl(pyrBucket: payerbucket): void {
    if (pyrBucket == null) return;
    let cbucket = this.getSelectedClaimBucket(pyrBucket);
    if (cbucket == null) return;

    let remitDatesListCtrl: IcecontrolSettings = this.claimRemittanceDatesListCtrl[pyrBucket.partyKey];
    if (remitDatesListCtrl == null) return;

    let opts = [];
    for (let idtCode = 0; idtCode < cbucket.SVCDTS.length; idtCode++) {
      let dtCode = cbucket.SVCDTS[idtCode];
      if (dtCode.datetime_qualifier != "573") continue;

      let desc = Iceutility.getDateTextEx(dtCode.date_required, null, false);
      let fndDateCode = this.dateQualOptions.filter(c => c.value == dtCode.datetime_qualifier);
      if (fndDateCode.length > 0) {
        desc += " " + fndDateCode[0].name;
      }

      opts.push({ name: desc, value: dtCode.service_date_key });
    }
    remitDatesListCtrl.setOptions(opts);
  }

  getClaimReferralAuthorizationListControl(pyrBucket: payerbucket): IcecontrolSettings {
    if (this.claimReferralAuthorizationListCtrl[pyrBucket.partyKey] == null) {
      this.claimReferralAuthorizationListCtrl[pyrBucket.partyKey]
        = new IcecontrolSettings("claimReferralAuthorization" + pyrBucket.partyKey, {}, null, null, "", "Authorizations")
          .setOptions([])
          .setActionItems([
            this.editAction, this.deleteAction
          ]);
    }
    else {
      this.setReadonly(pyrBucket, <IcecontrolSettings>this.claimReferralAuthorizationListCtrl[pyrBucket.partyKey]);
    }

    return this.claimReferralAuthorizationListCtrl[pyrBucket.partyKey];
  }

  loadReferralAuthorization(reflRef: referralreference, refl: referral): string {
    if (reflRef == null || refl == null) return "";
    let desc = "Auth: " + refl.hcr_review_identification_number;
    return desc;
  }

  loadClaimReferralAuthorizationListControl(pyrBucket: payerbucket): void {
    if (pyrBucket == null) return;
    let cbucket = this.getSelectedClaimBucket(pyrBucket);
    if (cbucket == null) return;

    let referralAuthorizationListCtrl: IcecontrolSettings = this.claimReferralAuthorizationListCtrl[pyrBucket.partyKey];
    if (referralAuthorizationListCtrl == null) return;

    let opts = [];
    for (let ireflRef = 0; ireflRef < cbucket.REFLREFS.length; ireflRef++) {
      let reflRef = cbucket.REFLREFS[ireflRef];

      let fndRefl = this.allReferrals.filter(r => r.referral_key == reflRef.referral_key);
      if (fndRefl.length > 0) {
        let desc = this.loadReferralAuthorization(reflRef, fndRefl[0]);
        opts.push({ name: desc, value: reflRef.referral_reference_key });
      }
    }
    referralAuthorizationListCtrl.setOptions(opts);
  }

  getClaimReferenceIDListControl(pyrBucket: payerbucket): IcecontrolSettings {
    if (this.claimReferenceIDListCtrl[pyrBucket.partyKey] == null) {
      this.claimReferenceIDListCtrl[pyrBucket.partyKey]
        = new IcecontrolSettings("claimReference" + pyrBucket.partyKey, {}, null, null, "", "Other References")
          .setOptions([])
          .setActionItems([
            this.editAction, this.deleteAction
          ]);
    }
    else {
      this.setReadonly(pyrBucket, <IcecontrolSettings>this.claimReferenceIDListCtrl[pyrBucket.partyKey]);
    }

    return this.claimReferenceIDListCtrl[pyrBucket.partyKey];
  }

  loadReferenceID(refid: referenceidentification): string {
    if (refid == null) return "";

    let desc = "";
    switch (refid.reference_identification_qualifier) {
      case "F5": {
        let fndMedOpts = this.claimMandatoryMedicareSectionCrossoverIndicatorOptions.filter(c => c.value == refid.reference_identification_code);
        if (fndMedOpts.length > 0) {
          desc = fndMedOpts[0].value + " - " + fndMedOpts[0].name;
        }
        else {
          desc = refid.reference_identification_code;
        }
        break;
      }
      case "4N": {
        let fndExpOpts = this.claimServiceAuthorizationExceptionCodeOptions.filter(c => c.value == refid.reference_identification_code);
        if (fndExpOpts.length > 0) {
          desc = fndExpOpts[0].value + " - " + fndExpOpts[0].name;
        }
        else {
          desc = refid.reference_identification_code;
        }
        break;
      }
      default: {
        desc = refid.reference_identification_code;
        break;
      }
    }

    let fndRefOpts = this.claimOtherReferenceOptions.filter(c => c.value == refid.reference_identification_qualifier);
    if (fndRefOpts.length > 0) {
      desc = "ID: " + fndRefOpts[0].name + " (" + fndRefOpts[0].value + "), " + desc;
    }
    else {
      desc = "ID: " + refid.reference_identification_qualifier + ": " + desc;
    }
    return desc;
  }

  loadClaimReferenceIDListControl(pyrBucket: payerbucket): void {
    if (pyrBucket == null) return;
    let cbucket = this.getSelectedClaimBucket(pyrBucket);
    if (cbucket == null) return;

    let refIDListCtrl: IcecontrolSettings = this.claimReferenceIDListCtrl[pyrBucket.partyKey];
    if (refIDListCtrl == null) return;

    let opts = [];
    for (let irefID = 0; irefID < cbucket.REFIDS.length; irefID++) {
      let refid = cbucket.REFIDS[irefID];

      let desc = this.loadReferenceID(refid);
      opts.push({ name: desc, value: refid.reference_identification_key });
    }
    refIDListCtrl.setOptions(opts);
  }

  getClaimAmountsListControl(pyrBucket: payerbucket): IcecontrolSettings {
    if (this.claimAmountsListCtrl[pyrBucket.partyKey] == null) {
      this.claimAmountsListCtrl[pyrBucket.partyKey]
        = new IcecontrolSettings("claimAmount" + pyrBucket.partyKey, {}, null, null, "", "COB Amounts")
          .setOptions([])
          .setActionItems([
            this.editAction, this.deleteAction
          ]);
    }
    else {
      this.setReadonly(pyrBucket, <IcecontrolSettings>this.claimAmountsListCtrl[pyrBucket.partyKey]);
    }

    return this.claimAmountsListCtrl[pyrBucket.partyKey];
  }

  loadAmounts(clm: claim, amt: amount): string {
    if (amt == null) return "";
    let desc = "";
    let fndAmtOpts = clm == null ? this.claimAmounts.filter(c => c.value == amt.amount_qualifier)
      : this.itemAmounts.filter(c => c.value == amt.amount_qualifier);
    if (fndAmtOpts.length > 0) {
      desc = fndAmtOpts[0].name + " (" + fndAmtOpts[0].value + "), " + Iceutility.toCurrency(amt.amount_value);
    }
    else {
      desc = amt.amount_qualifier + ": " + Iceutility.toCurrency(amt.amount_value);
    }
    return desc;
  }

  loadClaimAmountsListControl(pyrBucket: payerbucket): void {
    if (pyrBucket == null) return;
    let cbucket = this.getSelectedClaimBucket(pyrBucket);
    if (cbucket == null) return;

    let amtListCtrl: IcecontrolSettings = this.claimAmountsListCtrl[pyrBucket.partyKey];
    if (amtListCtrl == null) return;

    let opts = [];
    for (let iamt = 0; iamt < cbucket.COBS.length; iamt++) {
      let amt = cbucket.COBS[iamt];

      let desc = this.loadAmounts(null, amt);
      opts.push({ name: desc, value: amt.amount_key });
    }
    amtListCtrl.setOptions(opts);
  }

  getClaimAmbulanceTransportListControl(pyrBucket: payerbucket): IcecontrolSettings {
    if (this.claimAmbulanceTransportListCtrl[pyrBucket.partyKey] == null) {
      this.claimAmbulanceTransportListCtrl[pyrBucket.partyKey]
        = new IcecontrolSettings("claimAmbulanceTransport" + pyrBucket.partyKey, {}, null, null, "", "Ambulance Transport")
          .setOptions([])
          .setActionItems([
            this.editAction, this.deleteAction
          ]);
    }
    else {
      this.setReadonly(pyrBucket, <IcecontrolSettings>this.claimAmbulanceTransportListCtrl[pyrBucket.partyKey]);
    }

    return this.claimAmbulanceTransportListCtrl[pyrBucket.partyKey];
  }

  loadClaimAmbulanceTransportListControl(pyrBucket: payerbucket): void {
    if (pyrBucket == null) return;
    let cbucket = this.getSelectedClaimBucket(pyrBucket);
    if (cbucket == null) return;

    let ambListCtrl: IcecontrolSettings = this.claimAmbulanceTransportListCtrl[pyrBucket.partyKey];
    if (ambListCtrl == null) return;

    let opts = [];
    for (let iamb = 0; iamb < cbucket.AMBS.length; iamb++) {
      let amb = cbucket.AMBS[iamb];

      let desc = "";
      let fndAmbCodeOpts = this.transportReasonOptions.filter(c => c.value == amb.ambulance_transport_reason_code);
      if (fndAmbCodeOpts.length > 0) {
        desc = fndAmbCodeOpts[0].name;
      }
      else {
        desc = amb.ambulance_transport_reason_code + ": ";
      }

      let fAds = amb.ADS.filter(a => a.address_key == amb.pickup_address_key);
      if (fAds.length > 0) {
        let adrText = fAds[0].street1 + " " + fAds[0].street2 + " " + fAds[0].city + ", " + fAds[0].state_id + " " + fAds[0].postal_code;
        if (fAds[0].country_id.length > 0)
          adrText += ", " + fAds[0].country_id;

        desc += ", Pickup: " + adrText;
      }

      fAds = amb.ADS.filter(a => a.address_key == amb.dropoff_address_key);
      if (fAds.length > 0) {
        let adrText = fAds[0].street1 + " " + fAds[0].street2 + " " + fAds[0].city + ", " + fAds[0].state_id + " " + fAds[0].postal_code;
        if (fAds[0].country_id.length > 0)
          adrText += ", " + fAds[0].country_id;

        desc += ", Dropoff: " + adrText;
      }

      opts.push({ name: desc, value: amb.claim_ambulance_key });
    }
    ambListCtrl.setOptions(opts);
  }

  getClaimContractInformationListControl(pyrBucket: payerbucket): IcecontrolSettings {
    if (this.claimContractInformationListCtrl[pyrBucket.partyKey] == null) {
      this.claimContractInformationListCtrl[pyrBucket.partyKey]
        = new IcecontrolSettings("claimContractInformation" + pyrBucket.partyKey, {}, null, null, "", "Contract Information")
          .setOptions([])
          .setActionItems([
            this.editAction, this.deleteAction
          ]);
    }
    else {
      this.setReadonly(pyrBucket, <IcecontrolSettings>this.claimContractInformationListCtrl[pyrBucket.partyKey]);
    }

    return this.claimContractInformationListCtrl[pyrBucket.partyKey];
  }

  loadClaimContractInformationListControl(pyrBucket: payerbucket): void {
    if (pyrBucket == null) return;
    let cbucket = this.getSelectedClaimBucket(pyrBucket);
    if (cbucket == null) return;

    let contcListCtrl: IcecontrolSettings = this.claimContractInformationListCtrl[pyrBucket.partyKey];
    if (contcListCtrl == null) return;

    let opts = [];
    for (let iconTC = 0; iconTC < cbucket.CNTRCS.length; iconTC++) {
      let contc = cbucket.CNTRCS[iconTC];

      let desc = "";
      let fndCodeOpts = this.contractTypeCodeOptions.filter(c => c.value == contc.contract_type_code);
      if (fndCodeOpts.length > 0) {
        desc = fndCodeOpts[0].name;
      }
      else {
        desc = contc.contract_type_code + ": ";
      }

      if (contc.contract_type_code == "06") {
        desc += " " + contc.percentage.toString() + "%";
      }
      else {
        desc += " " + Iceutility.toCurrency(contc.price).toString();
      }
      opts.push({ name: desc, value: contc.claim_contract_key });
    }
    contcListCtrl.setOptions(opts);
  }

  getClaimAttachmentsListControl(pyrBucket: payerbucket): IcecontrolSettings {
    if (this.claimAttachmentsListCtrl[pyrBucket.partyKey] == null) {
      this.claimAttachmentsListCtrl[pyrBucket.partyKey]
        = new IcecontrolSettings("claimAttachments" + pyrBucket.partyKey, {}, null, null, "", "Supplemental Attachments")
          .setOptions([])
          .setActionItems([
            this.editAction, this.deleteAction
          ]);
    }
    else {
      let cbucket = this.getSelectedClaimBucket(pyrBucket);
      let ctrl: IcecontrolSettings = this.claimAttachmentsListCtrl[pyrBucket.partyKey];
      if (cbucket != null && cbucket.SUPPL.length > 0 && ctrl.getOptions().length != cbucket.SUPPL.length && this.allAttachments.length > 0)
        this.loadClaimAttachmentsListControl(pyrBucket);

      this.setReadonly(pyrBucket, ctrl);
    }

    return this.claimAttachmentsListCtrl[pyrBucket.partyKey];
  }

  loadAttachments(pyrBucket: payerbucket, suppInfo: claimsupplementalinformation): any {
    if (pyrBucket == null) return null;
    let cbucket = this.getSelectedClaimBucket(pyrBucket);
    if (cbucket == null || suppInfo == null) return null;

    let attchListCtrl: IcecontrolSettings = this.claimAttachmentsListCtrl[pyrBucket.partyKey];
    if (attchListCtrl == null) return null;

    let opt = null;
    let desc = "";
    if (suppInfo.external_data_key.length > 0) {
      let fndExtData = this.allAttachments.filter(e => e.external_data_key == suppInfo.external_data_key);
      if (fndExtData.length > 0) {
        desc = Iceutility.getDateTextEx(fndExtData[0].external_reference_date, null, true) + " Document: " + AccountingService.getSourceType(Iceutility.toLong(fndExtData[0].src_type)) + " " + fndExtData[0].title;
        opt = { name: desc, value: suppInfo.claim_supplemental_information_key };
      }
    }
    else if (suppInfo.encounter_progress_notes_key.length > 0) {
      let fndNote = this.allNotes.filter(n => n.encounter_progress_notes_key == suppInfo.encounter_progress_notes_key);
      if (fndNote.length > 0) {
        desc = Iceutility.getDateTextEx(fndNote[0].note_date, null, true) + " Notes: " + AccountingService.getSourceType(Iceutility.toLong(fndNote[0].src_type)) + ", " + fndNote[0].plain_text.substr(0, 30) + "...";
        opt = { name: desc, value: suppInfo.claim_supplemental_information_key };
      }
    }
    else if (suppInfo.observation_key.length > 0 && suppInfo.diagnosis_key.length > 0) {
      let fndDiag = this.allDiagnoses.filter(d => d.diagnosis_key == suppInfo.diagnosis_key);
      if (fndDiag.length > 0) {
        let fndOb = fndDiag[0].OBSERVS.filter(o => o.observation_key == suppInfo.observation_key);
        if (fndOb.length > 0) {
          let ob: observation = fndOb[0];
          desc = Iceutility.getDateTextEx(ob.observation_date, null, false)
            + " Observation: " + PatientService.getObservationType(ob.observation_type)
            + ", " + PatientService.getSeverityType(ob.severity_type)
            + ", " + ob.description.substr(0, 30) + "...";
          opt = { name: desc, value: suppInfo.claim_supplemental_information_key };
        }
      }
    }
    return opt;
  }

  loadClaimAttachmentsListControl(pyrBucket: payerbucket): void {
    if (pyrBucket == null) return;
    let cbucket = this.getSelectedClaimBucket(pyrBucket);
    if (cbucket == null) return;

    let attchListCtrl: IcecontrolSettings = this.claimAttachmentsListCtrl[pyrBucket.partyKey];
    if (attchListCtrl == null) return;

    let opts = [];
    for (let iattch = 0; iattch < cbucket.SUPPL.length; iattch++) {
      let suppInfo = cbucket.SUPPL[iattch];

      let opt = this.loadAttachments(pyrBucket, suppInfo);
      if (opt != null) {
        opts.push(opt);
      }
    }
    attchListCtrl.setOptions(opts);
  }

  getClaimNotesListControl(pyrBucket: payerbucket): IcecontrolSettings {
    if (this.claimNotesListCtrl[pyrBucket.partyKey] == null) {
      this.claimNotesListCtrl[pyrBucket.partyKey]
        = new IcecontrolSettings("claimNotes" + pyrBucket.partyKey, {}, null, null, "", "Claim Notes")
          .setOptions([])
          .setActionItems([
            this.editAction, this.deleteAction
          ]);
    }
    else {
      this.setReadonly(pyrBucket, <IcecontrolSettings>this.claimNotesListCtrl[pyrBucket.partyKey]);
    }

    return this.claimNotesListCtrl[pyrBucket.partyKey];
  }

  loadClaimNotesListControl(pyrBucket: payerbucket): void {
    if (pyrBucket == null) return;
    let cbucket = this.getSelectedClaimBucket(pyrBucket);
    if (cbucket == null) return;

    let noteListCtrl: IcecontrolSettings = this.claimNotesListCtrl[pyrBucket.partyKey];
    if (noteListCtrl == null) return;

    let opts = [];
    for (let iattch = 0; iattch < cbucket.CLMNOTES.length; iattch++) {
      let clmnte = cbucket.CLMNOTES[iattch];

      let desc = clmnte.description.substr(0, 80) + "...";

      opts.push({ name: desc, value: clmnte.claim_note_key });
    }
    noteListCtrl.setOptions(opts);
  }

  isLastDraftMessage(pyrBucket: payerbucket): boolean {
    if (pyrBucket == null) return false;
    let cbucket = this.getSelectedClaimBucket(pyrBucket);
    if (cbucket == null || cbucket.draft_message_key.length == 0) return false;
    return true;
  }

  getLastDraftMessage(pyrBucket: payerbucket): string {
    let ret = "";
    let cbucket = this.getSelectedClaimBucket(pyrBucket);
    if (cbucket == null || cbucket.draft_message_key.length == 0) return "";

    ret = "Last Clean attempt on: " + cbucket.draft_message_date + " - " + MessageService.getStatus(Iceutility.toLong(cbucket.draft_message_status), IceTypes.SourceType.srcStatement) + " - " + cbucket.draft_message_log;
    return ret;
  }

  isProcessingStatus(pyrBucket: payerbucket): boolean {
    if (pyrBucket == null) return false;
    let cbucket = this.getSelectedClaimBucket(pyrBucket);
    if (cbucket == null) return false;

    let processStatuses = [
      IceTypes.trans_status.isReadyToSend,
      IceTypes.trans_status.isModified,
      IceTypes.trans_status.isPending,
      IceTypes.trans_status.isProcessing,
    ];

    let fndStat = processStatuses.filter(status => status == cbucket.trans_status);
    return fndStat.length > 0 ? true : false;
  }

  isReadonlyStatus(status: IceTypes.trans_status): boolean {
    let roStatuses = [
      IceTypes.trans_status.isReadyToSend,
      IceTypes.trans_status.isReadyToPrint,
      IceTypes.trans_status.isScrubbed,
      IceTypes.trans_status.isSent,
      IceTypes.trans_status.isPaid,
      IceTypes.trans_status.isRejected,
      IceTypes.trans_status.isDenied,
      IceTypes.trans_status.isAccepted,
      IceTypes.trans_status.isReceived,
      IceTypes.trans_status.isStatusReceived
    ];

    let fndStat = roStatuses.filter(s => s == status);
    return fndStat.length > 0 ? true : false;
  }

  getNextStatusStates(basedOnThis: IceTypes.trans_status, includeThisOne: IceTypes.trans_status): any[] {
    let ret = [];
    switch (basedOnThis) {
      case IceTypes.trans_status.isNone:
        ret = this.allRelatedStatus.filter(s =>
          s.value == IceTypes.trans_status.isReadyToSend
          || s.value == IceTypes.trans_status.isReadyToPrint
          || s.value == IceTypes.trans_status.isTentative
          || s.value == IceTypes.trans_status.isError
          || s.value == IceTypes.trans_status.isScrubbed
        );
        break;
      case IceTypes.trans_status.isReadyToSend:
        ret = this.allRelatedStatus.filter(s =>
          s.value == IceTypes.trans_status.isNone
        );
        break;
      case IceTypes.trans_status.isReadyToPrint:
        ret = this.allRelatedStatus.filter(s =>
          s.value == IceTypes.trans_status.isNone
          || s.value == IceTypes.trans_status.isReadyToSend
        );
        break;
      case IceTypes.trans_status.isError:
      case IceTypes.trans_status.isScrubbed:
        ret = this.allRelatedStatus.filter(s =>
          s.value == IceTypes.trans_status.isNone
          || s.value == IceTypes.trans_status.isReadyToSend
          || s.value == IceTypes.trans_status.isReadyToPrint
        );
        break;
      case IceTypes.trans_status.isTentative:
        ret = this.allRelatedStatus.filter(s =>
          s.value == IceTypes.trans_status.isNone
          || s.value == IceTypes.trans_status.isReadyToSend
          || s.value == IceTypes.trans_status.isReadyToPrint
        );
        break;
      case IceTypes.trans_status.isModified:
      case IceTypes.trans_status.isPending:
      case IceTypes.trans_status.isProcessing:
        ret = this.allRelatedStatus.filter(s =>
          s.value == IceTypes.trans_status.isError
        );
        break;
      case IceTypes.trans_status.isSent:
      case IceTypes.trans_status.isStatusReceived:
        ret = this.allRelatedStatus.filter(s =>
          s.value == IceTypes.trans_status.isAccepted
          || s.value == IceTypes.trans_status.isError
          || s.value == IceTypes.trans_status.isReceived
          || s.value == IceTypes.trans_status.isPaid
          || s.value == IceTypes.trans_status.isDenied
          || s.value == IceTypes.trans_status.isRejected
          || s.value == IceTypes.trans_status.isScrubbed
        );
        break;
    }

    let fndInc = ret.filter(s => s.value == includeThisOne);
    if (fndInc.length == 0) {
      fndInc = this.allRelatedStatus.filter(s => s.value == includeThisOne);
      if (fndInc.length > 0)
        ret = ret.concat(fndInc);
    }

    return ret;
  }

  getProcessingPercentageComplete(pyrBucket: payerbucket): string {
    if (pyrBucket == null) return "0";
    let cbucket = this.getSelectedClaimBucket(pyrBucket);
    if (cbucket == null) return "0";

    let procentComplete = {};
    procentComplete[IceTypes.trans_status.isReadyToSend] = 20;
    procentComplete[IceTypes.trans_status.isModified] = 40;
    procentComplete[IceTypes.trans_status.isPending] = 60;
    procentComplete[IceTypes.trans_status.isProcessing] = 80;
    procentComplete[IceTypes.trans_status.isScrubbed] = 100;
    let ret = procentComplete[Iceutility.toLong(cbucket.trans_status)];
    if (ret == null) ret = 0;
    return ret.toString();
  }

  showItem(pyrBucket: payerbucket, clm: claim): boolean {
    let ret = true;

    if (this.isNewServiceItem(pyrBucket, clm)) // this is a new service
      return false;

    return ret;
  }

  isNewServiceItem(pyrBucket: payerbucket, clm: claim): boolean {
    return clm.gettablename() == "MEDICAL_SERVICE";
  }

  loadOneItem(dom: string, domType: IceTypes.ACCOUNT_TYPE, pyrBucket: payerbucket, clm: claim) {
    if (pyrBucket == null || clm == null) return;

    this.loadItemDatesofEventsListControl(pyrBucket, clm);
    this.loadItemReferralAuthorizationListControl(pyrBucket, clm);
    this.loadItemReferenceIDListControl(pyrBucket, clm);
    this.loadItemAmountsListControl(pyrBucket, clm);
    this.loadItemProviderListControl(pyrBucket, clm);
    this.loadItemAttachmentsListControl(pyrBucket, clm);
    this.loadItemNotesListControl(pyrBucket, clm);

    let svcHistData = this.chargeHistory.getService(clm.medical_service_key);
    if (svcHistData == null) {
      this.chargeHistory.setService(clm.medical_service_key, {});
      this.chargeHistory.setServiceAmountDue(clm.medical_service_key, Iceutility.toDouble(clm.total_amount));
    }
    this.initializePanelSync(clm);

    if (svcHistData == null) { // only load this once
      this.acctSvc.getJournal(dom, domType, "", "", IceTypes.JournalType.jtAsset, IceTypes.coa_types.coaAsset, clm.medical_service_key, IceTypes.coa_types.coaDeductibleAR).subscribe(
        data => {
          if (data != null) {
            let credits = AccountingService.updateChargeHistoryPostingData(this.acctSvc, dom, domType,
              this.chargeHistory, clm, data);
            let amountDue = Iceutility.toDouble(clm.total_amount) - credits;
            this.chargeHistory.setServiceAmountDue(clm.medical_service_key, amountDue);
          }
        },
        error => {
          console.log(error);
        });

      this.acctSvc.getJournal(dom, domType, "", "", IceTypes.JournalType.jtExpense, IceTypes.coa_types.coaDiscount, clm.medical_service_key, IceTypes.coa_types.coaCorrectionandReversalsAdjustment).subscribe(
        data => {
          if (data != null) {
            this.chargeHistory.setServiceExpenses(clm.medical_service_key, data);
          }
        },
        error => {
          console.log(error);
        });

      this.acctSvc.getClaims(dom, domType, this.serviceCharges.to_trans_account, this.serviceCharges.to_account_type, "", "", "", "", -1, clm.medical_service_key).subscribe(
        data => {
          if (data == null || data.length == 0) {
            return;
          }
          this.chargeHistory.setClaims(clm.medical_service_key, data);
        }, error => {
          console.log(JSON.stringify(this.acctSvc.getLastErrors()));
        });
    }
  }

  loadClaimItems(pyrBucket: payerbucket): void {
    if (pyrBucket == null) return;
    let cbucket = this.getSelectedClaimBucket(pyrBucket);
    if (cbucket == null) return;

    let dom = this.appSvc.getCurrentAccount();
    let domType = this.appSvc.getCurrentAccountType();
    // Separate the CLMS by medical_service_key then select default to be editing, ready, or latest
    for (let idata = 0; idata < pyrBucket.data.length; idata++) {
      let clmdata = pyrBucket.data[idata];
      // set history data 
      clmdata.history = cbucket.CLMS.filter(c => c.medical_service_key == clmdata.service.medical_service_key);

      // set history data into DDL
      let cbCtrl: IcecontrolSettings = this.itemControl[clmdata.service.medical_service_key];
      if (cbCtrl != null) {
        let clmReadyDefault: claim = null, clmEditingDefault: claim = null, clmLastDefault: claim = null;
        let opts = [];
        for (let iclm = 0; iclm < clmdata.history.length; iclm++) {
          let clm = clmdata.history[iclm];

          if (clm.trans_status == IceTypes.trans_status.isReadyToSend)
            clmReadyDefault = clm;
          else if (clm.trans_status == IceTypes.trans_status.isNone)
            clmEditingDefault = clm;

          clmLastDefault = clm;
          opts.push({ name: this.getClaimDDLTitle(clm.claim_date, Iceutility.toLong(clm.trans_status)), value: clm.claim_key });
        }
        cbCtrl.setOptions(opts);

        if (clmEditingDefault != null) {
          clmdata.claim = clmEditingDefault;
          cbCtrl.getFormControl().setValue(clmEditingDefault.claim_key);
        }
        else if (clmReadyDefault != null) {
          clmdata.claim = clmReadyDefault;
          cbCtrl.getFormControl().setValue(clmReadyDefault.claim_key);
        }
        else if (clmLastDefault != null) {
          clmdata.claim = clmLastDefault;
          cbCtrl.getFormControl().setValue(clmLastDefault.claim_key);
        }
      }

      // load item with default
      if (clmdata.claim != null) {
        this.loadOneItem(dom, domType, pyrBucket, clmdata.claim);
      }
    }
  }

  isItemExpanded(clm: claim): boolean {
    if (clm == null) return false;
    return this.itemExpanded[clm.medical_service_key] == null ? false : this.itemExpanded[clm.medical_service_key];
  }

  updateSelectedClaim(pyrBucket: payerbucket, selectedServiceKey: string, selectedClaimKey: string): void {
    if (pyrBucket == null || selectedServiceKey == null || selectedServiceKey.length == 0 || selectedClaimKey == null || selectedClaimKey.length == 0) return;

    let cbucket = this.getSelectedClaimBucket(pyrBucket);
    if (cbucket == null) return;

    let foundClmData = pyrBucket.data.filter(cd => cd.service != null && cd.service.medical_service_key == selectedServiceKey);
    if (foundClmData.length > 0) {
      let fndSelectedClm = cbucket.CLMS.filter(c => selectedClaimKey == c.claim_key);
      if (fndSelectedClm.length > 0) {
        foundClmData[0].claim = fndSelectedClm[0];
        let dom = this.appSvc.getCurrentAccount();
        let domType = this.appSvc.getCurrentAccountType();

        let ctrl: IcecontrolSettings = this.itemStatusButtonCtrl[fndSelectedClm[0].medical_service_key];
        let status: IceTypes.trans_status = Iceutility.toLong(fndSelectedClm[0].trans_status);
        if (status != IceTypes.trans_status.isReadyToSend && status != IceTypes.trans_status.isReadyToPrint) {
          ctrl.properties.lastOffStatus = status;
          ctrl.properties.offDisplayValue = MessageService.getStatus(status, IceTypes.SourceType.srcStatement);
        }

        this.loadOneItem(dom, domType, pyrBucket, fndSelectedClm[0]);
      }
    }
  }

  getItemService(pyrBucket: payerbucket, clm: claim): medicalservice {
    if (pyrBucket == null || pyrBucket.data == null || clm == null) return null;
    let svcFound = pyrBucket.data.filter(d => d.service.medical_service_key == clm.medical_service_key);
    if (svcFound.length > 0) {
      return svcFound[0].service;
    }

    return null;
  }

  getItemStatusButton(pyrBucket: payerbucket, clm: claim, itemNum: number): IcecontrolSettings {
    if (clm == null) return;

    if (this.itemStatusButtonCtrl[clm.medical_service_key] == null) {
      let status: IceTypes.trans_status = Iceutility.toLong(clm.trans_status);
      let statusText = "Draft";
      if (status != IceTypes.trans_status.isReadyToSend && status != IceTypes.trans_status.isReadyToPrint) {
        statusText = MessageService.getStatus(status, IceTypes.SourceType.srcStatement);
      }
      // To do store lastStatus in .properties.lastOffStatus = status
      this.itemStatusButtonCtrl[clm.medical_service_key]
        = new IcecontrolSettings("itemStatus" + clm.medical_service_key,
          { placeholder: "Claim Item: " + itemNum.toString() + " Status: ", onDisplayValue: "Ready", offDisplayValue: statusText, width: "75px", lastOffStatus: status },
          null, null, "itemStatus" + clm.medical_service_key)
          .setControlName("itemStatus" + clm.medical_service_key)
          .createFormControl(status == IceTypes.trans_status.isReadyToSend || status == IceTypes.trans_status.isReadyToPrint, [Validators.required]);
    }
    else {
      let ctrl: IcecontrolSettings = this.itemStatusButtonCtrl[clm.medical_service_key];
      let status: IceTypes.trans_status = Iceutility.toLong(clm.trans_status);
      if (status != IceTypes.trans_status.isReadyToSend && status != IceTypes.trans_status.isReadyToPrint) {
        status = ctrl.properties.lastOffStatus;
        ctrl.properties.offDisplayValue = MessageService.getStatus(status, IceTypes.SourceType.srcStatement);
      }

      ctrl.getFormControl().setValue(status == IceTypes.trans_status.isReadyToSend || status == IceTypes.trans_status.isReadyToPrint);
    }

    // Also create item select here
    if (this.itemControl[clm.medical_service_key] == null) {
      this.itemControl[clm.medical_service_key] = new IcecontrolSettings("iceselect", { menuItems: [], width: "100%" }, null, null, "ItemControl" + clm.medical_service_key, "Claim Item")
        .setControlName("ItemControl" + clm.medical_service_key)
        .createFormControl("", []);
    }
    return this.itemStatusButtonCtrl[clm.medical_service_key];
  }

  getItemDatesofEventsListControl(pyrBucket: payerbucket, clm: claim): IcecontrolSettings {
    if (clm == null) return;

    if (this.itemDatesofEventsListCtrl[clm.claim_key] == null) {
      this.itemDatesofEventsListCtrl[clm.claim_key]
        = new IcecontrolSettings("itemDatesofEvents" + clm.claim_key, {}, null, null, "", "Dates of Events")
          .setOptions([])
          .setActionItems([
            this.editAction, this.deleteAction
          ]);
      this.loadItemDatesofEventsListControl(pyrBucket, clm);
    }
    else {
      this.setReadonly(pyrBucket, <IcecontrolSettings>this.itemDatesofEventsListCtrl[clm.claim_key]);
    }

    return this.itemDatesofEventsListCtrl[clm.claim_key];
  }

  loadItemDatesofEventsListControl(pyrBucket: payerbucket, clm: claim): void {
    if (pyrBucket == null) return;
    if (clm == null) return;

    let cbucket = this.getSelectedClaimBucket(pyrBucket);
    if (cbucket == null) return;

    let datesOfEvtsListCtrl: IcecontrolSettings = this.itemDatesofEventsListCtrl[clm.claim_key];
    if (datesOfEvtsListCtrl == null) return;

    let opts = [];
    for (let idtCode = 0; idtCode < clm.SVCDTS.length; idtCode++) {
      let dtCode = clm.SVCDTS[idtCode];
      if (dtCode.datetime_qualifier == "573") continue;

      let desc = this.loadDatesofEvents(dtCode);
      opts.push({ name: desc, value: dtCode.service_date_key });
    }
    datesOfEvtsListCtrl.setOptions(opts);
  }

  getItemReferralAuthorizationListControl(pyrBucket: payerbucket, clm: claim): IcecontrolSettings {
    if (clm == null) return;

    if (this.itemReferralAuthorizationListCtrl[clm.claim_key] == null) {
      this.itemReferralAuthorizationListCtrl[clm.claim_key]
        = new IcecontrolSettings("itemReferralAuthorization" + clm.claim_key, {}, null, null, "", "Authorizations")
          .setOptions([])
          .setActionItems([
            this.editAction, this.deleteAction
          ]);
    }
    else {
      let cbucket = this.getSelectedClaimBucket(pyrBucket);
      let ctrl: IcecontrolSettings = this.itemReferralAuthorizationListCtrl[clm.claim_key];
      if (cbucket != null && clm != null && clm.REFLREFS.length > 0 && ctrl.getOptions().length != clm.REFLREFS.length && this.allReferrals.length > 0)
        this.loadItemReferralAuthorizationListControl(pyrBucket, clm);

      this.setReadonly(pyrBucket, <IcecontrolSettings>this.itemReferralAuthorizationListCtrl[clm.claim_key]);
    }

    return this.itemReferralAuthorizationListCtrl[clm.claim_key];
  }

  loadItemReferralAuthorizationListControl(pyrBucket: payerbucket, clm: claim): void {
    if (pyrBucket == null || clm == null) return;
    let cbucket = this.getSelectedClaimBucket(pyrBucket);
    if (cbucket == null) return;

    let referralAuthorizationListCtrl: IcecontrolSettings = this.itemReferralAuthorizationListCtrl[clm.claim_key];
    if (referralAuthorizationListCtrl == null) return;

    let opts = [];
    for (let ireflRef = 0; ireflRef < clm.REFLREFS.length; ireflRef++) {
      let reflRef = clm.REFLREFS[ireflRef];
      let fndRefl = this.allReferrals.filter(r => r.referral_key == reflRef.referral_key);
      if (fndRefl.length > 0) {
        let desc = this.loadReferralAuthorization(reflRef, fndRefl[0]);
        opts.push({ name: desc, value: reflRef.referral_reference_key });
      }
    }
    referralAuthorizationListCtrl.setOptions(opts);
  }

  getItemReferenceIDListControl(pyrBucket: payerbucket, clm: claim): IcecontrolSettings {
    if (clm == null) return null;
    if (this.itemReferenceIDListCtrl[clm.claim_key] == null) {
      this.itemReferenceIDListCtrl[clm.claim_key]
        = new IcecontrolSettings("itemReference" + clm.claim_key, {}, null, null, "", "Other References")
          .setOptions([])
          .setActionItems([
            this.editAction, this.deleteAction
          ]);
      this.loadItemReferenceIDListControl(pyrBucket, clm)
    }
    else {
      this.setReadonly(pyrBucket, <IcecontrolSettings>this.itemReferenceIDListCtrl[clm.claim_key]);
    }

    return this.itemReferenceIDListCtrl[clm.claim_key];
  }

  loadItemReferenceIDListControl(pyrBucket: payerbucket, clm: claim): void {
    if (pyrBucket == null || clm == null) return;
    let cbucket = this.getSelectedClaimBucket(pyrBucket);
    if (cbucket == null) return;

    let refIDListCtrl: IcecontrolSettings = this.itemReferenceIDListCtrl[clm.claim_key];
    if (refIDListCtrl == null) return;

    let opts = [];
    for (let irefID = 0; irefID < clm.REFIDS.length; irefID++) {
      let refid = clm.REFIDS[irefID];

      let desc = this.loadReferenceID(refid);
      opts.push({ name: desc, value: refid.reference_identification_key });
    }
    refIDListCtrl.setOptions(opts);
  }

  getItemAmountsListControl(pyrBucket: payerbucket, clm: claim): IcecontrolSettings {
    if (clm == null) return null;
    if (this.itemAmountsListCtrl[clm.claim_key] == null) {
      this.itemAmountsListCtrl[clm.claim_key]
        = new IcecontrolSettings("itemAmount" + clm.claim_key, {}, null, null, "", "COB Amounts")
          .setOptions([])
          .setActionItems([
            this.editAction, this.deleteAction
          ]);
      this.loadItemAmountsListControl(pyrBucket, clm);
    }
    else {
      this.setReadonly(pyrBucket, <IcecontrolSettings>this.itemAmountsListCtrl[clm.claim_key]);
    }

    return this.itemAmountsListCtrl[clm.claim_key];
  }

  loadItemAmountsListControl(pyrBucket: payerbucket, clm: claim): void {
    if (pyrBucket == null || clm == null) return;
    let cbucket = this.getSelectedClaimBucket(pyrBucket);
    if (cbucket == null) return;
    let amtListCtrl: IcecontrolSettings = this.itemAmountsListCtrl[clm.claim_key];
    if (amtListCtrl == null) return;

    let opts = [];
    for (let iamt = 0; iamt < clm.COBS.length; iamt++) {
      let amt = clm.COBS[iamt];

      let desc = this.loadAmounts(clm, amt);
      opts.push({ name: desc, value: amt.amount_key });
    }
    amtListCtrl.setOptions(opts);
  }

  getItemProviderListControl(pyrBucket: payerbucket, clm: claim): IcecontrolSettings {
    if (clm == null) return null;
    if (this.itemProviderListCtrl[clm.claim_key] == null) {
      this.itemProviderListCtrl[clm.claim_key]
        = new IcecontrolSettings("itemProvider" + clm.claim_key, {}, null, null, "", "Providers")
          .setOptions([])
          .setActionItems([
            this.editAction, this.deleteAction
          ]);
      this.loadItemProviderListControl(pyrBucket, clm);
    }
    else {
      this.setReadonly(pyrBucket, <IcecontrolSettings>this.itemProviderListCtrl[clm.claim_key]);
    }

    return this.itemProviderListCtrl[clm.claim_key];
  }

  loadItemProviderListControl(pyrBucket: payerbucket, clm: claim): void {
    if (pyrBucket == null || clm == null) return;
    let cbucket = this.getSelectedClaimBucket(pyrBucket);
    if (cbucket == null) return;

    let proListCtrl: IcecontrolSettings = this.itemProviderListCtrl[clm.claim_key];
    if (proListCtrl == null) return;

    let opts = [];
    for (let ipro = 0; ipro < clm.PROS.length; ipro++) {
      let proref = clm.PROS[ipro];
      let fndPro = this.practiceProviders.filter(p => p.trans_account == proref.trans_account);
      if (fndPro.length > 0) {
        opts.push({ name: this.loadProvider(fndPro[0], proref), value: proref.provider_reference_key });
      }
    }
    proListCtrl.setOptions(opts);
  }

  getItemAttachmentsListControl(pyrBucket: payerbucket, clm: claim): IcecontrolSettings {
    if (clm == null) return null;
    if (this.itemAttachmentsListCtrl[clm.claim_key] == null) {
      this.itemAttachmentsListCtrl[clm.claim_key]
        = new IcecontrolSettings("itemAttachments" + clm.claim_key, {}, null, null, "", "Supplemental Attachments")
          .setOptions([])
          .setActionItems([
            this.editAction, this.deleteAction
          ]);
    }
    else {
      let ctrl: IcecontrolSettings = this.itemAttachmentsListCtrl[clm.claim_key];
      if (clm != null && clm.SUPPL != null && clm.SUPPL.length > 0 && ctrl.getOptions().length != clm.SUPPL.length && this.allAttachments.length > 0)
        this.loadItemAttachmentsListControl(pyrBucket, clm);

      this.setReadonly(pyrBucket, <IcecontrolSettings>this.itemAttachmentsListCtrl[clm.claim_key]);
    }

    return this.itemAttachmentsListCtrl[clm.claim_key];
  }

  loadItemAttachmentsListControl(pyrBucket: payerbucket, clm: claim): void {
    if (pyrBucket == null) return;
    let cbucket = this.getSelectedClaimBucket(pyrBucket);
    if (cbucket == null || clm == null) return;

    let attchListCtrl: IcecontrolSettings = this.itemAttachmentsListCtrl[clm.claim_key];
    if (attchListCtrl == null) return;

    let opts = [];
    for (let iattch = 0; iattch < clm.SUPPL.length; iattch++) {
      let suppInfo = clm.SUPPL[iattch];

      let opt = this.loadAttachments(pyrBucket, suppInfo);
      if (opt != null) {
        opts.push(opt);
      }
    }
    attchListCtrl.setOptions(opts);
  }

  getItemNotesListControl(pyrBucket: payerbucket, clm: claim): IcecontrolSettings {
    if (clm == null) return null;
    if (this.itemNotesListCtrl[clm.claim_key] == null) {
      this.itemNotesListCtrl[clm.claim_key]
        = new IcecontrolSettings("itemNotes" + clm.claim_key, {}, null, null, "", "Claim Notes")
          .setOptions([])
          .setActionItems([
            this.editAction, this.deleteAction
          ]);
      this.loadItemNotesListControl(pyrBucket, clm);
    }
    else {
      this.setReadonly(pyrBucket, <IcecontrolSettings>this.itemNotesListCtrl[clm.claim_key]);
    }

    return this.itemNotesListCtrl[clm.claim_key];
  }

  loadItemNotesListControl(pyrBucket: payerbucket, clm: claim): void {
    if (pyrBucket == null) return;
    let cbucket = this.getSelectedClaimBucket(pyrBucket);
    if (cbucket == null || clm == null) return;

    let noteListCtrl: IcecontrolSettings = this.itemNotesListCtrl[clm.claim_key];
    if (noteListCtrl == null) return;

    let opts = [];
    for (let iattch = 0; iattch < clm.CLMNOTES.length; iattch++) {
      let clmnte = clm.CLMNOTES[iattch];

      let desc = clmnte.description.substr(0, 80) + "...";

      opts.push({ name: desc, value: clmnte.claim_note_key });
    }
    noteListCtrl.setOptions(opts);
  }

  getPayerBucketClaims(pyrBucket: payerbucket): claim[] {
    let cbucket = this.getSelectedClaimBucket(pyrBucket);
    if (cbucket == null) return [];

    let clms: claim[] = [];
    for (let idata = 0; idata < pyrBucket.data.length; idata++) {
      let clmdata = pyrBucket.data[idata];
      if (clmdata == null) continue;
      if (clmdata.claim == null)
        clms.push(<claim>clmdata.service);
      else
        clms.push(clmdata.claim);
    }

    // To do: order by index if index is not set
    return clms;
  }

  getClaimDiagnoses(): diagnosis[]  {
    let ret: diagnosis[] = [];
    for (let idx = 0; idx < this.serviceCharges.DIAGS.length; idx++) {
      let fnd = this.allDiagnoses.filter(dx => this.serviceCharges.DIAGS[idx].icd_code == dx.icd_code);
      if (fnd.length > 0) {
        ret.push(fnd[0]);
      }
    }
    return ret;
  }

  getClaimTotal(pyrBucket: any): string {
    if (pyrBucket == null) return "";
    let ret = 0;
    let clms = this.getPayerBucketClaims(pyrBucket);
    if (clms != null) {
      for (let iclm = 0; iclm < clms.length; iclm++) {
        let clm = clms[iclm];
        ret += Iceutility.toDouble(clm.total_amount);
      }
    }
    return ret.toFixed(2).toString();
  }

  getItemDateRange(pyrBucket: any, clm: claim): string {
    if (pyrBucket == null || clm == null) return "";

    let ret = "";
    if (clm.SVCDTS.length > 0 && clm.SVCDTS[0] != null) {
      let dtFrom = Iceutility.isTextDateTime(clm.SVCDTS[0].date_required) ? Iceutility.getDateTextEx(clm.SVCDTS[0].date_required, null, false) : Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(clm.SVCDTS[0].date_required), null, false);
      let dtTo = Iceutility.isTextDateTime(clm.SVCDTS[0].end_date_required) ? Iceutility.getDateTextEx(clm.SVCDTS[0].end_date_required, null, false) : Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(clm.SVCDTS[0].end_date_required), null, false);
      ret = dtFrom + " - " + dtTo;
    }
    return ret;
  }

  getItemTotal(pyrBucket: any, clm: claim): string {
    if (pyrBucket == null || clm == null) return "";
    let ret = Iceutility.toDouble(clm.total_amount);
    return ret.toFixed(2).toString();
  }

  getItemStatus(pyrBucket: any, clm: claim): string {
    if (pyrBucket == null || clm == null) return "";
    let ret = MessageService.getStatus(Iceutility.toLong(clm.trans_status), IceTypes.SourceType.srcStatement);
    return ret;
  }

  getItemModifiers(pyrBucket: any, clm: claim): string[] {
    let ret: string[] = [];
    if (clm == null) return [];
    for (let imod = 1; imod <= 4; imod++) {
      let fld = "modifier" + imod.toString();
      if (clm[fld] == null) continue;
      let modFound = this.listOfModifiers.filter(bc => bc.code == clm[fld]);
      if (modFound.length > 0) {
        ret.push(modFound[0].code + " - " + modFound[0].title);
      }
    }
    return ret;
  }

  getItemDiagnoses(pyrBucket: any, clm: claim): diagnosis[] {
    let ret: diagnosis[] = [];
    let svc: medicalservice = clm;
    if (svc == null) return [];

    let mrefFound = this.serviceCharges.CHARGES.filter(m => m.medical_service_key == svc.medical_service_key);
    if (mrefFound.length > 0) {
      for (let idx = 0; idx < mrefFound[0].DIAGREFS.length; idx++) {
        let dref = mrefFound[0].DIAGREFS[idx];
        let fnd = this.allDiagnoses.filter(dx => dx.icd_code == dref.icd_code);
        if (fnd.length > 0) {
          ret.push(fnd[0]);
        }
      }
    }
    return ret;
  }

  getItemDates(pyrBucket: any, clm: claim): string[] {
    let ret: string[] = [];
    if (clm == null) return [];
    for (let idt = 0; idt < clm.SVCDTS.length; idt++) {
      let dt = clm.SVCDTS[idt];
      let dtFrom = Iceutility.isTextDateTime(dt.date_required) ? Iceutility.getDateTextEx(dt.date_required, null, false) : Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(dt.date_required), null, false);
      let dtTo = Iceutility.isTextDateTime(dt.end_date_required) ? Iceutility.getDateTextEx(dt.end_date_required, null, false) : Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(dt.end_date_required), null, false);
      let dtType = "";
      if (dt.datetime_qualifier != null) {
        dtType = dt.datetime_qualifier;
        let fnd = this.listOfDateQualifiers.filter(bc => bc.code == dt.datetime_qualifier)
        if (fnd.length > 0) {
          dtType = fnd[0].title;
        }
      }

      dtType = dtType.length > 0 ? dtType + " - " : "";
      let range = dtType + dtFrom;
      if (dtTo.length > 0) range += " - " + dtTo;
      ret.push(range);
    }
    return ret;
  }

  getItemProviders(pyrBucket: payerbucket, clm: claim): provider_index[] {
    if (pyrBucket == null || clm == null) return [];

    let ret: provider_index[] = [];
    for (let ipro = 0; ipro < clm.PROS.length; ipro++) {
      ret = ret.concat(this.practiceProviders.filter(p => p.trans_account == clm.PROS[ipro].trans_account));
    }

    return ret;
  }

  ////////////////////////////////////////////////
  // Popups
  doOtherSubscriberPopup(parentPyrBucket: payerbucket, subref: subscriberreference) {
    let descText = "";
    if (parentPyrBucket == null || subref == null) return;

    let partyKey = AccountingService.getPartyBucketKeyEx(subref.subscriber_key, subref.coverage_key, subref.payer_key);
    let partyFnd = this.responsibleParties.filter(r => r.value == partyKey);
    if (partyFnd.length > 0 && partyFnd[0].summary != null) {
      let info: any[] = <any[]>partyFnd[0].summary;
      descText = info.join("\n");
    }

    let otherSubCtrl: IcecontrolSettings = null, otherSubInfoCtrl: IcecontrolSettings = null;
    let sections: IcepanelsectionSettings[] = [
      new IcepanelsectionSettings("OtherSubscriberSection", { class: ["yalla"], styles: {} }, [],
        [otherSubCtrl = new IcecontrolSettings("iceselect", { width: "400px" }, null, null, "OtherSubscriber", "Other Subscriber")
          .setControlName("payer_id")
          .createFormControl(partyKey, [Validators.required])
          .setOptions(this.responsibleParties.filter(r => r.value != this.getPayerBucketKey(parentPyrBucket)))], null),
      new IcepanelsectionSettings("OtherSubscriberDescSection", { class: ["yalla"], styles: {} }, [],
        [otherSubInfoCtrl = new IcecontrolSettings("icetextarea", { width: "400px", height: "300px" }, null, null, "Description", "Description")
          .setControlName("description")
          .createFormControl(descText, [])
          .setReadonly(true)
        ], null),
    ];

    let headerControls = [
      new IcecontrolSettings("icesubmitbutton", { class: "fas fa-check", width: "50px" }, null, null, "Save"),
      new IcecontrolSettings("icecancelbutton", { class: "fas fa-times", width: "50px" }, null, null, "Close")
    ];

    otherSubCtrl.createChangeControlEvent().subscribe(
      data => {
        if (data == null) return;
        let respFnd = this.responsibleParties.filter(r => r.value == data.value);
        if (respFnd.length > 0 && respFnd[0].summary != null) {
          let info: any[] = <any[]>respFnd[0].summary;
          otherSubInfoCtrl.getFormControl().setValue(info.join("\n"));
        }
        else {
          otherSubInfoCtrl.getFormControl().setValue("");
        }        
      },
      err => {
      });
    this.otherSubscriberDialogRef = this.dialog.open(IcepanelDialog, {
      height: '400px',
      width: '500px',
      data: {
        record: subref,
        parentrecord: parentPyrBucket,
        panel: new IcepanelSettings("", "", "Other Subscriber", "", sections, headerControls)
          .enableForm(),
      }
    });

    var ref = this.otherSubscriberDialogRef;
    this.otherSubscriberDialogRef.afterClosed().subscribe(result => {
      if (ref.componentInstance == null || ref.componentInstance.data == null) return;
      let hdrCtrl: IcecontrolSettings = <IcecontrolSettings>ref.componentInstance.data.headerCtrl;
      if (hdrCtrl == null || hdrCtrl.id == "Close") return;

      let sref: subscriberreference = <subscriberreference>ref.componentInstance.data.record;
      let pbket = ref.componentInstance.data.parentrecord;
      let panel: IcepanelSettings = <IcepanelSettings>ref.componentInstance.data.panel;
      if (panel != null && pbket != null && sref != null) {
        let form = panel.getForm();
        if (form != null && form.valid) {
          for (let isec = 0; isec < panel.sections.length; isec++) {
            let sec = panel.sections[isec];
            for (let ictrl = 0; ictrl < sec.controls.length; ictrl++) {
              let ctrl = sec.controls[ictrl];
              switch (ctrl.getControlName()) {
                case "payer_id": {
                  AccountingService.setSubscriberReferenceFromDDLKey(ctrl, sref)
                  break;
                }
              }
            }
          }

          let cbucket = this.getSelectedClaimBucket(parentPyrBucket);
          if (cbucket == null) return "";

          if (subref.offline_record_status == IceTypes.offlineRecStatus.offlineInsert) {
            subref.subscriber_reference_key = Iceutility.guid(true);
            cbucket.SUBS.push(subref);
          }
          else {
            subref.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;
          }

          if (cbucket.offline_record_status != IceTypes.offlineRecStatus.offlineInsert)
            cbucket.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;

          this.autoSavePayerBuckets([cbucket]).subscribe(
            data => {
              if (data != null) {
                subref.offline_record_status = IceTypes.offlineRecStatus.offlineNoChange;
                this.loadClaimOtherSubscriberListControl(parentPyrBucket);
                this.resetChangedBuckets(<claimbucket[]>data);
              }
            },
            error => {
              console.log(error);
            });
        }
      }
    });

  }

  doRelatedCausePopup(parentPyrBucket: any, relcause: relatedcause) {
    let descText = "";
    if (parentPyrBucket == null || relcause == null) return;

    let relCauseCtrl: IcecontrolSettings = null, countryCtrl: IcecontrolSettings = null, stateCtrl: IcecontrolSettings = null;
    let sections: IcepanelsectionSettings[] = [
      new IcepanelsectionSettings("RelatedCauseSection", { class: ["yalla"], styles: {} }, [],
        [relCauseCtrl = new IcecontrolSettings("iceselect", { width: "400px" }, null, null, "RelatedCause", "Related Cause")
          .setControlName("related_cause_code")
          .createFormControl(relcause.related_cause_code, [Validators.required])
          .setOptions(this.relatedCauseOptions)], null),
      new IcepanelsectionSettings("CountrySection", { class: ["yalla"], styles: {} }, [],
        [countryCtrl = new IcecontrolSettings("iceselect", { width: "400px" }, null, null, "Country", "Country")
          .setControlName("country_id")
          .createFormControl(relcause.country_id, [Validators.required])], null),
      new IcepanelsectionSettings("StateSection", { class: ["yalla"], styles: {} }, [],
        [stateCtrl = new IcecontrolSettings("iceselect", { width: "400px" }, null, null, "State", "State")
          .setControlName("state_id")
          .createFormControl(relcause.state_id, [Validators.required])], null),
    ];

    this.appSvc.setCountryCodeList(this.medCodeSvc, countryCtrl);
    this.appSvc.setStateIDList(this.medCodeSvc, stateCtrl, relcause.country_id);

    let headerControls = [
      new IcecontrolSettings("icesubmitbutton", { class: "fas fa-check", width: "50px" }, null, null, "Save"),
      new IcecontrolSettings("icecancelbutton", { class: "fas fa-times", width: "50px" }, null, null, "Close")
    ];

    countryCtrl.createChangeControlEvent().subscribe(
      data => {
        if (data == null) return;
        let countryid = data.value;
        this.appSvc.setStateIDList(this.medCodeSvc, stateCtrl, countryid);
      },
      err => {
      });
    this.relatedCauseDialogRef = this.dialog.open(IcepanelDialog, {
      height: '400px',
      width: '500px',
      data: {
        record: relcause,
        parentrecord: parentPyrBucket,
        panel: new IcepanelSettings("", "", "Related Cause", "", sections, headerControls)
          .enableForm(),
      }
    });

    var ref = this.relatedCauseDialogRef;
    this.relatedCauseDialogRef.afterClosed().subscribe(result => {
      if (ref.componentInstance == null || ref.componentInstance.data == null) return;
      let hdrCtrl: IcecontrolSettings = <IcecontrolSettings>ref.componentInstance.data.headerCtrl;
      if (hdrCtrl == null || hdrCtrl.id == "Close") return;

      let rc: relatedcause = <relatedcause>ref.componentInstance.data.record;
      let pbket = ref.componentInstance.data.parentrecord;
      let panel: IcepanelSettings = <IcepanelSettings>ref.componentInstance.data.panel;
      if (panel != null && pbket != null && rc != null) {
        let form = panel.getForm();
        if (form != null && form.valid) {
          for (let isec = 0; isec < panel.sections.length; isec++) {
            let sec = panel.sections[isec];
            for (let ictrl = 0; ictrl < sec.controls.length; ictrl++) {
              let ctrl = sec.controls[ictrl];
              switch (ctrl.getControlName()) {
                case "related_cause_code": {
                  relcause.related_cause_code = ctrl.getFormControl().value;
                  break;
                }
                case "country_id": {
                  relcause.country_id = ctrl.getFormControl().value;
                  break;
                }
                case "state_id": {
                  relcause.state_id = ctrl.getFormControl().value;
                  break;
                }
              }
            }
          }

          let cbucket = this.getSelectedClaimBucket(parentPyrBucket);
          if (cbucket == null) return "";

          if (relcause.offline_record_status == IceTypes.offlineRecStatus.offlineInsert) {
            relcause.related_cause_key = Iceutility.guid(true);
            cbucket.CAUSES.push(relcause);
          }
          else {
            relcause.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;
          }

          if (cbucket.offline_record_status != IceTypes.offlineRecStatus.offlineInsert)
            cbucket.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;

          this.autoSavePayerBuckets([cbucket]).subscribe(
            data => {
              if (data != null) {
                relcause.offline_record_status = IceTypes.offlineRecStatus.offlineNoChange;
                this.loadClaimRelatedCausesListControl(parentPyrBucket);
                this.resetChangedBuckets(<claimbucket[]>data);
              }
            },
            error => {
              console.log(error);
            });
        }
      }
    });

  }

  doDatesPopup(parentPyrBucket: any, clm: claim, caption: string, defaultCode: string, sdt: servicedate) {
    let descText = "";
    if (parentPyrBucket == null || sdt == null) return;

    let dtFrom = Iceutility.isTextDateTime(sdt.date_required) ? Iceutility.GetLocalDate(sdt.date_required) : Iceutility.ConvertFromDotNetServerTime(sdt.date_required);
    let dtTo = Iceutility.isTextDateTime(sdt.end_date_required) ? Iceutility.GetLocalDate(sdt.end_date_required) : Iceutility.ConvertFromDotNetServerTime(sdt.end_date_required);

    if (sdt.datetime_qualifier == "") {
      sdt.datetime_qualifier = defaultCode;
    }
    let dateCodeCtrl: IcecontrolSettings = null, dateCtrl: IcecontrolSettings = null, endDateCtrl: IcecontrolSettings = null;
    let sections: IcepanelsectionSettings[] = [
      new IcepanelsectionSettings("DateQualSection", { class: ["yalla"], styles: {} }, [],
        [dateCodeCtrl = new IcecontrolSettings("iceselect", { width: "400px" }, null, null, "DateCode", "Date Code")
          .setControlName("datetime_qualifier")
          .createFormControl(sdt.datetime_qualifier, [Validators.required])
          .setOptions(this.dateQualOptions)], null),
      new IcepanelsectionSettings("DateSection", { class: ["yalla"], styles: {} }, [],
        [dateCtrl = new IcecontrolSettings("icedatepicker", { width: "200px" }, null, null, "Date", "Date")
          .setControlName("date_required")
          .createFormControl(dtFrom, [])], null),
      new IcepanelsectionSettings("EndDateSection", { class: ["yalla"], styles: {} }, [],
        [endDateCtrl = new IcecontrolSettings("icedatepicker", { width: "200px" }, null, null, "EndDate", "End Date")
          .setControlName("end_date_required")
          .createFormControl(dtTo, [])], null),
    ];

    let headerControls = [
      new IcecontrolSettings("icesubmitbutton", { class: "fas fa-check", width: "50px" }, null, null, "Save"),
      new IcecontrolSettings("icecancelbutton", { class: "fas fa-times", width: "50px" }, null, null, "Close")
    ];

    this.dateDialogRef = this.dialog.open(IcepanelDialog, {
      height: '400px',
      width: '500px',
      data: {
        record: sdt,
        parentrecord: parentPyrBucket,
        panel: new IcepanelSettings("", "", caption, "", sections, headerControls)
          .enableForm(),
      }
    });

    var ref = this.dateDialogRef;
    this.dateDialogRef.afterClosed().subscribe(result => {
      if (ref.componentInstance == null || ref.componentInstance.data == null) return;
      let hdrCtrl: IcecontrolSettings = <IcecontrolSettings>ref.componentInstance.data.headerCtrl;
      if (hdrCtrl == null || hdrCtrl.id == "Close") return;
      let svcdt: servicedate = <servicedate>ref.componentInstance.data.record;
      let pbket = ref.componentInstance.data.parentrecord;
      let panel: IcepanelSettings = <IcepanelSettings>ref.componentInstance.data.panel;
      if (panel != null && pbket != null && svcdt != null) {
        let form = panel.getForm();
        if (form != null && form.valid) {
          for (let isec = 0; isec < panel.sections.length; isec++) {
            let sec = panel.sections[isec];
            for (let ictrl = 0; ictrl < sec.controls.length; ictrl++) {
              let ctrl = sec.controls[ictrl];
              switch (ctrl.getControlName()) {
                case "datetime_qualifier": {
                  sdt.datetime_qualifier = ctrl.getFormControl().value;
                  break;
                }
                case "date_required": {
                  sdt.date_required = Iceutility.GetDateText(ctrl.getFormControl().value, null, true);
                  break;
                }
                case "end_date_required": {
                  sdt.end_date_required = Iceutility.GetDateText(ctrl.getFormControl().value, null, true);
                  break;
                }
              }
            }
          }

          let cbucket = this.getSelectedClaimBucket(parentPyrBucket);
          if (cbucket == null) return;

          if (clm == null) {
            if (sdt.offline_record_status == IceTypes.offlineRecStatus.offlineInsert) {
              sdt.service_date_key = Iceutility.guid(true);
              cbucket.SVCDTS.push(sdt);
            }
            else {
              sdt.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;
            }
          }
          else {
            if (sdt.offline_record_status == IceTypes.offlineRecStatus.offlineInsert) {
              sdt.service_date_key = Iceutility.guid(true);
              clm.SVCDTS.push(sdt);
            }
            else {
              sdt.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;
            }

            if (clm.offline_record_status != IceTypes.offlineRecStatus.offlineInsert)
              clm.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;
          }

          if (cbucket.offline_record_status != IceTypes.offlineRecStatus.offlineInsert)
            cbucket.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;

          this.autoSavePayerBuckets([cbucket]).subscribe(
            data => {
              if (data != null) {
                sdt.offline_record_status = IceTypes.offlineRecStatus.offlineNoChange;
                if (clm == null) { // do the claim dates 
                  if (defaultCode == "573")
                    this.loadClaimRemittanceDatesListControl(parentPyrBucket);
                  else
                    this.loadClaimDatesofEventsListControl(parentPyrBucket);
                }
                else {
                  // do item dates
                  this.loadItemDatesofEventsListControl(parentPyrBucket, clm);
                }
                this.resetChangedBuckets(<claimbucket[]>data);
              }
            },
            error => {
              console.log(error);
            });
        }
      }
    });
  }

  doReferralAuthorizationPopup(parentPyrBucket: payerbucket, clm: claim, reflref: referralreference, refl: referral) {
    let descText = "";
    if (parentPyrBucket == null || reflref == null) return;

    let certActionCtrl: IcecontrolSettings = null, reviewIDCtrl: IcecontrolSettings = null, reviewDecReasonCtrl: IcecontrolSettings = null;
    let sections: IcepanelsectionSettings[] = [
      new IcepanelsectionSettings("CertActionSection", { class: ["yalla"], styles: {} }, [],
        [certActionCtrl = new IcecontrolSettings("iceselect", { width: "400px" }, null, null, "CertAction", "Certification Action")
          .setControlName("hcr_certification_action_code")
          .createFormControl(refl.hcr_certification_action_code, [Validators.required])
          .setOptions([
            { value: "A1", name: "A1 - Certified in total (Affirmed Decision)" },
            { value: "A2", name: "A2 – Certified – partial (Partially Affirmed Decision)" },
            { value: "A3", name: "A3 – Not Certified (Non-Affirmed Decision)" },
            { value: "A6", name: "A6 – Modified (Affirmed with Changes Decision)." },
            { value: "A4", name: "A4 - Pended" },
            { value: "C", name: "C - Canceled" },
          ])], null),
      new IcepanelsectionSettings("ReviewIDSection", { class: ["yalla"], styles: {} }, [],
        [reviewIDCtrl = new IcecontrolSettings("iceinput", { width: "300px" }, null, null, "ReviewIdentificationNumber", "Review Identification Number")
          .setControlName("hcr_review_identification_number")
          .createFormControl(refl.hcr_review_identification_number, [Validators.required])], null),
      new IcepanelsectionSettings("ReviewDecReasonSection", { class: ["yalla"], styles: {} }, [],
        [reviewDecReasonCtrl = new IcecontrolSettings("iceselect", { width: "300px" }, null, null, "ReviewDecisionReason", "Review Decision Reason")
          .setControlName("hcr_review_decision_reason_code")
          .createFormControl(refl.hcr_review_decision_reason_code, [])
          .setOptions([
            { value: "", name: "N/A" },
            { value: "0U", name: "0U - Successful Submission" },
            { value: "0P", name: "0P - 2–Business Day Warning" },
            { value: "0B", name: "0B - RC Pickup Notification Cancelation" },
          ])], null),
    ];

    let headerControls = [
      new IcecontrolSettings("icesubmitbutton", { class: "fas fa-check", width: "50px" }, null, null, "Save"),
      new IcecontrolSettings("icecancelbutton", { class: "fas fa-times", width: "50px" }, null, null, "Close")
    ];

    this.referralAuthDialogRef = this.dialog.open(IcepanelDialog, {
      height: '400px',
      width: '500px',
      data: {
        record: reflref,
        parentrecord: parentPyrBucket,
        panel: new IcepanelSettings("", "", "Review Authorization and Certification", "", sections, headerControls)
          .enableForm(),
      }
    });

    var ref = this.referralAuthDialogRef;
    this.referralAuthDialogRef.afterClosed().subscribe(result => {
      if (ref.componentInstance == null || ref.componentInstance.data == null) return;
      let hdrCtrl: IcecontrolSettings = <IcecontrolSettings>ref.componentInstance.data.headerCtrl;
      if (hdrCtrl == null || hdrCtrl.id == "Close") return;

      let rref: referralreference = <referralreference>ref.componentInstance.data.record;
      let pbket = ref.componentInstance.data.parentrecord;
      let panel: IcepanelSettings = <IcepanelSettings>ref.componentInstance.data.panel;
      if (panel != null && pbket != null && rref != null) {
        let form = panel.getForm();
        if (form != null && form.valid) {
          for (let isec = 0; isec < panel.sections.length; isec++) {
            let sec = panel.sections[isec];
            for (let ictrl = 0; ictrl < sec.controls.length; ictrl++) {
              let ctrl = sec.controls[ictrl];
              switch (ctrl.getControlName()) {
                case "hcr_certification_action_code": {
                  refl.hcr_certification_action_code = ctrl.getFormControl().value;
                  break;
                }
                case "hcr_review_identification_number": {
                  refl.hcr_review_identification_number = ctrl.getFormControl().value;
                  break;
                }
                case "hcr_review_decision_reason_code": {
                  refl.hcr_review_decision_reason_code = ctrl.getFormControl().value;
                  break;
                }
              }
            }
          }

          let cbucket = this.getSelectedClaimBucket(parentPyrBucket);
          if (cbucket == null) return ;
          
          this.ptSvc.insertUpdateReferralCertification(cbucket.to_trans_account, refl).subscribe(
            data => {
              if (data == null || data.length == 0) return;
              let servRefl: referral = data[0];
              if (reflref.offline_record_status == IceTypes.offlineRecStatus.offlineInsert) {
                reflref.referral_reference_key = Iceutility.guid(true);
                reflref.referral_key = servRefl.referral_key;
                if (clm == null) {
                  cbucket.REFLREFS.push(reflref);
                }
                else {
                  if (clm.offline_record_status != IceTypes.offlineRecStatus.offlineInsert)
                    clm.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;

                  clm.REFLREFS.push(reflref);
                }
                this.allReferrals.push(servRefl);
              }
              else {
                reflref.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;
              }

              if (cbucket.offline_record_status != IceTypes.offlineRecStatus.offlineInsert)
                cbucket.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;

              this.autoSavePayerBuckets([cbucket]).subscribe(
                data => {
                  if (data != null) {
                    reflref.offline_record_status = IceTypes.offlineRecStatus.offlineNoChange;
                    if (clm == null)
                      this.loadClaimReferralAuthorizationListControl(parentPyrBucket);
                    else
                      this.loadItemReferralAuthorizationListControl(parentPyrBucket, clm);

                    this.resetChangedBuckets(<claimbucket[]>data);
                  }
                },
                error => {
                  console.log(error);
                });
            },
            error => {
              console.log(error);
            }
          );
        }
      }
    });
  }

  doOtherReferencePopup(parentPyrBucket: payerbucket, clm: claim, refID: referenceidentification) {
    let descText = "";
    if (parentPyrBucket == null || refID == null) return;

    let otherRefCtrl: IcecontrolSettings = null, refValueCtrl: IcecontrolSettings = null, refValueOptionCtrl: IcecontrolSettings = null;
    let sections: IcepanelsectionSettings[] = [
      new IcepanelsectionSettings("OtherRefSection", { class: ["yalla"], styles: {} }, [],
        [otherRefCtrl = new IcecontrolSettings("iceselect", { width: "400px" }, null, null, "RefQual", "Reference Type")
          .setControlName("reference_identification_qualifier")
          .createFormControl(refID.reference_identification_qualifier, [Validators.required])
          .setOptions(this.claimOtherReferenceOptions)], null),
      new IcepanelsectionSettings("ReferenceCodeSection", { class: ["yalla"], styles: {} }, [],
        [refValueCtrl = new IcecontrolSettings("iceinput", { width: "300px" }, null, null, "ReferenceCodeORNumber", "Reference Code or Number")
          .setControlName("reference_identification_code")
          .createFormControl(refID.reference_identification_code, [Validators.required])], null)
    ];

    switch (refID.reference_identification_qualifier) {
      case "F5": {
        let fnd = sections.filter(s => s.tag == "ReferenceCodeSection");
        if (fnd.length > 0 && fnd[0].controls != null) {
          let ctrlFnd = fnd[0].controls.filter(c => c.getControlName() == "reference_identification_code");
          if (ctrlFnd.length > 0) {
            ctrlFnd[0].tag = "iceselect";
            ctrlFnd[0].setOptions(this.claimMandatoryMedicareSectionCrossoverIndicatorOptions);
          }
        }
        break;
      }
      case "4N": {
        let fnd = sections.filter(s => s.tag == "ReferenceCodeSection");
        if (fnd.length > 0 && fnd[0].controls != null) {
          let ctrlFnd = fnd[0].controls.filter(c => c.getControlName() == "reference_identification_code");
          if (ctrlFnd.length > 0) {
            ctrlFnd[0].tag = "iceselect";
            ctrlFnd[0].setOptions(this.claimServiceAuthorizationExceptionCodeOptions);
          }
        }
        break;
      }
    }

    let headerControls = [
      new IcecontrolSettings("icesubmitbutton", { class: "fas fa-check", width: "50px" }, null, null, "Save"),
      new IcecontrolSettings("icecancelbutton", { class: "fas fa-times", width: "50px" }, null, null, "Close")
    ];

    otherRefCtrl.createChangeControlEvent().subscribe(
      data => {
        if (data == null) return;
        switch (data.value) {
          case "F5": {
            let fnd = sections.filter(s => s.tag == "ReferenceCodeSection");
            if (fnd.length > 0 && fnd[0].controls != null) {
              let ctrlFnd = fnd[0].controls.filter(c => c.getControlName() == "reference_identification_code");
              if (ctrlFnd.length > 0) {
                ctrlFnd[0].tag = "iceselect";
                ctrlFnd[0].setOptions(this.claimMandatoryMedicareSectionCrossoverIndicatorOptions);
              }
            }
            break;
          }
          case "4N": {
            let fnd = sections.filter(s => s.tag == "ReferenceCodeSection");
            if (fnd.length > 0 && fnd[0].controls != null) {
              let ctrlFnd = fnd[0].controls.filter(c => c.getControlName() == "reference_identification_code");
              if (ctrlFnd.length > 0) {
                ctrlFnd[0].tag = "iceselect";
                ctrlFnd[0].setOptions(this.claimServiceAuthorizationExceptionCodeOptions);
              }
            }
            break;
          }
          default: {
            let fnd = sections.filter(s => s.tag == "ReferenceCodeSection");
            if (fnd.length > 0 && fnd[0].controls != null) {
              let ctrlFnd = fnd[0].controls.filter(c => c.getControlName() == "reference_identification_code");
              if (ctrlFnd.length > 0) {
                ctrlFnd[0].getFormControl().setValue("");
                ctrlFnd[0].tag = "iceinput";
                ctrlFnd[0].setOptions([]);
              }
            }
            break;
          }
        }
      },
      err => {
      });

    this.otherReferenceDialogRef = this.dialog.open(IcepanelDialog, {
      height: '400px',
      width: '500px',
      data: {
        record: refID,
        parentrecord: parentPyrBucket,
        panel: new IcepanelSettings("", "", "Other Reference Information", "", sections, headerControls)
          .enableForm(),
      }
    });

    var ref = this.otherReferenceDialogRef;
    this.otherReferenceDialogRef.afterClosed().subscribe(result => {
      if (ref.componentInstance == null || ref.componentInstance.data == null) return;
      let hdrCtrl: IcecontrolSettings = <IcecontrolSettings>ref.componentInstance.data.headerCtrl;
      if (hdrCtrl == null || hdrCtrl.id == "Close") return;

      let rref: referenceidentification = <referenceidentification>ref.componentInstance.data.record;
      let pbket = ref.componentInstance.data.parentrecord;
      let panel: IcepanelSettings = <IcepanelSettings>ref.componentInstance.data.panel;
      if (panel != null && pbket != null && rref != null) {
        let form = panel.getForm();
        if (form != null && form.valid) {
          for (let isec = 0; isec < panel.sections.length; isec++) {
            let sec = panel.sections[isec];
            for (let ictrl = 0; ictrl < sec.controls.length; ictrl++) {
              let ctrl = sec.controls[ictrl];
              switch (ctrl.getControlName()) {
                case "reference_identification_qualifier": {
                  refID.reference_identification_qualifier = ctrl.getFormControl().value;
                  break;
                }
                case "reference_identification_code": {
                  refID.reference_identification_code = ctrl.getFormControl().value;
                  break;
                }
              }
            }
          }

          let cbucket = this.getSelectedClaimBucket(parentPyrBucket);
          if (cbucket == null) return;

          if (refID.offline_record_status == IceTypes.offlineRecStatus.offlineInsert) {
            refID.reference_identification_key = Iceutility.guid(true);
            if (clm == null)
              cbucket.REFIDS.push(refID);
            else
              clm.REFIDS.push(refID);
          }
          else {
            refID.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;
          }

          if (clm != null) {
            if (clm.offline_record_status != IceTypes.offlineRecStatus.offlineInsert)
              clm.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;
          }

          if (cbucket.offline_record_status != IceTypes.offlineRecStatus.offlineInsert)
            cbucket.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;

          this.autoSavePayerBuckets([cbucket]).subscribe(
            data => {
              if (data != null) {
                refID.offline_record_status = IceTypes.offlineRecStatus.offlineNoChange;
                if (clm == null)
                  this.loadClaimReferenceIDListControl(parentPyrBucket);
                else 
                  this.loadItemReferenceIDListControl(parentPyrBucket, clm);
                this.resetChangedBuckets(<claimbucket[]>data);
              }
            },
            error => {
              console.log(error);
            });
        }
      }
    });
  }

  doAmountsPopup(parentPyrBucket: payerbucket, clm: claim, amtref: amount) {
    let descText = "";
    if (parentPyrBucket == null || amtref == null) return;

    let partyKey = AccountingService.getPartyBucketKeyEx(amtref.subscriber_key, amtref.coverage_key, amtref.payer_key);
    let amtRefCtrl: IcecontrolSettings = null, otherSubCtrl: IcecontrolSettings = null, otherSubInfoCtrl: IcecontrolSettings = null, amtValueCtrl: IcecontrolSettings = null;
    let sections: IcepanelsectionSettings[] = [
      new IcepanelsectionSettings("AmountRefSection", { class: ["yalla"], styles: {} }, [],
        [amtRefCtrl = new IcecontrolSettings("iceselect", { width: "400px" }, null, null, "RefQual", "Reference Type")
          .setControlName("amount_qualifier")
          .createFormControl(amtref.amount_qualifier, [Validators.required])
          .setOptions(clm == null ? this.claimAmounts : this.itemAmounts)], null),
      new IcepanelsectionSettings("OtherSubscriberSection", { class: ["yalla"], styles: {} }, [],
        [otherSubCtrl = new IcecontrolSettings("iceselect", { width: "400px" }, null, null, "OtherSubscriber", "Other Subscriber")
          .setControlName("payer_id")
          .createFormControl(partyKey, [Validators.required])
          .setOptions(this.responsibleParties.filter(r => r.value != this.getPayerBucketKey(parentPyrBucket)))], null),
      new IcepanelsectionSettings("OtherSubscriberDescSection", { class: ["yalla"], styles: {} }, [],
        [otherSubInfoCtrl = new IcecontrolSettings("icetextarea", { width: "400px", height: "300px" }, null, null, "Description", "Description")
          .setControlName("description")
          .createFormControl(descText, [])
          .setReadonly(true)], null),
      new IcepanelsectionSettings("ReferenceCodeSection", { class: ["yalla"], styles: {} }, [],
        [amtValueCtrl = new IcecontrolSettings("iceinput", { width: "100px" }, null, null, "AmountValue", "Amount")
          .setControlName("amount_value")
          .createFormControl(amtref.amount_value, [Validators.required])], null)
    ];

    let headerControls = [
      new IcecontrolSettings("icesubmitbutton", { class: "fas fa-check", width: "50px" }, null, null, "Save"),
      new IcecontrolSettings("icecancelbutton", { class: "fas fa-times", width: "50px" }, null, null, "Close")
    ];

    otherSubCtrl.createChangeControlEvent().subscribe(
      data => {
        if (data == null) return;
        let payerid = data.value;
        let pyrBucket = this.getPayerBucketByPartyKey(payerid);
        if (pyrBucket != null) {
          let clmInfo = this.getClaimInformation(pyrBucket);
          otherSubInfoCtrl.getFormControl().setValue(clmInfo);
        }
        else {
          otherSubInfoCtrl.getFormControl().setValue("");
        }
      },
      err => {
      });
    this.amountValueDialogRef = this.dialog.open(IcepanelDialog, {
      height: '400px',
      width: '500px',
      data: {
        record: amtref,
        parentrecord: parentPyrBucket,
        panel: new IcepanelSettings("", "", "Claim Amount", "", sections, headerControls)
          .enableForm(),
      }
    });

    var ref = this.amountValueDialogRef;
    this.amountValueDialogRef.afterClosed().subscribe(result => {
      if (ref.componentInstance == null || ref.componentInstance.data == null) return;
      let hdrCtrl: IcecontrolSettings = <IcecontrolSettings>ref.componentInstance.data.headerCtrl;
      if (hdrCtrl == null || hdrCtrl.id == "Close") return;

      let aref: amount = <amount>ref.componentInstance.data.record;
      let pbket = ref.componentInstance.data.parentrecord;
      let panel: IcepanelSettings = <IcepanelSettings>ref.componentInstance.data.panel;
      if (panel != null && pbket != null && aref != null) {
        let form = panel.getForm();
        if (form != null && form.valid) {
          for (let isec = 0; isec < panel.sections.length; isec++) {
            let sec = panel.sections[isec];
            for (let ictrl = 0; ictrl < sec.controls.length; ictrl++) {
              let ctrl = sec.controls[ictrl];
              switch (ctrl.getControlName()) {
                case "amount_qualifier": {
                  amtref.amount_qualifier = ctrl.getFormControl().value;
                  break;
                }
                case "payer_id": {
                  AccountingService.setSubscriberAmountFromDDLKey(ctrl, aref)
                  break;
                }
                case "amount_value": {
                  amtref.amount_value = ctrl.getFormControl().value;
                  break;
                }
              }
            }
          }

          let cbucket = this.getSelectedClaimBucket(parentPyrBucket);
          if (cbucket == null) return "";

          if (amtref.offline_record_status == IceTypes.offlineRecStatus.offlineInsert) {
            amtref.amount_key = Iceutility.guid(true);
            if (clm == null)
              cbucket.COBS.push(amtref);
            else
              clm.COBS.push(amtref);
          }
          else {
            amtref.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;
          }

          if (clm != null) {
            if (clm.offline_record_status != IceTypes.offlineRecStatus.offlineInsert)
              clm.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;
          }

          if (cbucket.offline_record_status != IceTypes.offlineRecStatus.offlineInsert)
            cbucket.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;

          this.autoSavePayerBuckets([cbucket]).subscribe(
            data => {
              if (data != null) {
                amtref.offline_record_status = IceTypes.offlineRecStatus.offlineNoChange;
                if (clm == null)
                  this.loadClaimAmountsListControl(parentPyrBucket);
                else
                  this.loadItemAmountsListControl(parentPyrBucket, clm);

                this.resetChangedBuckets(<claimbucket[]>data);
              }
            },
            error => {
              console.log(error);
            });
        }
      }
    });

  }

  doTransportationPopup(parentPyrBucket: any, clmamb: claimambulance) {
    let descText = "";
    if (parentPyrBucket == null || clmamb == null) return;

    let pickup_ent_name = ""
    let entFnd = clmamb.ENTS.filter(e => e.entity_key == clmamb.pickup_entity_key);
    if (entFnd.length > 0) {
      let ent = entFnd[0];
      pickup_ent_name = ent.organization_name;
    }

    let pickupLocation = "";
    if (pickup_ent_name.length > 0)
      pickupLocation = JSON.stringify([{ name: pickup_ent_name, value: clmamb.pickup_trans_account }]);

    let dropoff_ent_name = "";
    entFnd = clmamb.ENTS.filter(e => e.entity_key == clmamb.dropoff_entity_key);
    if (entFnd.length > 0) {
      let ent = entFnd[0];
      dropoff_ent_name = ent.organization_name;
    }

    let dropoffLocation = "";
    if (dropoff_ent_name.length > 0)
      dropoffLocation = JSON.stringify([{ name: dropoff_ent_name, value: clmamb.dropoff_trans_account }]);

    let pickup_street1 = "", pickup_street2 = "", pickup_city = "", pickup_state_id = "", pickup_postal_code = "";
    let adrFnd = clmamb.ADS.filter(a => a.address_key == clmamb.pickup_address_key);
    if (adrFnd.length > 0) {
      let adr = adrFnd[0];
      pickup_street1 = adr.street1;
      pickup_street2 = adr.street2;
      pickup_city = adr.city;
      pickup_state_id = adr.state_id;
      pickup_postal_code = adr.postal_code;
    }

    let dropoff_street1 = "", dropoff_street2 = "", dropoff_city = "", dropoff_state_id = "", dropoff_postal_code = "";
    adrFnd = clmamb.ADS.filter(a => a.address_key == clmamb.dropoff_address_key);
    if (adrFnd.length > 0) {
      let adr = adrFnd[0];
      dropoff_street1 = adr.street1;
      dropoff_street2 = adr.street2;
      dropoff_city = adr.city;
      dropoff_state_id = adr.state_id;
      dropoff_postal_code = adr.postal_code;
    }

    let reasonCodeOptsCtrl: IcecontrolSettings = null, distanceCtrl: IcecontrolSettings = null, distanceUnitsCtrl: IcecontrolSettings = null;
    let transportPickupCtrl: IcecontrolSettings = null, transportPickupAddress1Ctrl: IcecontrolSettings = null, transportPickupAddress2Ctrl: IcecontrolSettings = null,
      transportPickupCityCtrl: IcecontrolSettings = null, transportPickupStateCtrl: IcecontrolSettings = null, transportPickupPostalCodeCtrl: IcecontrolSettings = null;
    let transportDropoffCtrl: IcecontrolSettings = null, transportDropoffAddress1Ctrl: IcecontrolSettings = null, transportDropoffAddress2Ctrl: IcecontrolSettings = null,
      transportDropoffCityCtrl: IcecontrolSettings = null, transportDropoffStateCtrl: IcecontrolSettings = null, transportDropoffPostalCodeCtrl: IcecontrolSettings = null;
    let sections: IcepanelsectionSettings[] = [
      new IcepanelsectionSettings("ReasonSection", { class: ["yalla"], styles: {} }, [],
        [reasonCodeOptsCtrl = new IcecontrolSettings("iceselect", { width: "400px" }, null, null, "ReasonOption", "Transport Reasons")
          .setControlName("ambulance_transport_reason_code")
          .createFormControl(clmamb.ambulance_transport_reason_code, [Validators.required])
          .setOptions(this.transportReasonOptions)], null),
      new IcepanelsectionSettings("DistanceSection", { class: ["yalla"], styles: {} }, [],
        [distanceCtrl = new IcecontrolSettings("iceinput", { width: "100px" }, null, null, "Distance", "Distance")
          .setControlName("transport_distance")
          .createFormControl(clmamb.transport_distance, [Validators.required])], null),
      new IcepanelsectionSettings("DistanceUnitsSection", { class: ["yalla"], styles: {} }, [],
        [distanceUnitsCtrl = new IcecontrolSettings("iceselect", { width: "400px" }, null, null, "Units", "Units")
          .setControlName("transport_distance_unit_code")
          .createFormControl(clmamb.transport_distance_unit_code, [Validators.required])
          .setOptions([{ value: "DH", name: "Miles" }])], null),
      new IcepanelsectionSettings("PickupProviderSection", { class: ["yalla"], styles: {} }, [],
        [transportPickupCtrl = new IcecontrolSettings("iceautocomplete", { menuItems: [], width: "400px" }, null, "PickupProvider", "PickupProvider", "Pickup Provider")
          .setControlName("pickup_trans_account")
          .createFormControl(pickupLocation, [])
          .setOptions(this.listOfFacilities)], null),
      new IcepanelsectionSettings("PickupAddress1Section", { class: ["yalla"], styles: {} }, [],
        [transportPickupAddress1Ctrl = new IcecontrolSettings("iceinput", { menuItems: [], width: "400px" }, null, null, "PickupAddress1", "Pickup Address 1")
          .setControlName("pickup_street1")
          .createFormControl(pickup_street1, [Validators.required])], null),
      new IcepanelsectionSettings("PickupAddress2Section", { class: ["yalla"], styles: {} }, [],
        [transportPickupAddress2Ctrl = new IcecontrolSettings("iceinput", { menuItems: [], width: "400px" }, null, null, "PickupAddress2", "Pickup Address 2")
          .setControlName("pickup_street2")
          .createFormControl(pickup_street2, [])], null),
      new IcepanelsectionSettings("PickupCitySection", { class: ["yalla"], styles: {} }, [],
        [transportPickupCityCtrl = new IcecontrolSettings("iceinput", { menuItems: [], width: "400px" }, null, null, "PickupCity", "Pickup City")
          .setControlName("pickup_city")
          .createFormControl(pickup_city, [Validators.required])], null),
      new IcepanelsectionSettings("PickupStateSection", { class: ["yalla"], styles: {} }, [],
        [transportPickupStateCtrl = new IcecontrolSettings("iceselect", { width: "400px" }, null, null, "PickupState", "Pickup State")
          .setControlName("pickup_state_id")
          .createFormControl(pickup_state_id, [Validators.required])], null),
      new IcepanelsectionSettings("PickupPostalCodeSection", { class: ["yalla"], styles: {} }, [],
        [transportPickupPostalCodeCtrl = new IcecontrolSettings("iceinput", { menuItems: [], width: "400px" }, null, null, "PickupPostalCode", "Pickup Postal Code")
          .setControlName("pickup_postal_code")
          .createFormControl(pickup_postal_code, [Validators.required])], null),
      new IcepanelsectionSettings("DropoffProviderSection", { class: ["yalla"], styles: {} }, [],
        [transportDropoffCtrl = new IcecontrolSettings("iceautocomplete", { menuItems: [], width: "400px" }, null, "DropoffProvider", "DropoffProvider", "Dropoff Provider")
          .setControlName("dropoff_trans_account")
          .createFormControl(dropoffLocation, [])
          .setMultipleSelection(false)
          .setOptions(this.listOfFacilities)], null),
      new IcepanelsectionSettings("DropoffAddress1Section", { class: ["yalla"], styles: {} }, [],
        [transportDropoffAddress1Ctrl = new IcecontrolSettings("iceinput", { menuItems: [], width: "400px" }, null, null, "DropoffAddress1", "Dropoff Address 1")
          .setControlName("dropoff_street1")
          .createFormControl(dropoff_street1, [Validators.required])], null),
      new IcepanelsectionSettings("DropoffAddress2Section", { class: ["yalla"], styles: {} }, [],
        [transportDropoffAddress2Ctrl = new IcecontrolSettings("iceinput", { menuItems: [], width: "400px" }, null, null, "DropoffAddress2", "Dropoff Address 2")
          .setControlName("dropoff_street2")
          .createFormControl(dropoff_street2, [Validators.required])], null),
      new IcepanelsectionSettings("DropoffCitySection", { class: ["yalla"], styles: {} }, [],
        [transportDropoffCityCtrl = new IcecontrolSettings("iceinput", { menuItems: [], width: "400px" }, null, null, "DropoffCity", "Dropoff City")
          .setControlName("dropoff_city")
          .createFormControl(dropoff_city, [Validators.required])], null),
      new IcepanelsectionSettings("DropoffStateSection", { class: ["yalla"], styles: {} }, [],
        [transportDropoffStateCtrl = new IcecontrolSettings("iceselect", { width: "400px" }, null, null, "DropoffState", "Dropoff State")
          .setControlName("dropoff_state_id")
          .createFormControl(dropoff_state_id, [Validators.required])], null),
      new IcepanelsectionSettings("DropoffPostalCodeSection", { class: ["yalla"], styles: {} }, [],
        [transportDropoffPostalCodeCtrl = new IcecontrolSettings("iceinput", { menuItems: [], width: "400px" }, null, null, "DropoffPostalCode", "Dropoff Postal Code")
          .setControlName("dropoff_postal_code")
          .createFormControl(dropoff_postal_code, [Validators.required])], null),
    ];

    this.appSvc.setStateIDList(this.medCodeSvc, transportPickupStateCtrl, "");
    this.appSvc.setStateIDList(this.medCodeSvc, transportDropoffStateCtrl, "");

    let headerControls = [
      new IcecontrolSettings("icesubmitbutton", { class: "fas fa-check", width: "50px" }, null, null, "Save"),
      new IcecontrolSettings("icecancelbutton", { class: "fas fa-times", width: "50px" }, null, null, "Close")
    ];

    this.transportValueDialogRef = this.dialog.open(IcepanelDialog, {
      height: '90%',
      width: '500px',
      data: {
        record: clmamb,
        parentrecord: parentPyrBucket,
        panel: new IcepanelSettings("", "", "Ambulance or Transport", "", sections, headerControls)
          .enableForm(),
      }
    });

    transportPickupCtrl.setMultipleSelection(false);

    var ref = this.transportValueDialogRef;
    this.transportValueDialogRef.afterClosed().subscribe(result => {
      if (ref.componentInstance == null || ref.componentInstance.data == null) return;
      let hdrCtrl: IcecontrolSettings = <IcecontrolSettings>ref.componentInstance.data.headerCtrl;
      if (hdrCtrl == null || hdrCtrl.id == "Close") return;

      let amb: claimambulance = <claimambulance>ref.componentInstance.data.record;
      let pbket = ref.componentInstance.data.parentrecord;
      let panel: IcepanelSettings = <IcepanelSettings>ref.componentInstance.data.panel;
      if (panel != null && pbket != null && amb != null) {
        let form = panel.getForm();
        if (form != null && form.valid) {
          for (let isec = 0; isec < panel.sections.length; isec++) {
            let sec = panel.sections[isec];
            for (let ictrl = 0; ictrl < sec.controls.length; ictrl++) {
              let ctrl = sec.controls[ictrl];
              switch (ctrl.getControlName()) {
                case "ambulance_transport_reason_code": {
                  clmamb.ambulance_transport_reason_code = ctrl.getFormControl().value;
                  break;
                }
                case "transport_distance": {
                  clmamb.transport_distance = ctrl.getFormControl().value; // To do: this should be a number with 2 place precision
                  break;
                }
                case "transport_distance_unit_code": {
                  clmamb.transport_distance_unit_code = ctrl.getFormControl().value;
                  break;
                }
                case "pickup_trans_account": {
                  let pickUp = ctrl.getFormControl().value;
                  let fndEnt: entity[] = [];
                  if (clmamb.pickup_entity_key.length == 0) {
                    let ent = new entity();
                    ent.entity_key = clmamb.pickup_entity_key = Iceutility.guid(true);
                    fndEnt.push(ent);
                    clmamb.ENTS.push(ent);
                  }
                  else {
                    fndEnt = clmamb.ENTS.filter(e => e.entity_key == clmamb.pickup_entity_key);
                  }

                  try {
                    let pUpObj = JSON.parse(pickUp);
                    if (pUpObj && pUpObj.length > 0) {
                      clmamb.pickup_trans_account = pUpObj[0].value;
                      clmamb.pickup_account_type = IceTypes.ACCOUNT_TYPE.actFacility;
                      if (fndEnt.length > 0) {
                        fndEnt[0].organization_name = pUpObj[0].name;
                      }
                    }
                    else {
                      clmamb.pickup_trans_account = "";
                      clmamb.pickup_account_type = IceTypes.ACCOUNT_TYPE.actNone;
                      if (fndEnt.length > 0) {
                        fndEnt[0].organization_name = pickUp;
                      }
                    }
                  }
                  catch (e) {
                    console.log(e);
                    clmamb.pickup_trans_account = "";
                    clmamb.pickup_account_type = IceTypes.ACCOUNT_TYPE.actNone;
                    let pickUpOptAC: FormControl = ctrl.optionAutoCompleteFormControl;
                    if (pickUpOptAC != null && fndEnt.length > 0) {
                      fndEnt[0].organization_name = pickUpOptAC.value;
                    }
                  }
                  break;
                }
                case "pickup_street1": {
                  let fndAdr: address[] = [];
                  if (clmamb.pickup_address_key.length == 0) {
                    let adr = new address();
                    adr.address_key = clmamb.pickup_address_key = Iceutility.guid(true);
                    fndAdr.push(adr);
                    clmamb.ADS.push(adr);
                  }
                  else {
                    fndAdr = clmamb.ADS.filter(a => a.address_key == clmamb.pickup_address_key);
                  }

                  if (fndAdr.length > 0) {
                    fndAdr[0].street1 = ctrl.getFormControl().value;
                  }
                  break;
                }
                case "pickup_street2": {
                  let fndAdr = clmamb.ADS.filter(a => a.address_key == clmamb.pickup_address_key);
                  if (fndAdr.length > 0) {
                    fndAdr[0].street2 = ctrl.getFormControl().value;
                  }
                  break;
                }
                case "pickup_state_id": {
                  let fndAdr = clmamb.ADS.filter(a => a.address_key == clmamb.pickup_address_key);
                  if (fndAdr.length > 0) {
                    fndAdr[0].state_id = ctrl.getFormControl().value;
                  }
                  break;
                }
                case "pickup_city": {
                  let fndAdr = clmamb.ADS.filter(a => a.address_key == clmamb.pickup_address_key);
                  if (fndAdr.length > 0) {
                    fndAdr[0].city = ctrl.getFormControl().value;
                  }
                  break;
                }
                case "pickup_postal_code": {
                  let fndAdr = clmamb.ADS.filter(a => a.address_key == clmamb.pickup_address_key);
                  if (fndAdr.length > 0) {
                    fndAdr[0].postal_code = ctrl.getFormControl().value;
                  }
                  break;
                }
                case "dropoff_trans_account": {
                  let dropOff = ctrl.getFormControl().value;
                  let fndEnt: entity[] = [];
                  if (clmamb.dropoff_entity_key.length == 0) {
                    let ent = new entity();
                    ent.entity_key = clmamb.dropoff_entity_key = Iceutility.guid(true);
                    fndEnt.push(ent);
                    clmamb.ENTS.push(ent);
                  }
                  else {
                    fndEnt = clmamb.ENTS.filter(e => e.entity_key == clmamb.dropoff_entity_key);
                  }

                  try {
                    let dOffObj = JSON.parse(dropOff);
                    if (dOffObj && dOffObj.length > 0) {
                      clmamb.dropoff_trans_account = dOffObj[0].value;
                      clmamb.dropoff_account_type = IceTypes.ACCOUNT_TYPE.actFacility;
                      if (fndEnt.length > 0) {
                        fndEnt[0].organization_name = dOffObj[0].name;
                      }
                    }
                    else {
                      clmamb.dropoff_trans_account = "";
                      clmamb.dropoff_account_type = IceTypes.ACCOUNT_TYPE.actNone;
                      if (fndEnt.length > 0) {
                        fndEnt[0].organization_name = dropOff;
                      }
                    }
                  }
                  catch (e) {
                    console.log(e);
                    clmamb.dropoff_trans_account = "";
                    clmamb.dropoff_account_type = IceTypes.ACCOUNT_TYPE.actNone;
                    let dropOffOptAC: FormControl = ctrl.optionAutoCompleteFormControl;
                    if (dropOffOptAC != null && fndEnt.length > 0) {
                      fndEnt[0].organization_name = dropOffOptAC.value;
                    }
                  }
                  break;
                }
                case "dropoff_street1": {
                  let fndAdr: address[] = [];
                  if (clmamb.dropoff_address_key.length == 0) {
                    let adr = new address();
                    adr.address_key = clmamb.dropoff_address_key = Iceutility.guid(true);
                    fndAdr.push(adr);
                    clmamb.ADS.push(adr);
                  }
                  else {
                    fndAdr = clmamb.ADS.filter(a => a.address_key == clmamb.dropoff_address_key);
                  }

                  if (fndAdr.length > 0) {
                    fndAdr[0].street1 = ctrl.getFormControl().value;
                  }
                  break;
                }
                case "dropoff_street2": {
                  let fndAdr = clmamb.ADS.filter(a => a.address_key == clmamb.dropoff_address_key);
                  if (fndAdr.length > 0) {
                    fndAdr[0].street2 = ctrl.getFormControl().value;
                  }
                  break;
                }
                case "dropoff_state_id": {
                  let fndAdr = clmamb.ADS.filter(a => a.address_key == clmamb.dropoff_address_key);
                  if (fndAdr.length > 0) {
                    fndAdr[0].state_id = ctrl.getFormControl().value;
                  }
                  break;
                }
                case "dropoff_city": {
                  let fndAdr = clmamb.ADS.filter(a => a.address_key == clmamb.dropoff_address_key);
                  if (fndAdr.length > 0) {
                    fndAdr[0].city = ctrl.getFormControl().value;
                  }
                  break;
                }
                case "dropoff_postal_code": {
                  let fndAdr = clmamb.ADS.filter(a => a.address_key == clmamb.dropoff_address_key);
                  if (fndAdr.length > 0) {
                    fndAdr[0].postal_code = ctrl.getFormControl().value;
                  }
                  break;
                }
              }
            }
          }

          let cbucket = this.getSelectedClaimBucket(parentPyrBucket);
          if (cbucket == null) return "";

          if (clmamb.offline_record_status == IceTypes.offlineRecStatus.offlineInsert) {
            clmamb.claim_ambulance_key = Iceutility.guid(true);
            cbucket.AMBS.push(clmamb);
          }
          else {
            clmamb.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;
          }

          if (cbucket.offline_record_status != IceTypes.offlineRecStatus.offlineInsert)
            cbucket.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;

          this.autoSavePayerBuckets([cbucket]).subscribe(
            data => {
              if (data != null) {
                clmamb.offline_record_status = IceTypes.offlineRecStatus.offlineNoChange;
                this.loadClaimAmbulanceTransportListControl(parentPyrBucket);
                this.resetChangedBuckets(<claimbucket[]>data);
              }
            },
            error => {
              console.log(error);
            });
        }
      }
    });
  }

  doContractPopup(parentPyrBucket: any, clmctrct: claimcontract) {
    let descText = "";
    if (parentPyrBucket == null || clmctrct == null) return;

    let contractTypeOptsCtrl: IcecontrolSettings = null, contractPriceCtrl: IcecontrolSettings = null, contractPercentageCtrl: IcecontrolSettings = null;
    let contractCodeCtrl: IcecontrolSettings = null, termsDiscountPercentageCtrl: IcecontrolSettings = null, versionIdentifierCtrl: IcecontrolSettings = null;
    let sections: IcepanelsectionSettings[] = [
      new IcepanelsectionSettings("ContractOptionSection", { class: ["yalla"], styles: {} }, [],
        [contractTypeOptsCtrl = new IcecontrolSettings("iceselect", { width: "300px" }, null, null, "ContractTypeOptions", "Contract Types")
          .setControlName("contract_type_code")
          .createFormControl(clmctrct.contract_type_code, [Validators.required])
          .setOptions(this.contractTypeCodeOptions)], null),
      new IcepanelsectionSettings("ContractPriceSection", { class: ["yalla"], styles: {} }, [],
        [contractPriceCtrl = new IcecontrolSettings("iceinput", { width: "100%", inputType: "number" }, null, null, "ContractPrice", "Price")
          .setControlName("price")
          .createFormControl(clmctrct.price, [])], null),
      new IcepanelsectionSettings("ContractPercentageSection", { class: ["yalla"], styles: {} }, [],
        [contractPercentageCtrl = new IcecontrolSettings("iceinput", { width: "100%", inputType: "number" }, null, null, "ContractPercentage", "Percentage")
          .setControlName("percentage")
          .createFormControl(clmctrct.percentage, [])], null),
      new IcepanelsectionSettings("ContractCodeSection", { class: ["yalla"], styles: {} }, [],
        [contractCodeCtrl = new IcecontrolSettings("iceinput", { width: "100%" }, null, null, "ContractCode", "Contract Code")
          .setControlName("contract_code")
          .createFormControl(clmctrct.contract_code, [])], null),
      new IcepanelsectionSettings("TermsDiscountPercentageSection", { class: ["yalla"], styles: {} }, [],
        [termsDiscountPercentageCtrl = new IcecontrolSettings("iceinput", { width: "100%", inputType: "number" }, null, null, "TermsDiscountPercentage", "Discount Percentage")
          .setControlName("terms_discount_percentage")
          .createFormControl(clmctrct.terms_discount_percentage, [])], null),
      new IcepanelsectionSettings("VersionIdentifierSection", { class: ["yalla"], styles: {} }, [],
        [versionIdentifierCtrl = new IcecontrolSettings("iceinput", { width: "100%" }, null, null, "VersionIdentifier", "Contract Version")
          .setControlName("version_identifier")
          .createFormControl(clmctrct.version_identifier, [])], null),
    ];

    let headerControls = [
      new IcecontrolSettings("icesubmitbutton", { class: "fas fa-check", width: "50px" }, null, null, "Save"),
      new IcecontrolSettings("icecancelbutton", { class: "fas fa-times", width: "50px" }, null, null, "Close")
    ];

    this.transportValueDialogRef = this.dialog.open(IcepanelDialog, {
      height: '600px',
      width: '400px',
      data: {
        record: clmctrct,
        parentrecord: parentPyrBucket,
        panel: new IcepanelSettings("", "", "Payer-Provider Contract", "", sections, headerControls)
          .enableForm(),
      }
    });

    var ref = this.transportValueDialogRef;
    this.transportValueDialogRef.afterClosed().subscribe(result => {
      if (ref.componentInstance == null || ref.componentInstance.data == null) return;
      let hdrCtrl: IcecontrolSettings = <IcecontrolSettings>ref.componentInstance.data.headerCtrl;
      if (hdrCtrl == null || hdrCtrl.id == "Close") return;

      let amb: claimambulance = <claimambulance>ref.componentInstance.data.record;
      let pbket = ref.componentInstance.data.parentrecord;
      let panel: IcepanelSettings = <IcepanelSettings>ref.componentInstance.data.panel;
      if (panel != null && pbket != null && amb != null) {
        let form = panel.getForm();
        if (form != null && form.valid) {
          for (let isec = 0; isec < panel.sections.length; isec++) {
            let sec = panel.sections[isec];
            for (let ictrl = 0; ictrl < sec.controls.length; ictrl++) {
              let ctrl = sec.controls[ictrl];
              switch (ctrl.getControlName()) {
                case "contract_type_code": {
                  clmctrct.contract_type_code = ctrl.getFormControl().value;
                  break;
                }
                case "price": {
                  clmctrct.price = ctrl.getFormControl().value;
                  break;
                }
                case "percentage": {
                  clmctrct.percentage = ctrl.getFormControl().value;
                  break;
                }
                case "contract_code": {
                  clmctrct.contract_code = ctrl.getFormControl().value;
                  break;
                }
                case "terms_discount_percentage": {
                  clmctrct.terms_discount_percentage = ctrl.getFormControl().value;
                  break;
                }
                case "version_identifier": {
                  clmctrct.version_identifier = ctrl.getFormControl().value;
                  break;
                }
              }
            }
          }

          let cbucket = this.getSelectedClaimBucket(parentPyrBucket);
          if (cbucket == null) return "";

          if (clmctrct.offline_record_status == IceTypes.offlineRecStatus.offlineInsert) {
            clmctrct.claim_contract_key = Iceutility.guid(true);
            cbucket.CNTRCS.push(clmctrct);
          }
          else {
            clmctrct.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;
          }

          if (cbucket.offline_record_status != IceTypes.offlineRecStatus.offlineInsert)
            cbucket.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;

          this.autoSavePayerBuckets([cbucket]).subscribe(
            data => {
              if (data != null) {
                clmctrct.offline_record_status = IceTypes.offlineRecStatus.offlineNoChange;
                this.loadClaimContractInformationListControl(parentPyrBucket);
                this.resetChangedBuckets(<claimbucket[]>data);
              }
            },
            error => {
              console.log(error);
            });
        }
      }
    });
  }

  doAttachmentPopup(parentPyrBucket: any, clm: claim, clmattach: claimsupplementalinformation) {
    let descText = "";
    if (parentPyrBucket == null || clmattach == null) return;

    let docsOpts = [{ name: "<Select Existing Document or Note>", value: "" }];
    for (let i = 0; i < this.allAttachments.length; i++) {
      let doc: externaldata = <externaldata>this.allAttachments[i];
      if (doc == null) continue;
      let desc = Iceutility.getDateTextEx(doc.external_reference_date, null, true) + " Document: " + AccountingService.getSourceType(Iceutility.toLong(doc.src_type)) + " " + doc.title;
      let opt = {
        name: desc, value: doc.external_data_key,
        date: Iceutility.GetLocalDate(doc.external_reference_date).getTime(),
        obj: doc
      };
      docsOpts.push(opt);
    }

    let dupNote = {};

    for (let i = 0; i < this.allDiagnoses.length; i++) {
      let diag: diagnosis = <diagnosis>this.allDiagnoses[i];
      if (diag == null) continue;
      for (let inte = 0; inte < diag.NOTES.length; inte++) {
        let nte = diag.NOTES[inte];
        if (dupNote[nte.encounter_progress_notes_key] != null) continue;

        let fndNote = this.allNotes.filter(n => n.encounter_progress_notes_key == nte.encounter_progress_notes_key);
        if (fndNote.length > 0) {
          let desc = Iceutility.getDateTextEx(fndNote[0].note_date, null, true) + " Notes: " + AccountingService.getSourceType(Iceutility.toLong(fndNote[0].src_type)) + ", " + fndNote[0].plain_text.substr(0, 30) + "...";
          let opt = {
            name: desc, value: nte.encounter_progress_notes_key,
            date: Iceutility.GetLocalDate(fndNote[0].note_date).getTime(),
            srctype: Iceutility.toLong(fndNote[0].src_type),
            srckey: fndNote[0].src_key,
            obj: fndNote[0]
          };
          docsOpts.push(opt);
          dupNote[nte.encounter_progress_notes_key] = true;
        }
      }

      for (let iob = 0; iob < diag.OBSERVS.length; iob++) {
        let ob = diag.OBSERVS[iob];
        let desc = Iceutility.getDateTextEx(ob.observation_date, null, false)
          + " Observation: " + PatientService.getObservationType(ob.observation_type)
          + ", " + PatientService.getSeverityType(ob.severity_type)
          + ", " + ob.description;
        let opt = {
          name: desc, value: ob.observation_key,
          date: Iceutility.GetLocalDate(ob.observation_date).getTime(),
          srctype: IceTypes.SourceType.srcDiagnosis,
          srckey: diag.diagnosis_key,
          obj: ob
        }
        docsOpts.push(opt);
      }
    }

    for (let inte = 0; inte < this.allNotes.length; inte++) {
      let nte = this.allNotes[inte];
      if (dupNote[nte.encounter_progress_notes_key] != null) continue;

      let desc = Iceutility.getDateTextEx(nte.note_date, null, true) + " Notes: " + AccountingService.getSourceType(Iceutility.toLong(nte.src_type)) + ", " + nte.plain_text.substr(0, 30) + "...";
      let opt = {
        name: desc, value: nte.encounter_progress_notes_key,
        date: Iceutility.GetLocalDate(nte.note_date).getTime(),
        srctype: Iceutility.toLong(nte.src_type),
        srckey: nte.src_key,
        obj: nte
      };
      docsOpts.push(opt);
      dupNote[nte.encounter_progress_notes_key] = true;
    }

    docsOpts.sort((a, b) => {
      let aV: number = a["date"];
      let bV: number = b["date"];
      return bV - aV;
    });

    let key = "";
    if (clmattach.encounter_progress_notes_key.length > 0)
      key = clmattach.encounter_progress_notes_key;
    else if (clmattach.external_data_key.length > 0)
      key = clmattach.external_data_key
    else if (clmattach.observation_key.length > 0)
      key = clmattach.observation_key;

    let attachmentOptsCtrl: IcecontrolSettings = null, reportTypeOptionsCtrl: IcecontrolSettings = null, reportTransmissionCtrl: IcecontrolSettings = null,
      attachmentDetailsCtrl: IcecontrolSettings = null;
    let sections: IcepanelsectionSettings[] = [
      new IcepanelsectionSettings("AttachmentSection", { class: ["yalla"], styles: {} }, [],
        [attachmentOptsCtrl = new IcecontrolSettings("iceselect", { width: "500px" }, null, null, "AttachmentOptions", "Attachments")
          .setControlName("key")
          .createFormControl(key, [Validators.required])
          .setOptions(docsOpts)], null),
      new IcepanelsectionSettings("ReportTypeSection", { class: ["yalla"], styles: {} }, [],
        [reportTypeOptionsCtrl = new IcecontrolSettings("iceselect", { width: "300px" }, null, null, "ReportTypeOptions", "Report Types")
          .setControlName("report_type_code")
          .createFormControl(clmattach.report_type_code, [Validators.required])
          .setOptions(this.attachmentReportTypeOptions)], null),
      new IcepanelsectionSettings("ReportTransmissionSection", { class: ["yalla"], styles: {} }, [],
        [reportTransmissionCtrl = new IcecontrolSettings("iceselect", { width: "100%" }, null, null, "ReportTransmission", "Report Transmission")
          .setControlName("report_transmission_code")
          .createFormControl(clmattach.report_transmission_code, [])
          .setOptions(this.reportTransmissionCodeOptions)], null),
      new IcepanelsectionSettings("AttachmentDescSection", { class: ["yalla"], styles: {} }, [],
        [attachmentDetailsCtrl = new IcecontrolSettings("icetextarea", { width: "500px", height: "300px" }, null, null, "Description", "Description")
          .setControlName("description")
          .createFormControl(descText, [])
          .setReadonly(true)
        ], null),    ];

    let headerControls = [
      new IcecontrolSettings("icesubmitbutton", { class: "fas fa-check", width: "50px" }, null, null, "Save"),
      new IcecontrolSettings("icecancelbutton", { class: "fas fa-times", width: "50px" }, null, null, "Close")
    ];

    this.transportValueDialogRef = this.dialog.open(IcepanelDialog, {
      height: '400px',
      width: '600px',
      data: {
        record: clmattach,
        parentrecord: parentPyrBucket,
        panel: new IcepanelSettings("", "", "Attachment", "", sections, headerControls)
          .enableForm(),
      }
    });

    let fnSetDetails: Function = (ctrl: IcecontrolSettings) => {
      let fndOpt = ctrl.getOptions().filter(o => o.value == ctrl.getFormControl().value);
      if (fndOpt.length > 0 && fndOpt[0].obj) {
        switch (fndOpt[0].obj.gettablename()) {
          case "EXTERNAL_DATA": {
            let ext: externaldata = fndOpt[0].obj;
            if (ext != null) {
              let dtls = ext.title;
              attachmentDetailsCtrl.getFormControl().setValue(dtls);
            }
            break;
          }
          case "ENCOUNTER_PROGRESS_NOTES": {
            let nte: encounterprogressnotes = fndOpt[0].obj;
            if (nte != null) {
              let dtls = nte.plain_text;
              attachmentDetailsCtrl.getFormControl().setValue(dtls);
            }
            break;
          }
          case "OBSERVATION": {
            let ob: observation = fndOpt[0].obj;
            if (ob != null) {
              let dtls = ob.description;
              attachmentDetailsCtrl.getFormControl().setValue(dtls);
            }
            break;
          }
        }
      }
    };

    attachmentOptsCtrl.createChangeControlEvent().subscribe(
      event => {
        attachmentDetailsCtrl.getFormControl().setValue("");
        if (event.selectSettings) {
          fnSetDetails(event.selectSettings);
        }
      },
      error => {
        console.log(error);
      }
    );

    fnSetDetails(attachmentOptsCtrl);

    var ref = this.transportValueDialogRef;
    this.transportValueDialogRef.afterClosed().subscribe(result => {
      if (ref.componentInstance == null || ref.componentInstance.data == null) return;
      let hdrCtrl: IcecontrolSettings = <IcecontrolSettings>ref.componentInstance.data.headerCtrl;
      if (hdrCtrl == null || hdrCtrl.id == "Close") return;

      let clmsupl: claimsupplementalinformation = <claimsupplementalinformation>ref.componentInstance.data.record;
      let pbket = ref.componentInstance.data.parentrecord;
      let panel: IcepanelSettings = <IcepanelSettings>ref.componentInstance.data.panel;
      if (panel != null && pbket != null && clmsupl != null) {
        let form = panel.getForm();
        if (form != null && form.valid) {
          for (let isec = 0; isec < panel.sections.length; isec++) {
            let sec = panel.sections[isec];
            for (let ictrl = 0; ictrl < sec.controls.length; ictrl++) {
              let ctrl = sec.controls[ictrl];
              switch (ctrl.getControlName()) {
                case "key": {
                  let fndOpt = ctrl.getOptions().filter(o => o.value == ctrl.getFormControl().value);
                  if (fndOpt.length > 0 && fndOpt[0].obj) {
                    switch (fndOpt[0].obj.gettablename()) {
                      case "EXTERNAL_DATA": {
                        let ext: externaldata = fndOpt[0].obj;
                        if (ext != null) {
                          clmattach.external_data_key = ext.external_data_key;
                          clmattach.encounter_key = "";
                          clmattach.diagnosis_key = "";
                          clmattach.encounter_progress_notes_key = "";
                          clmattach.observation_key = "";
                        }
                        break;
                      }
                      case "ENCOUNTER_PROGRESS_NOTES": {
                        let nte: encounterprogressnotes = fndOpt[0].obj;
                        if (nte != null) {
                          clmattach.external_data_key = "";
                          switch (Iceutility.toLong(nte.src_type)) {
                            case IceTypes.SourceType.srcDiagnosis: {
                              clmattach.diagnosis_key = nte.src_key;
                              break;
                            }
                            case IceTypes.SourceType.srcEncounterNotes: {
                              clmattach.encounter_key = nte.src_key;
                              break;
                            }
                          }
                          clmattach.encounter_progress_notes_key = nte.encounter_progress_notes_key;
                          clmattach.observation_key = "";
                        }
                        break;
                      }
                      case "OBSERVATION": {
                        let ob: observation = fndOpt[0].obj;
                        if (ob != null) {
                          clmattach.external_data_key = "";
                          clmattach.encounter_key = "";
                          clmattach.encounter_progress_notes_key = "";
                          clmattach.observation_key = ob.observation_key;
                          switch (fndOpt[0].srctype) {
                            case IceTypes.SourceType.srcDiagnosis: {
                              clmattach.diagnosis_key = fndOpt[0].srckey;
                              break;
                            }
                          }
                        }
                        break;
                      }
                    }
                  }
                  else {
                    clmattach.external_data_key = "";
                    clmattach.encounter_key = "";
                    clmattach.diagnosis_key = "";
                    clmattach.encounter_progress_notes_key = "";
                    clmattach.observation_key = "";
                  }
                  break;
                }
                case "report_type_code": {
                  clmattach.report_type_code = ctrl.getFormControl().value;
                  break;
                }
                case "report_transmission_code": {
                  clmattach.report_transmission_code = ctrl.getFormControl().value;
                  break;
                }
              }
            }
          }

          let cbucket = this.getSelectedClaimBucket(parentPyrBucket);
          if (cbucket == null) return;

          if (clmattach.offline_record_status == IceTypes.offlineRecStatus.offlineInsert) {
            clmattach.claim_supplemental_information_key = Iceutility.guid(true);
            if (clm == null)
              cbucket.SUPPL.push(clmattach);
            else 
              clm.SUPPL.push(clmattach);
          }
          else {
            clmattach.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;
          }

          if (clm != null) {
            if (clm.offline_record_status != IceTypes.offlineRecStatus.offlineInsert)
              clm.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;
          }

          if (cbucket.offline_record_status != IceTypes.offlineRecStatus.offlineInsert)
            cbucket.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;

          this.autoSavePayerBuckets([cbucket]).subscribe(
            data => {
              if (data != null) {
                clmattach.offline_record_status = IceTypes.offlineRecStatus.offlineNoChange;
                if (clm == null)
                  this.loadClaimAttachmentsListControl(parentPyrBucket);
                else
                  this.loadItemAttachmentsListControl(parentPyrBucket, clm);

                this.resetChangedBuckets(<claimbucket[]>data);
              }
            },
            error => {
              console.log(error);
            });
        }
      }
    });
  }

  doNotesPopup(parentPyrBucket: payerbucket, clm: claim, clmnote: claimnote) {
    let descText = "";
    if (parentPyrBucket == null || clmnote == null) return;

    let noteDetailsCtrl: IcecontrolSettings = null;
    let sections: IcepanelsectionSettings[] = [
      new IcepanelsectionSettings("NoteDescSection", { class: ["yalla"], styles: {} }, [],
        [noteDetailsCtrl = new IcecontrolSettings("icetextarea", { width: "500px", height: "300px" }, null, null, "Description", "Description")
          .setControlName("description")
          .createFormControl(clmnote.description, [])
        ], null),];

    let headerControls = [
      new IcecontrolSettings("icesubmitbutton", { class: "fas fa-check", width: "50px" }, null, null, "Save"),
      new IcecontrolSettings("icecancelbutton", { class: "fas fa-times", width: "50px" }, null, null, "Close")
    ];

    this.transportValueDialogRef = this.dialog.open(IcepanelDialog, {
      height: '400px',
      width: '600px',
      data: {
        record: clmnote,
        parentrecord: parentPyrBucket,
        panel: new IcepanelSettings("", "", "Note", "", sections, headerControls)
          .enableForm(),
      }
    });

    var ref = this.transportValueDialogRef;
    this.transportValueDialogRef.afterClosed().subscribe(result => {
      if (ref.componentInstance == null || ref.componentInstance.data == null) return;
      let hdrCtrl: IcecontrolSettings = <IcecontrolSettings>ref.componentInstance.data.headerCtrl;
      if (hdrCtrl == null || hdrCtrl.id == "Close") return;

      let clmnte: claimnote = <claimnote>ref.componentInstance.data.record;
      let pbket = ref.componentInstance.data.parentrecord;
      let panel: IcepanelSettings = <IcepanelSettings>ref.componentInstance.data.panel;
      if (panel != null && pbket != null && clmnte != null) {
        let form = panel.getForm();
        if (form != null && form.valid) {
          for (let isec = 0; isec < panel.sections.length; isec++) {
            let sec = panel.sections[isec];
            for (let ictrl = 0; ictrl < sec.controls.length; ictrl++) {
              let ctrl = sec.controls[ictrl];
              switch (ctrl.getControlName()) {
                case "description": {
                  clmnote.description = ctrl.getFormControl().value;
                  break;
                }
              }
            }
          }

          let cbucket = this.getSelectedClaimBucket(parentPyrBucket);
          if (cbucket == null) return;

          if (clmnote.offline_record_status == IceTypes.offlineRecStatus.offlineInsert) {
            clmnote.claim_note_key = Iceutility.guid(true);
            if (clm == null)
              cbucket.CLMNOTES.push(clmnote);
            else
              clm.CLMNOTES.push(clmnote);
          }
          else {
            clmnote.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;
          }

          if (clm != null) {
            if (clm.offline_record_status != IceTypes.offlineRecStatus.offlineInsert)
              clm.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;
          }
          if (cbucket.offline_record_status != IceTypes.offlineRecStatus.offlineInsert)
            cbucket.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;

          this.autoSavePayerBuckets([cbucket]).subscribe(
            data => {
              if (data != null) {
                clmnote.offline_record_status = IceTypes.offlineRecStatus.offlineNoChange;
                if (clm == null)
                  this.loadClaimNotesListControl(parentPyrBucket);
                else
                  this.loadItemNotesListControl(parentPyrBucket, clm);

                this.resetChangedBuckets(<claimbucket[]>data);
              }
            },
            error => {
              console.log(error);
            });
        }
      }
    });
  }

  doRefreshItemPopup(parentPyrBucket: payerbucket, clm: claim, svcChanges: string[], clmChanges: string[]) {
    if (parentPyrBucket == null || clm == null) return;

    let svcDetailsCtrl: IcecontrolSettings = null, clmDetailsCtrl: IcecontrolSettings = null;
    let sections: IcepanelsectionSettings[] = [
      new IcepanelsectionSettings("RefreshItemSection", { class: ["yalla"], styles: {} }, [],
        [
          svcDetailsCtrl = new IcecontrolSettings("icetextarea", { width: "500px", height: "300px" }, null, null, "ServiceRecord", "Service Record Latest Changes")
            .setControlName("service_changes")
            .createFormControl(svcChanges.join('\n'), [])
            .setReadonly(true),
          clmDetailsCtrl = new IcecontrolSettings("icetextarea", { width: "500px", height: "300px" }, null, null, "ClaimRecord", "Claim Item #" + clm.claim_key)
            .setControlName("claim_changes")
            .createFormControl(clmChanges.join('\n'), [])
            .setReadonly(true)
        ], null),];

    let headerControls = [
      new IcecontrolSettings("icesubmitbutton", { class: "fas fa-check", width: "50px" }, null, null, "Save"),
      new IcecontrolSettings("icecancelbutton", { class: "fas fa-times", width: "50px" }, null, null, "Close")
    ];

    this.transportValueDialogRef = this.dialog.open(IcepanelDialog, {
      height: '500px',
      width: '600px',
      data: {
        record: clm,
        parentrecord: parentPyrBucket,
        panel: new IcepanelSettings("", "", "Refresh Claim Item", "", sections, headerControls)
          .enableForm(),
      }
    });

    var ref = this.transportValueDialogRef;
    this.transportValueDialogRef.afterClosed().subscribe(result => {
      if (ref.componentInstance == null || ref.componentInstance.data == null) return;
      let hdrCtrl: IcecontrolSettings = <IcecontrolSettings>ref.componentInstance.data.headerCtrl;
      if (hdrCtrl == null || hdrCtrl.id == "Close") return;

      let clmnte: claimnote = <claimnote>ref.componentInstance.data.record;
      let pbket = ref.componentInstance.data.parentrecord;
      let panel: IcepanelSettings = <IcepanelSettings>ref.componentInstance.data.panel;
      if (panel != null && pbket != null && clmnte != null) {
        let form = panel.getForm();
        if (form != null && form.valid) {
          for (let isec = 0; isec < panel.sections.length; isec++) {
            let sec = panel.sections[isec];
            for (let ictrl = 0; ictrl < sec.controls.length; ictrl++) {
              let ctrl = sec.controls[ictrl];
              switch (ctrl.getControlName()) {
                case "service_changes": {
                  //clmnote.description = ctrl.getFormControl().value;
                  break;
                }
                case "claim_changes": {
                  //clmnote.description = ctrl.getFormControl().value;
                  break;
                }
              }
            }
          }

          let cbucket = this.getSelectedClaimBucket(parentPyrBucket);
          if (cbucket == null) return;

          this.acctSvc.refreshClaimBuckets(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), [cbucket], clm.claim_key, []).subscribe(
            data => {
              if (data != null && data.length > 0) {
                let cbuck: claimbucket = data[0];
                if (cbuck == null) return;
                // remove clm from memory
                cbucket.CLMS = cbucket.CLMS.filter(c => c.claim_key != clm.claim_key);
                // insert refreshed clm into memory 
                let fndClm = cbuck.CLMS.filter(c => c.claim_key == clm.claim_key);
                if (fndClm.length > 0)
                  cbucket.CLMS.push(fndClm[0]);

                // update view
                this.updateSelectedClaim(parentPyrBucket, clm.medical_service_key, clm.claim_key);
              }
            },
            error => {
              console.log(error);
            });
        }
      }
    });
  }

  doRefreshBucketPopup(parentPyrBucket: payerbucket, svcChanges: string[], clmChanges: string[]) {
    if (parentPyrBucket == null) return;

    let svcDetailsCtrl: IcecontrolSettings = null, clmDetailsCtrl: IcecontrolSettings = null;
    let sections: IcepanelsectionSettings[] = [
      new IcepanelsectionSettings("RefreshBucketSection", { class: ["yalla"], styles: {} }, [],
        [
          svcDetailsCtrl = new IcecontrolSettings("icetextarea", { width: "500px", height: "300px" }, null, null, "ServiceRecord", "Service Record(s) Latest Changes")
            .setControlName("service_changes")
            .createFormControl(svcChanges.join('\n'), [])
            .setReadonly(true),
          clmDetailsCtrl = new IcecontrolSettings("icetextarea", { width: "500px", height: "300px" }, null, null, "ClaimRecord", "Claim Item(s)")
            .setControlName("claim_changes")
            .createFormControl(clmChanges.join('\n'), [])
            .setReadonly(true)
        ], null),];

    let headerControls = [
      new IcecontrolSettings("icesubmitbutton", { class: "fas fa-check", width: "50px" }, null, null, "Save"),
      new IcecontrolSettings("icecancelbutton", { class: "fas fa-times", width: "50px" }, null, null, "Close")
    ];

    this.transportValueDialogRef = this.dialog.open(IcepanelDialog, {
      height: '500px',
      width: '600px',
      data: {
        record: null,
        parentrecord: parentPyrBucket,
        panel: new IcepanelSettings("", "", "Refresh Claim Bucket", "", sections, headerControls)
          .enableForm(),
      }
    });

    var ref = this.transportValueDialogRef;
    this.transportValueDialogRef.afterClosed().subscribe(result => {
      if (ref.componentInstance == null || ref.componentInstance.data == null) return;
      let hdrCtrl: IcecontrolSettings = <IcecontrolSettings>ref.componentInstance.data.headerCtrl;
      if (hdrCtrl == null || hdrCtrl.id == "Close") return;

      let pbket = ref.componentInstance.data.parentrecord;
      let panel: IcepanelSettings = <IcepanelSettings>ref.componentInstance.data.panel;
      if (panel != null && pbket != null) {
        let form = panel.getForm();
        if (form != null && form.valid) {
          for (let isec = 0; isec < panel.sections.length; isec++) {
            let sec = panel.sections[isec];
            for (let ictrl = 0; ictrl < sec.controls.length; ictrl++) {
              let ctrl = sec.controls[ictrl];
              switch (ctrl.getControlName()) {
                case "service_changes": {
                  //clmnote.description = ctrl.getFormControl().value;
                  break;
                }
                case "claim_changes": {
                  //clmnote.description = ctrl.getFormControl().value;
                  break;
                }
              }
            }
          }

          if (parentPyrBucket.buckets.length == 0) { // this is a new bucket
            let newbucket = new claimbucket();
            newbucket.superbill_charges_key = this.serviceCharges.superbill_charges_key;
            newbucket.to_account_type = this.serviceCharges.to_account_type;
            newbucket.to_trans_account = this.serviceCharges.to_trans_account;
            let newsvcs: medicalservice[] = [];

            for (let idata = 0; idata < parentPyrBucket.data.length; idata++) {
              let clmdata = parentPyrBucket.data[idata];
              if ((newbucket.subscriber_key.length == 0
                    || newbucket.coverage_key.length == 0
                    || newbucket.payer_key.length == 0)
                  && clmdata.service != null) {
                newbucket.subscriber_key = clmdata.service.subscriber_key;
                newbucket.coverage_key = clmdata.service.coverage_key;
                newbucket.payer_key = clmdata.service.payer_key;
              }

              if (clmdata.service != null)
                newsvcs.push(clmdata.service);
            }

            this.acctSvc.refreshClaimBuckets(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), [newbucket], "", newsvcs).subscribe(
              data => {
                if (data != null) {
                  location.reload();
                }
              },
              error => {
                console.log(error);
              });
          }
          else {
            let cbucket = this.getSelectedClaimBucket(parentPyrBucket);
            if (cbucket == null) return;

            let newsvcs: medicalservice[] = [];
            for (let idata = 0; idata < parentPyrBucket.data.length; idata++) {
              let clmdata = parentPyrBucket.data[idata];
              if (clmdata.claim == null)
                newsvcs.push(clmdata.service);
            }

            this.acctSvc.refreshClaimBuckets(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), [cbucket], "", newsvcs).subscribe(
              data => {
                if (data != null) {
                  location.reload();
                }
              },
              error => {
                console.log(error);
              });
          }
        }
      }
    });
  }

  getBucketID(pyrBucket: payerbucket): string {
    let cbucket = this.getSelectedClaimBucket(pyrBucket);
    if (cbucket == null) return "";

    return cbucket.claim_bucket_key;
  }

  getConnection(pyrBucket: payerbucket): string {
    let cbucket = this.getSelectedClaimBucket(pyrBucket);
    if (cbucket == null) return "";

    let connparams = this.practiceObj.CONNPARAMS;
    let ret = "No Claim Network Connection";
    if (cbucket.connection_parameters_key.length == 0) {
      let defaultConnParamKey = "";
      let trefs = this.practiceObj.TYPEREFS;
      if (trefs && connparams) {
        for (let iref = 0; iref < trefs.length; iref++) {
          let tref = trefs[iref];
          if (tref == null) continue;
          if (Iceutility.toLong(tref.trans_type_code) != IceTypes.TRANSTYPE.itClaimSubmission) continue;
          defaultConnParamKey = tref.connection_parameters_key;
          break;
        }
      }
      cbucket.connection_parameters_key = defaultConnParamKey;
    }

    if (cbucket.connection_parameters_key.length > 0 && connparams != null && connparams.length > 0) {

      let foundConnary = connparams.filter(c => c.connection_parameters_key == cbucket.connection_parameters_key);
      if (foundConnary.length > 0) {
        ret = foundConnary[0].connection_title;
      }
    }

    return ret;
  }

  getItemID(pyrBucket: payerbucket, clm: claim): string {
    let cbucket = this.getSelectedClaimBucket(pyrBucket);
    if (cbucket == null) return "";

    return clm.claim_key;
  }

  ////////////////////////////////////////////////
  // Events
  goToBucket(event) {
    this.router.navigate([this.navSvc.buildRoute("accounting/serviceitemcharge/" + this.serviceCharges.superbill_charges_key, false)], this.navOptions);
  }

  goToBalance(event) {
    this.router.navigate([this.navSvc.buildRoute("accounting/outstandingbalance/" + this.serviceCharges.superbill_charges_key, false)], this.navOptions);
  }

  ////////////////////////////////////////////////
  // Claim Bucket Events
  onBucketSelectChange(event, pyrBucket: payerbucket): void {
    let cbucket = pyrBucket.getbucket(event.value);
    this.updateSelectedClaimBucket(pyrBucket, cbucket);
  }

  onBucketActionButtonClick(event, pyrBucket: payerbucket, action: any): void {
    let cbucket = this.getSelectedClaimBucket(pyrBucket);
    if (cbucket == null || event == null || action == null) return;

    if (action.value != null && action.value == IceTypes.recordQuickActionRemove.value) {
      if (Iceutility.yesnomodal("Would you like to remove this claim bucket?")) {
        this.acctSvc.deleteClaim(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), cbucket.claim_bucket_key).subscribe(
          data => {
            if (data != null) {
              let ctrl: IcecontrolSettings = this.claimBucketControl[pyrBucket.partyKey];
              if (ctrl != null) {
                let opts = ctrl.getOptions().filter(o => o.value != cbucket.claim_bucket_key);
                ctrl.setOptions(opts);
                if (opts.length > 0)
                  ctrl.getFormControl().setValue(opts[opts.length - 1].value);
                else
                  this.payerBuckets = this.payerBuckets.filter(pyrbuc => pyrbuc.partyKey != pyrBucket.partyKey); // remove payer
              }
            }
          },
          error => {
            // To do
          }
        );
      }
    }
    else if (action.value != null && action.value == IceTypes.recordQuickActionClone.value) {
      let fndEditing = pyrBucket.buckets.filter(cb => Iceutility.toLong(cb.trans_status) == IceTypes.trans_status.isNone);
      if (fndEditing.length > 0) {
        if (false == Iceutility.yesnomodal("There is at least one claim bucket marked for 'Editing'. \nWould you like to continue and mark this bucket 'On-Hold'?")) {
          return;
        }
      }

      this.acctSvc.cloneClaimBucket(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), cbucket.claim_bucket_key).subscribe(
        data => {
          if (data != null && data.length > 0) {
            let newClaimBucket: claimbucket = data[0];

            pyrBucket.buckets.push(newClaimBucket);

            let cbCtrl: IcecontrolSettings = this.claimBucketControl[pyrBucket.partyKey];
            if (cbCtrl != null) {
              let opts = cbCtrl.getOptions();
              opts.push({ name: this.getClaimDDLTitle(newClaimBucket.created, Iceutility.toLong(newClaimBucket.trans_status)), value: newClaimBucket.claim_bucket_key });
              cbCtrl.getFormControl().setValue(newClaimBucket.claim_bucket_key);
            }

            this.updateSelectedClaimBucket(pyrBucket, newClaimBucket);
          }
        },
        error => {
          // To do
        });
    }
    else if (action.value != null && action.value == IceTypes.recordQuickActionRefresh.value) {
      this.onNewBucketActionButtonClick(event, pyrBucket);
    }
    else if (action.value != null && action.value == IceTypes.recordQuickActionSend.value) {
      this.acctSvc.sendClaimBucket(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), cbucket.claim_bucket_key).subscribe(
        data => {
          if (data != null && data.length > 0) {
            let newClaimBucket: claimbucket = data[0];
            if (Iceutility.toLong(newClaimBucket.trans_status) == IceTypes.trans_status.isSent)
              this.router.navigate([this.navSvc.buildRoute("accounting/claimshistory", false)]);
          }
        },
        error => {
          // To do
        });
    }
  }

  onNewBucketActionButtonClick(event, pyrBucket: payerbucket): void {
    let allChanges: string[] = [];
    let allCurrent: string[] = [];

    allChanges.push("Claims for " + this.getPayerName(pyrBucket) + " " + this.getSubscriberName(pyrBucket) + " - " + this.getSubscriberPatientRelationship(pyrBucket) + ", MI: " + this.getSubscriberMINumber(pyrBucket) + ", GP: " + this.getSubscriberGroupNumber(pyrBucket));

    let svcCount = 1;
    let fndAllPayerServices = this.chargeList.filter(m => AccountingService.getPartyBucketKeyEx(m.subscriber_key, m.coverage_key, m.payer_key) == pyrBucket.partyKey);
    for (let isvc = 0; isvc < fndAllPayerServices.length; isvc++) {
      let svc = fndAllPayerServices[isvc];
      let fndData = pyrBucket.data.filter(d => d.service != null && d.service.medical_service_key == svc.medical_service_key);
      if (fndData.length == 0 || (fndData.length > 0 && fndData[0].claim == null)) {
        let thischanges = this.summaryOfItem(pyrBucket, svc);
        thischanges.unshift(svcCount.toString() + "). New Service Record Detected:");

        if (allChanges.length > 0 && allChanges[allChanges.length - 1].length != 0) allChanges.push("");
        allChanges = allChanges.concat(thischanges);
      }
      else {
        let clmdata = fndData[0];
        if (clmdata == null || clmdata.claim == null || clmdata.service == null) continue;
        let thischanges = this.summaryOfItem(pyrBucket, clmdata.service);
        let thiscurrent = this.summaryOfItem(pyrBucket, clmdata.claim);
        if (JSON.stringify(thischanges) === JSON.stringify(thiscurrent)) {
          thischanges.unshift(svcCount.toString() + "). Existing Service Record:");

          thiscurrent.unshift("No Change Detected:");
          thiscurrent.unshift("Claim Item #" + clmdata.claim.claim_key);
        }
        else {
          thischanges.unshift(svcCount.toString() + "). Existing Service Record:");

          thiscurrent.unshift("*Change Detected:");
          thiscurrent.unshift("Claim Item #" + clmdata.claim.claim_key);
        }

        if (allChanges.length > 0 && allChanges[allChanges.length - 1].length != 0) allChanges.push("");
        allChanges = allChanges.concat(thischanges);

        if (allCurrent.length > 0 && allCurrent[allCurrent.length - 1].length != 0) allCurrent.push("");
        allCurrent = allCurrent.concat(thiscurrent);
      }
      svcCount++;
    }
    this.doRefreshBucketPopup(pyrBucket, allChanges, allCurrent);
  }

  onBucketStatusSelectChange(event, pyrBucket: payerbucket): void {
    let cbucket = this.getSelectedClaimBucket(pyrBucket);
    if (cbucket == null) return;
    cbucket.trans_status = Iceutility.toLong(event.value);

    let ctrl: IcecontrolSettings = this.claimBucketControl[pyrBucket.partyKey];
    if (ctrl != null) {
      let fndOpts = ctrl.getOptions().filter(o => o.value == cbucket.claim_bucket_key);
      if (fndOpts.length > 0) {
        fndOpts[0].name = this.getClaimDDLTitle(cbucket.created, cbucket.trans_status);
      }
    }

    let statusCtrl: IcecontrolSettings = event.selectSettings;
    if (statusCtrl != null) {
      let theseOpts = this.getNextStatusStates(cbucket.trans_status, cbucket.trans_status);
      statusCtrl.setOptions(theseOpts);
    }

    this.markChangeAndAutoSavePayerBucket(cbucket);

    if (cbucket.trans_status == IceTypes.trans_status.isReadyToSend) {
      this.startProcessing(pyrBucket);
    }
  }

  startProcessing(pyrBucket: payerbucket) {
    if (pyrBucket == null) return;
    let cbucket = this.getSelectedClaimBucket(pyrBucket);
    if (cbucket == null) return;

    pyrBucket.processingTimeout = 60;
    pyrBucket.percentComplete = 0;

    let ctrlStatus: IcecontrolSettings = this.claimBucketStatus[pyrBucket.partyKey];
    if (ctrlStatus == null) return;
    ctrlStatus.setDisabled(true);
    pyrBucket.processingColor = "warn";

    pyrBucket.processingInterval = setInterval(
      () => {
        if (pyrBucket.percentComplete < 100 && pyrBucket.processingTimeout > 0) {
          pyrBucket.processingTimeout--;
        }
        else {
          this.stopProcessing(pyrBucket);
          pyrBucket.processingTimeout = 60;
          ctrlStatus.setDisabled(false);
        }

        this.acctSvc.getClaimBucketStatus(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), cbucket.claim_bucket_key).subscribe(
          data => {
            if (data == null || data.length == 0) return;

            let buckidx: claimbucketindex = data[0];
            let progress = 0;
            let status = Iceutility.toLong(buckidx.trans_status);
            switch (status) {
              case IceTypes.trans_status.isReadyToSend: progress = 20; pyrBucket.processingColor = "warn"; break;
              case IceTypes.trans_status.isModified: progress = 40; pyrBucket.processingColor = "warn"; break;
              case IceTypes.trans_status.isPending: progress = 60; pyrBucket.processingColor = "warn"; break;
              case IceTypes.trans_status.isProcessing: progress = 80; pyrBucket.processingColor = "warn"; break;
              case IceTypes.trans_status.isScrubbed: progress = 100; pyrBucket.processingColor = "green"; break;
              case IceTypes.trans_status.isError: progress = 100; pyrBucket.processingColor = "warn"; break;
            }

            pyrBucket.percentComplete = Math.max(progress, pyrBucket.percentComplete);
            cbucket.trans_status = status;
            let theseOpts = this.getNextStatusStates(status, status);
            ctrlStatus.setOptions(theseOpts);
            ctrlStatus.getFormControl().setValue(status);

            // update the draft data
            cbucket.draft_message_key = buckidx.draft_message_key;
            cbucket.draft_message_date = buckidx.draft_message_date;
            cbucket.draft_message_status = buckidx.draft_message_status;
            cbucket.draft_message_log = buckidx.draft_message_log;
          },
          error => {
            // To do
          });

      }, 5000);
  }

  stopProcessing(pyrBucket: payerbucket) {
    clearInterval(pyrBucket.processingInterval);
  }

  onClaimInsuranceTypeChange(event, pyrBucket: payerbucket): void {
    let cbucket = this.getSelectedClaimBucket(pyrBucket);
    if (cbucket == null) return;

    cbucket.insurance_type_code = event.value;
    this.markChangeAndAutoSavePayerBucket(cbucket);
  }

  onClaimFilingIndicatorChange(event, pyrBucket: payerbucket): void {
    let cbucket = this.getSelectedClaimBucket(pyrBucket);
    if (cbucket == null) return;

    cbucket.claim_filing_indicator_code = event.value;
    this.markChangeAndAutoSavePayerBucket(cbucket);
  }

  addClaimOtherSubscriberClick(event, pyrBucket: payerbucket): void {
    let subref: subscriberreference = new subscriberreference();
    subref.offline_record_status = IceTypes.offlineRecStatus.offlineInsert;
    this.doOtherSubscriberPopup(pyrBucket, subref);
  }

  claimOtherSubscriberClick(event, pyrBucket: payerbucket): void {
    let cbucket = this.getSelectedClaimBucket(pyrBucket);
    if (cbucket == null || event.item == null || event.action == null) return;

    let partyKey: string = event.item.value;
    if (partyKey.indexOf("|") >= 0) {
      let parts = partyKey.split("|");
      if (parts.length < 3) return;

      let subscriberKey = parts[0];
      let coverageKey = parts[1];
      let payerKey = parts[2];
      let fndSub = cbucket.SUBS.filter(s => s.subscriber_key == subscriberKey && s.coverage_key == coverageKey && s.payer_key == payerKey);

      if (event.action.value == IceTypes.RecordActionType.oatRemove) {
        if (Iceutility.yesnomodal("Would you like to remove this insurance subscriber?")) {
          if (fndSub.length > 0)
            fndSub[0].offline_record_status = IceTypes.offlineRecStatus.offlineDelete;

          if (cbucket.offline_record_status != IceTypes.offlineRecStatus.offlineInsert)
            cbucket.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;

          this.autoSavePayerBuckets([cbucket]).subscribe(
            data => {
              if (data != null) {
                cbucket.SUBS = cbucket.SUBS.filter(s => AccountingService.getPartyBucketKeyEx(s.subscriber_key, s.coverage_key, s.payer_key) != partyKey);
                this.loadClaimOtherSubscriberListControl(pyrBucket);
                this.resetChangedBuckets(<claimbucket[]>data);
              }
            },
            error => {
              console.log(error);
            });
        }
      }
      else {
        if (fndSub.length > 0)
          this.doOtherSubscriberPopup(pyrBucket, fndSub[0]);
      }
    }
  }

  addClaimRelatedCauseClick(event, pyrBucket: payerbucket): void {
    let rc: relatedcause = new relatedcause();
    rc.offline_record_status = IceTypes.offlineRecStatus.offlineInsert;
    this.doRelatedCausePopup(pyrBucket, rc);
  }

  claimRelatedCauseClick(event, pyrBucket: payerbucket): void {
    let cbucket = this.getSelectedClaimBucket(pyrBucket);
    if (cbucket == null || event.item == null || event.action == null) return;

    let relCauseKey: string = event.item.value;
    let fndRelCause = cbucket.CAUSES.filter(c => c.related_cause_key == relCauseKey);

    if (event.action.value == IceTypes.RecordActionType.oatRemove) {
      if (Iceutility.yesnomodal("Would you like to remove this related cause?")) {
        if (fndRelCause.length > 0)
          fndRelCause[0].offline_record_status = IceTypes.offlineRecStatus.offlineDelete;

        if (cbucket.offline_record_status != IceTypes.offlineRecStatus.offlineInsert)
          cbucket.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;

        this.autoSavePayerBuckets([cbucket]).subscribe(
          data => {
            if (data != null) {
              cbucket.CAUSES = cbucket.CAUSES.filter(c => c.related_cause_key != relCauseKey);
              this.loadClaimRelatedCausesListControl(pyrBucket);
              this.resetChangedBuckets(<claimbucket[]>data);
            }
          },
          error => {
            console.log(error);
          });
      }
    }
    else {
      if (fndRelCause.length > 0)
        this.doRelatedCausePopup(pyrBucket, fndRelCause[0]);
    }
  }

  onClaimEncounterTypeChange(event, pyrBucket: payerbucket): void {
    let cbucket = this.getSelectedClaimBucket(pyrBucket);
    if (cbucket == null) return;
    cbucket.claim_encounter_type = event.value;
    this.markChangeAndAutoSavePayerBucket(cbucket);
  }

  onClaimPlaceOfServiceChange(event, pyrBucket: payerbucket): void {
    let cbucket = this.getSelectedClaimBucket(pyrBucket);
    if (cbucket == null) return;
    cbucket.place_of_service_code = event.value;
    this.markChangeAndAutoSavePayerBucket(cbucket);
  }

  onClaimProviderSigOnFileChange(event, pyrBucket: payerbucket): void {
    let cbucket = this.getSelectedClaimBucket(pyrBucket);
    if (cbucket == null) return;
    cbucket.provider_signature_code = event.checked ? 'Y' : 'N';
    this.markChangeAndAutoSavePayerBucket(cbucket);
  }

  onClaimPatientAssignmentChange(event, pyrBucket: payerbucket): void {
    let cbucket = this.getSelectedClaimBucket(pyrBucket);
    if (cbucket == null) return;
    cbucket.assignment_of_benefits_code = event.value;
    this.markChangeAndAutoSavePayerBucket(cbucket);
  }

  onClaimProviderAcceptAssignmentChange(event, pyrBucket: payerbucket): void {
    let cbucket = this.getSelectedClaimBucket(pyrBucket);
    if (cbucket == null) return;
    cbucket.provider_accepts_assignment_code = event.value;
    this.markChangeAndAutoSavePayerBucket(cbucket);
  }

  onClaimReleaseOfInformationChange(event, pyrBucket: payerbucket): void {
    let cbucket = this.getSelectedClaimBucket(pyrBucket);
    if (cbucket == null) return;
    cbucket.release_of_information_code = event.value;
    this.markChangeAndAutoSavePayerBucket(cbucket);
  }

  onClaimPatientSignatureChange(event, pyrBucket: payerbucket): void {
    let cbucket = this.getSelectedClaimBucket(pyrBucket);
    if (cbucket == null) return;
    cbucket.patient_signature_code = event.value;
    this.markChangeAndAutoSavePayerBucket(cbucket);
  }

  addClaimDatesofEventsClick(event, pyrBucket: any): void {
    let svcdt: servicedate = new servicedate();
    svcdt.offline_record_status = IceTypes.offlineRecStatus.offlineInsert;
    this.doDatesPopup(pyrBucket, null, "Claim Date of Event", "", svcdt);
  }

  claimDatesofEventsClick(event, pyrBucket: payerbucket): void {
    let cbucket = this.getSelectedClaimBucket(pyrBucket);
    if (cbucket == null || event.item == null || event.action == null) return;

    let dtCodeKey: string = event.item.value;
    let fndDtCode = cbucket.SVCDTS.filter(c => c.service_date_key == dtCodeKey);

    if (event.action.value == IceTypes.RecordActionType.oatRemove) {
      if (Iceutility.yesnomodal("Would you like to remove this date code?")) {
        if (fndDtCode.length > 0)
          fndDtCode[0].offline_record_status = IceTypes.offlineRecStatus.offlineDelete;

        if (cbucket.offline_record_status != IceTypes.offlineRecStatus.offlineInsert)
          cbucket.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;

        this.autoSavePayerBuckets([cbucket]).subscribe(
          data => {
            if (data != null) {
              cbucket.SVCDTS = cbucket.SVCDTS.filter(c => c.service_date_key != dtCodeKey);
              this.loadClaimDatesofEventsListControl(pyrBucket);
              this.resetChangedBuckets(<claimbucket[]>data);
            }
          },
          error => {
            console.log(error);
          });
      }
    }
    else {
      if (fndDtCode.length > 0)
        this.doDatesPopup(pyrBucket, null, "Claim Date of Event", "", fndDtCode[0]);
    }
  }

  addClaimRemittanceDatesClick(event, pyrBucket: any): void {
    let svcdt: servicedate = new servicedate();
    svcdt.offline_record_status = IceTypes.offlineRecStatus.offlineInsert;
    this.doDatesPopup(pyrBucket, null, "Claim Remittance Date", "573", svcdt);
  }

  claimRemittanceDatesClick(event, pyrBucket: payerbucket): void {
    let cbucket = this.getSelectedClaimBucket(pyrBucket);
    if (cbucket == null || event.item == null || event.action == null) return;

    let dtCodeKey: string = event.item.value;
    let fndDtCode = cbucket.SVCDTS.filter(c => c.service_date_key == dtCodeKey);

    if (event.action.value == IceTypes.RecordActionType.oatRemove) {
      if (Iceutility.yesnomodal("Would you like to remove this remittance date code?")) {
        if (fndDtCode.length > 0)
          fndDtCode[0].offline_record_status = IceTypes.offlineRecStatus.offlineDelete;

        if (cbucket.offline_record_status != IceTypes.offlineRecStatus.offlineInsert)
          cbucket.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;

        this.autoSavePayerBuckets([cbucket]).subscribe(
          data => {
            if (data != null) {
              cbucket.SVCDTS = cbucket.SVCDTS.filter(c => c.service_date_key != dtCodeKey);
              this.loadClaimRemittanceDatesListControl(pyrBucket);
              this.resetChangedBuckets(<claimbucket[]>data);
            }
          },
          error => {
            console.log(error);
          });
      }
    }
    else {
      if (fndDtCode.length > 0)
        this.doDatesPopup(pyrBucket, null, "Claim Remittance Date", "573", fndDtCode[0]);
    }
  }

  addClaimReferralAuthorizationClick(event, pyrBucket: payerbucket): void {
    let reflref: referralreference = new referralreference();
    reflref.offline_record_status = IceTypes.offlineRecStatus.offlineInsert;

    let refl: referral = new referral();
    refl.offline_record_status = IceTypes.offlineRecStatus.offlineInsert;
    refl.billing_provider_account_type = this.serviceCharges.from_account_type;
    refl.billing_provider_trans_account = this.serviceCharges.from_trans_account;
    this.doReferralAuthorizationPopup(pyrBucket, null, reflref, refl);
  }

  claimReferralAuthorizationClick(event, pyrBucket: payerbucket): void {
    let cbucket = this.getSelectedClaimBucket(pyrBucket);
    if (cbucket == null || event.item == null || event.action == null) return;

    let reflRefKey: string = event.item.value;
    let fndReflRef = cbucket.REFLREFS.filter(c => c.referral_reference_key == reflRefKey);

    if (event.action.value == IceTypes.RecordActionType.oatRemove) {
      if (Iceutility.yesnomodal("Would you like to remove this authorization?")) {
        if (fndReflRef.length > 0)
          fndReflRef[0].offline_record_status = IceTypes.offlineRecStatus.offlineDelete;

        if (cbucket.offline_record_status != IceTypes.offlineRecStatus.offlineInsert)
          cbucket.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;

        this.autoSavePayerBuckets([cbucket]).subscribe(
          data => {
            if (data != null) {
              cbucket.REFLREFS = cbucket.REFLREFS.filter(c => c.referral_reference_key != reflRefKey);
              this.loadClaimReferralAuthorizationListControl(pyrBucket);
              this.resetChangedBuckets(<claimbucket[]>data);
            }
          },
          error => {
            console.log(error);
          });
      }
    }
    else {
      if (fndReflRef.length > 0) {
        let fndRefl = this.allReferrals.filter(r => r.referral_key == fndReflRef[0].referral_key);
        if (fndRefl.length > 0) {
          this.doReferralAuthorizationPopup(pyrBucket, null, fndReflRef[0], fndRefl[0]);
        }
      }
    }
  }

  addClaimOtherReferencesClick(event, pyrBucket: any): void {
    let refID: referenceidentification = new referenceidentification();
    refID.offline_record_status = IceTypes.offlineRecStatus.offlineInsert;
    this.doOtherReferencePopup(pyrBucket, null, refID);
  }
  claimOtherReferencesClick(event, pyrBucket: payerbucket): void {
    let cbucket = this.getSelectedClaimBucket(pyrBucket);
    if (cbucket == null || event.item == null || event.action == null) return;

    let refKey: string = event.item.value;
    let fndRef = cbucket.REFIDS.filter(c => c.reference_identification_key == refKey);

    if (event.action.value == IceTypes.RecordActionType.oatRemove) {
      if (Iceutility.yesnomodal("Would you like to remove this reference ID?")) {
        if (fndRef.length > 0)
          fndRef[0].offline_record_status = IceTypes.offlineRecStatus.offlineDelete;

        if (cbucket.offline_record_status != IceTypes.offlineRecStatus.offlineInsert)
          cbucket.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;

        this.autoSavePayerBuckets([cbucket]).subscribe(
          data => {
            if (data != null) {
              cbucket.REFLREFS = cbucket.REFLREFS.filter(c => c.referral_reference_key != refKey);
              this.loadClaimReferenceIDListControl(pyrBucket);
              this.resetChangedBuckets(<claimbucket[]>data);
            }
          },
          error => {
            console.log(error);
          });
      }
    }
    else {
      if (fndRef.length > 0)
        this.doOtherReferencePopup(pyrBucket, null, fndRef[0]);
    }
  }

  addClaimAmountsClick(event, pyrBucket: payerbucket): void {
    let amtref: amount = new amount();
    amtref.offline_record_status = IceTypes.offlineRecStatus.offlineInsert;
    this.doAmountsPopup(pyrBucket, null, amtref);
  }
  claimAmountsClick(event, pyrBucket: payerbucket): void {
    let cbucket = this.getSelectedClaimBucket(pyrBucket);
    if (cbucket == null || event.item == null || event.action == null) return;

    let amtKey: string = event.item.value;
    let fndAmt = cbucket.COBS.filter(c => c.amount_key == amtKey);

    if (event.action.value == IceTypes.RecordActionType.oatRemove) {
      if (Iceutility.yesnomodal("Would you like to remove this COB Amount?")) {
        if (fndAmt.length > 0)
          fndAmt[0].offline_record_status = IceTypes.offlineRecStatus.offlineDelete;

        if (cbucket.offline_record_status != IceTypes.offlineRecStatus.offlineInsert)
          cbucket.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;

        this.autoSavePayerBuckets([cbucket]).subscribe(
          data => {
            if (data != null) {
              cbucket.COBS = cbucket.COBS.filter(c => c.amount_key != amtKey);
              this.loadClaimAmountsListControl(pyrBucket);
              this.resetChangedBuckets(<claimbucket[]>data);
            }
          },
          error => {
            console.log(error);
          });
      }
    }
    else {
      if (fndAmt.length > 0)
        this.doAmountsPopup(pyrBucket, null, fndAmt[0]);
    }
  }

  addClaimProviderClick(event, pyrBucket: payerbucket): void {
    let cbucket = this.getSelectedClaimBucket(pyrBucket);
    if (cbucket == null) return;

    let proref: provider_reference = new provider_reference(null);
    proref.offline_record_status = IceTypes.offlineRecStatus.offlineInsert;
    this.proSvc.doProviderPopup(this.dialog, this.practiceProviders, pyrBucket, proref).subscribe(result => {
      if (this.proSvc.processProvider(result) == true) {
        // save bucket
        if (proref.offline_record_status == IceTypes.offlineRecStatus.offlineInsert) {
          proref.provider_reference_key = Iceutility.guid(true);
          cbucket.PROS.push(proref);
        }

        if (cbucket.offline_record_status != IceTypes.offlineRecStatus.offlineInsert)
          cbucket.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;

        this.autoSavePayerBuckets([cbucket]).subscribe(
          data => {
            if (data != null) {
              this.loadClaimProviderListControl(pyrBucket);
              proref.offline_record_status = IceTypes.offlineRecStatus.offlineNoChange;
              this.resetChangedBuckets(<claimbucket[]>data);
            }
          },
          error => {
            console.log(error);
          });;
      }
    });
  }

  claimProviderClick(event, pyrBucket: payerbucket): void {
    let cbucket = this.getSelectedClaimBucket(pyrBucket);
    if (cbucket == null || event.item == null || event.action == null) return;

    let proAct = event.item.value;
    let fndPro = cbucket.PROS.filter(p => p.provider_reference_key == proAct);
    if (fndPro.length == 0) return;

    if (event.action.value == IceTypes.RecordActionType.oatRemove) {
      if (Iceutility.yesnomodal("Would you like to remove this provider?")) {
        if (fndPro.length > 0)
          fndPro[0].offline_record_status = IceTypes.offlineRecStatus.offlineDelete;

        if (cbucket.offline_record_status != IceTypes.offlineRecStatus.offlineInsert)
          cbucket.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;

        this.autoSavePayerBuckets([cbucket]).subscribe(
          data => {
            if (data != null) {
              cbucket.PROS = cbucket.PROS.filter(p => p.provider_reference_key != fndPro[0].provider_reference_key);
              this.loadClaimProviderListControl(pyrBucket);
              this.resetChangedBuckets(<claimbucket[]>data);
            }
          },
          error => {
            console.log(error);
          });
      }
    }
    else {
      let proref: provider_reference = fndPro[0];
      this.proSvc.doProviderPopup(this.dialog, this.practiceProviders, pyrBucket, proref).subscribe(result => {
        if (this.proSvc.processProvider(result) == true) {
          // save bucket
          if (proref.offline_record_status != IceTypes.offlineRecStatus.offlineInsert)
            proref.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;

          if (cbucket.offline_record_status != IceTypes.offlineRecStatus.offlineInsert)
            cbucket.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;

          this.autoSavePayerBuckets([cbucket]).subscribe(
            data => {
              if (data != null) {
                this.loadClaimProviderListControl(pyrBucket);
                proref.offline_record_status = IceTypes.offlineRecStatus.offlineNoChange;
                this.resetChangedBuckets(<claimbucket[]>data);
              }
            },
            error => {
              console.log(error);
            });
        }
      });
    }
  }

  bucketsModified(buckets: claimbucket[]): boolean {
    if (buckets == null) return false;

    return buckets.filter(b => Iceutility.toLong(b.offline_record_status) != IceTypes.offlineRecStatus.offlineNoChange).length > 0;
  }

  autoSavePayerBuckets(buckets: claimbucket[]): Observable<any> {
    if (buckets == null || buckets.length == 0) return Observable.throw("Invalid parameters");

    if (this.bucketsModified(buckets)) {
      // add any other dirty
      for (let ipyrbuck = 0; ipyrbuck < this.payerBuckets.length; ipyrbuck++) {
        let pyrBuck = this.payerBuckets[ipyrbuck];
        for (let iclmbuck = 0; iclmbuck < pyrBuck.buckets.length; iclmbuck++) {
          let clmBuck = pyrBuck.buckets[iclmbuck];
          if (clmBuck != null) {
            let alreadyIn = buckets.filter(cb => cb.claim_bucket_key == clmBuck.claim_bucket_key);
            if (alreadyIn.length > 0) {
              continue;
            }
            if (this.bucketsModified([clmBuck])) {
              buckets.push(clmBuck); // add to save process
            }
          }
        }
      }

      // Update or Insert Buckets
      return this.acctSvc.insertUpdateClaimBuckets(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), buckets);
    }
    return Observable.of(false);
  }

  resetChangedBuckets(data: claimbucket[]) {
    if (data == null) return;

    for (let ibck = 0; ibck < data.length; ibck++) {
      let thisCBck: claimbucket = data[ibck];
      for (let iPryBck = 0; iPryBck < this.payerBuckets.length; iPryBck++) {
        let pryBck = this.payerBuckets[iPryBck];
        if (pryBck != null) {
          let cbck = pryBck.getbucket(thisCBck.claim_bucket_key);
          if (cbck != null) {
            cbck.offline_record_status = IceTypes.offlineRecStatus.offlineNoChange;
            break;
          }
        }
      }
    }
  }

  markChangeAndAutoSavePayerBucket(cbucket: claimbucket) {
    if (cbucket.offline_record_status != IceTypes.offlineRecStatus.offlineInsert)
      cbucket.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;

    this.autoSavePayerBuckets([cbucket]).subscribe(
      data => {
        if (data != null) {
          this.resetChangedBuckets(<claimbucket[]>data);
        }
      },
      error => {
        console.log(error);
      });
  }

  addClaimAmbulanceTransportClick(event, pyrBucket: any): void {
    let amb: claimambulance = new claimambulance();
    amb.offline_record_status = IceTypes.offlineRecStatus.offlineInsert;
    this.doTransportationPopup(pyrBucket, amb);
  }
  claimAmbulanceTransportClick(event, pyrBucket: payerbucket): void {
    let cbucket = this.getSelectedClaimBucket(pyrBucket);
    if (cbucket == null || event.item == null || event.action == null) return;

    let ambKey: string = event.item.value;
    let fndAmb = cbucket.AMBS.filter(c => c.claim_ambulance_key == ambKey);

    if (event.action.value == IceTypes.RecordActionType.oatRemove) {
      if (Iceutility.yesnomodal("Would you like to remove this Transport?")) {
        if (fndAmb.length > 0)
          fndAmb[0].offline_record_status = IceTypes.offlineRecStatus.offlineDelete;

        if (cbucket.offline_record_status != IceTypes.offlineRecStatus.offlineInsert)
          cbucket.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;

        this.autoSavePayerBuckets([cbucket]).subscribe(
          data => {
            if (data != null) {
              cbucket.AMBS = cbucket.AMBS.filter(c => c.claim_ambulance_key != ambKey);
              this.loadClaimAmbulanceTransportListControl(pyrBucket);
              this.resetChangedBuckets(<claimbucket[]>data);
            }
          },
          error => {
            console.log(error);
          });
      }
    }
    else {
      if (fndAmb.length > 0)
        this.doTransportationPopup(pyrBucket, fndAmb[0]);
    }
  }

  addClaimContractInformationClick(event, pyrBucket: any): void {
    let ctrct: claimcontract = new claimcontract();
    ctrct.offline_record_status = IceTypes.offlineRecStatus.offlineInsert;
    this.doContractPopup(pyrBucket, ctrct);
  }
  claimContractInformationClick(event, pyrBucket: payerbucket): void {
    let cbucket = this.getSelectedClaimBucket(pyrBucket);
    if (cbucket == null || event.item == null || event.action == null) return;

    let contcKey: string = event.item.value;
    let fndConTC = cbucket.CNTRCS.filter(c => c.claim_contract_key == contcKey);

    if (event.action.value == IceTypes.RecordActionType.oatRemove) {
      if (Iceutility.yesnomodal("Would you like to remove this Contract reference?")) {
        if (fndConTC.length > 0)
          fndConTC[0].offline_record_status = IceTypes.offlineRecStatus.offlineDelete;

        if (cbucket.offline_record_status != IceTypes.offlineRecStatus.offlineInsert)
          cbucket.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;

        this.autoSavePayerBuckets([cbucket]).subscribe(
          data => {
            if (data != null) {
              cbucket.AMBS = cbucket.AMBS.filter(c => c.claim_ambulance_key != contcKey);
              this.loadClaimContractInformationListControl(pyrBucket);
              this.resetChangedBuckets(<claimbucket[]>data);
            }
          },
          error => {
            console.log(error);
          });
      }
    }
    else {
      if (fndConTC.length > 0)
        this.doContractPopup(pyrBucket, fndConTC[0]);
    }
  }

  addClaimAttachmentsClick(event, pyrBucket: any): void {
    let attchmt: claimsupplementalinformation = new claimsupplementalinformation();
    attchmt.offline_record_status = IceTypes.offlineRecStatus.offlineInsert;
    this.doAttachmentPopup(pyrBucket, null, attchmt);
  }
  claimAttachmentsClick(event, pyrBucket: payerbucket): void {
    let cbucket = this.getSelectedClaimBucket(pyrBucket);
    if (cbucket == null || event.item == null || event.action == null) return;

    let suppInfoKey: string = event.item.value;
    let fndsuppInfo = cbucket.SUPPL.filter(c => c.claim_supplemental_information_key == suppInfoKey);

    if (event.action.value == IceTypes.RecordActionType.oatRemove) {
      if (Iceutility.yesnomodal("Would you like to remove this Supplemental Information?")) {
        if (fndsuppInfo.length > 0)
          fndsuppInfo[0].offline_record_status = IceTypes.offlineRecStatus.offlineDelete;

        if (cbucket.offline_record_status != IceTypes.offlineRecStatus.offlineInsert)
          cbucket.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;

        this.autoSavePayerBuckets([cbucket]).subscribe(
          data => {
            if (data != null) {
              cbucket.SUPPL = cbucket.SUPPL.filter(c => c.claim_supplemental_information_key != suppInfoKey);
              this.loadClaimAttachmentsListControl(pyrBucket);
              this.resetChangedBuckets(<claimbucket[]>data);
            }
          },
          error => {
            console.log(error);
          });
      }
    }
    else {
      if (fndsuppInfo.length > 0)
        this.doAttachmentPopup(pyrBucket, null, fndsuppInfo[0]);
    }
  }

  addClaimNotesClick(event, pyrBucket: payerbucket): void {
    let clmnote: claimnote = new claimnote();
    clmnote.offline_record_status = IceTypes.offlineRecStatus.offlineInsert;
    this.doNotesPopup(pyrBucket, null, clmnote);
  }
  claimNotesClick(event, pyrBucket: payerbucket): void {
    let cbucket = this.getSelectedClaimBucket(pyrBucket);
    if (cbucket == null || event.item == null || event.action == null) return;

    let clmNoteKey: string = event.item.value;
    let fndNote = cbucket.CLMNOTES.filter(c => c.claim_note_key == clmNoteKey);

    if (event.action.value == IceTypes.RecordActionType.oatRemove) {
      if (Iceutility.yesnomodal("Would you like to remove this Note?")) {
        if (fndNote.length > 0)
          fndNote[0].offline_record_status = IceTypes.offlineRecStatus.offlineDelete;

        if (cbucket.offline_record_status != IceTypes.offlineRecStatus.offlineInsert)
          cbucket.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;

        this.autoSavePayerBuckets([cbucket]).subscribe(
          data => {
            if (data != null) {
              cbucket.SUPPL = cbucket.SUPPL.filter(c => c.claim_supplemental_information_key != clmNoteKey);
              this.loadClaimNotesListControl(pyrBucket);
              this.resetChangedBuckets(<claimbucket[]>data);
            }
          },
          error => {
            console.log(error);
          });
      }
    }
    else {
      if (fndNote.length > 0)
        this.doNotesPopup(pyrBucket, null, fndNote[0]);
    }
  }

  ////////////////////////////////////////////////
  // Claim Item Events
  onItemClosed(pyrBucket: payerbucket, clm: claim): void {
    this.itemExpanded[clm.medical_service_key] = false;
  }

  onItemOpened(pyrBucket: payerbucket, clm: claim): void {
    if (this.itemExpanded[clm.medical_service_key] == null) {
      this.updateSelectedClaim(pyrBucket, clm.medical_service_key, clm.claim_key);
    }
    this.itemExpanded[clm.medical_service_key] = true;
  }
  onItemSelectChange(event, pyrBucket: payerbucket, clm: claim): void {
    this.updateSelectedClaim(pyrBucket, clm.medical_service_key, event.value);
  }

  onItemActionButtonClick(event, pyrBucket: payerbucket, clm: claim, action: any): void {
    let cbucket = this.getSelectedClaimBucket(pyrBucket);
    if (cbucket == null || clm == null || event == null || action == null) return;

    if (action.value != null && action.value == IceTypes.recordQuickActionRemove.value) {
      if (Iceutility.yesnomodal("Would you like to remove this claim record?")) {
        this.acctSvc.deleteClaimItem(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), cbucket.claim_bucket_key, clm.claim_key).subscribe(
          data => {
            if (data != null) {
              let ctrl: IcecontrolSettings = this.itemControl[clm.medical_service_key];
              if (ctrl != null) {
                let opts = ctrl.getOptions().filter(o => o.value != clm.claim_key);
                ctrl.setOptions(opts);
                if (opts.length > 0)
                  ctrl.getFormControl().setValue(opts[opts.length - 1].value);
              }
              let foundClmData = pyrBucket.data.filter(cd => cd.service != null && cd.service.medical_service_key == clm.medical_service_key);
              if (foundClmData.length > 0) {
                // Remove claim from history
                foundClmData[0].history = foundClmData[0].history.filter(c => c.claim_key != clm.claim_key);
                this.updateSelectedClaim(pyrBucket, clm.medical_service_key, ctrl.getFormControl().value);
              }
              // Remove from claim bucket
              cbucket.CLMS = cbucket.CLMS.filter(c => c.claim_key != clm.claim_key);
            }
          },
          error => {
            // To do
          }
        );
      }
    }
    else if (action.value != null && action.value == IceTypes.recordQuickActionClone.value) {
      let fndEditing = cbucket.CLMS.filter(c => Iceutility.toLong(c.trans_status) == IceTypes.trans_status.isNone);
      if (fndEditing.length > 0) {
        if (false == Iceutility.yesnomodal("There is at least one claim marked for 'Editing'. \nWould you like to continue and mark this claim 'On-Hold'?")) {
          return;
        }
      }

      this.acctSvc.cloneClaimItem(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), cbucket.claim_bucket_key, clm.claim_key).subscribe(
        data => {
          if (data != null && data.length > 0) {
            let newclm: claim = data[0];
            cbucket.CLMS.push(newclm);
            let ctrl: IcecontrolSettings = this.itemControl[clm.medical_service_key];
            if (ctrl != null) {
              let opts = ctrl.getOptions();
              opts.push({ name: this.getClaimDDLTitle(newclm.claim_date, Iceutility.toLong(newclm.trans_status)), value: newclm.claim_key });
              ctrl.setOptions(opts);
              ctrl.getFormControl().setValue(newclm.claim_key);
            }

            // Set the current claim being cloned to On-Hold if in Draft
            if (Iceutility.toLong(clm.trans_status) == IceTypes.trans_status.isNone)
              clm.trans_status = IceTypes.trans_status.isTentative;

            this.updateSelectedClaim(pyrBucket, newclm.medical_service_key, newclm.claim_key);
          }
        },
        error => {
          // To do
        });
    }
    else if (action.value != null && action.value == IceTypes.recordQuickActionRefresh.value) {
      let fndSvc = this.chargeList.filter(s => s.medical_service_key == clm.medical_service_key);
      if (fndSvc.length == 0) return;
      let svc = fndSvc[0];
      let changes = this.summaryOfItem(pyrBucket, svc);
      let current = this.summaryOfItem(pyrBucket, clm);

      if (JSON.stringify(changes) === JSON.stringify(current)) {
        if (false == Iceutility.yesnomodal("There are no new changes to refresh. \nWould you like to continue with refresing this claim (OK to Continue or Cancel)'?"))
          return;
      }
      else {
        current.unshift("*Change Detected:");
      }
      this.doRefreshItemPopup(pyrBucket, clm, changes, current);
    }
  }

  summaryOfItem(pyrBucket: payerbucket, svc: medicalservice): string[] {
    let ret: string[] = [];

    let dts = "";
    for (let idt = 0; idt < svc.SVCDTS.length; idt++) {
      ret.push("Date: " + this.loadDatesofEvents(svc.SVCDTS[idt]));
    }
    ret.push("Code: " + svc.code);
    ret.push("Title: " + svc.service_description);
    ret.push(
      "Charge: " + Iceutility.toDouble(svc.price).toString()
      + ", Qty: " + Iceutility.toDouble(svc.quantity).toString()
      + ", Total: " + Iceutility.toDouble(svc.total_amount).toString()
    );
    ret.push("");
    if (svc.modifier1.length > 0) ret.push("modifier: " + svc.modifier1);
    if (svc.modifier2.length > 0) ret.push("modifier: " + svc.modifier2);
    if (svc.modifier3.length > 0) ret.push("modifier: " + svc.modifier3);
    if (svc.modifier4.length > 0) ret.push("modifier: " + svc.modifier4);

    if (ret[ret.length - 1].length != 0) ret.push("");
    let fndMRef = this.serviceCharges.CHARGES.filter(mref => mref.medical_service_key == svc.medical_service_key);
    if (fndMRef.length > 0) {
      for (let idx = 0; idx < fndMRef[0].DIAGREFS.length; idx++) {
        if (fndMRef[0].DIAGREFS[idx].icd_code.length > 0) ret.push("dx pointer: " + fndMRef[0].DIAGREFS[idx].icd_code);
      }
    }

    if (ret[ret.length - 1].length != 0) ret.push("");
    for (let ipro = 0; ipro < svc.PROS.length; ipro++) {
      let proref = svc.PROS[ipro];
      let fndPro = this.practiceProviders.filter(p => p.trans_account == proref.trans_account);
      if (fndPro.length > 0) {
        ret.push("provider: " + this.loadProvider(fndPro[0], proref));
      }
    }

    let suppl: claimsupplementalinformation[] = svc["SUPPL"];
    if (suppl != null) {
      if (ret[ret.length - 1].length != 0) ret.push("");
      for (let iattch = 0; iattch < suppl.length; iattch++) {
        let suppInfo = suppl[iattch];

        let opt = this.loadAttachments(pyrBucket, suppInfo);
        if (opt != null) {
          ret.push("attachment: " + opt.name);
        }
      }
    }
    else {
      if (ret[ret.length - 1].length != 0) ret.push("");
      for (let idocRef = 0; idocRef < svc.EDOCS.length; idocRef++) {
        let docRef = svc.EDOCS[idocRef];
        let fndDoc = this.allAttachments.filter(a => a.external_data_key == docRef.external_data_key);
        if (fndDoc.length > 0) {
          let desc = Iceutility.getDateTextEx(fndDoc[0].external_reference_date, null, true) + " Document: " + AccountingService.getSourceType(Iceutility.toLong(fndDoc[0].src_type)) + " " + fndDoc[0].title;
          ret.push("attachment: " + desc);
        }
      }

    }

    return ret;
  }

  addItemStatusClick(event, pyrBucket: any, clm: claim): void {
    let cbucket = this.getSelectedClaimBucket(pyrBucket);
    if (cbucket == null || clm == null || event == null) return;

    let ctrlStatus: IcecontrolSettings = this.itemStatusButtonCtrl[clm.medical_service_key];
    if (this.isNewServiceItem(pyrBucket, clm)) {
      if (ctrlStatus != null) {
        ctrlStatus.getFormControl().setValue(false); // reset to false, since
      }
      return;
    }

    let lastOffStat = IceTypes.trans_status.isNone;
    if (ctrlStatus.properties.lastOffStatus != null) {
      lastOffStat = ctrlStatus.properties.lastOffStatus;
    }

    clm.trans_status = event.checked ? IceTypes.trans_status.isReadyToSend : lastOffStat;
    let ctrlClaimItemDDL: IcecontrolSettings = this.itemControl[clm.medical_service_key];
    let fndOpts = ctrlClaimItemDDL.getOptions().filter(o => o.value == clm.claim_key);
    if (fndOpts.length > 0) {
      fndOpts[0].name = this.getClaimDDLTitle(clm.claim_date, clm.trans_status);
    }

    // Reset all other ready claims
    let fndClms = cbucket.CLMS.filter(c => c.trans_status == IceTypes.trans_status.isReadyToSend
      && c.claim_key != clm.claim_key && c.medical_service_key == clm.medical_service_key);
    for (let iclm = 0; iclm < fndClms.length; iclm++) {
      fndClms[iclm].trans_status = IceTypes.trans_status.isTentative;      
      if (fndClms[iclm].offline_record_status != IceTypes.offlineRecStatus.offlineInsert)
        fndClms[iclm].offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;

      fndOpts = ctrlClaimItemDDL.getOptions().filter(o => o.value == fndClms[iclm].claim_key);
      if (fndOpts.length > 0) {
        fndOpts[0].name = this.getClaimDDLTitle(fndClms[iclm].claim_date, fndClms[iclm].trans_status);
      }
    }

    if (clm.offline_record_status != IceTypes.offlineRecStatus.offlineInsert)
      clm.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;

    if (cbucket.offline_record_status != IceTypes.offlineRecStatus.offlineInsert)
      cbucket.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;

    this.autoSavePayerBuckets([cbucket]).subscribe(
      data => {
        if (data != null) {
          this.resetChangedBuckets(<claimbucket[]>data);
        }
      },
      error => {
        console.log(error);
      });
  }

  addItemDatesofEventsClick(event, pyrBucket: any, clm: claim): void {
    let svcdt: servicedate = new servicedate();
    svcdt.offline_record_status = IceTypes.offlineRecStatus.offlineInsert;
    this.doDatesPopup(pyrBucket, clm, "Item Date of Event", "", svcdt);
  }

  itemDatesofEventsClick(event, pyrBucket: any, clm: claim): void {
    let cbucket = this.getSelectedClaimBucket(pyrBucket);
    if (cbucket == null || clm == null || event.item == null || event.action == null) return;

    let dtCodeKey: string = event.item.value;
    let fndDtCode = clm.SVCDTS.filter(c => c.service_date_key == dtCodeKey);

    if (event.action.value == IceTypes.RecordActionType.oatRemove) {
      if (Iceutility.yesnomodal("Would you like to remove this date code?")) {
        if (fndDtCode.length > 0)
          fndDtCode[0].offline_record_status = IceTypes.offlineRecStatus.offlineDelete;

        if (clm.offline_record_status != IceTypes.offlineRecStatus.offlineInsert)
          clm.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;

        if (cbucket.offline_record_status != IceTypes.offlineRecStatus.offlineInsert)
          cbucket.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;

        this.autoSavePayerBuckets([cbucket]).subscribe(
          data => {
            if (data != null) {
              clm.SVCDTS = clm.SVCDTS.filter(c => c.service_date_key != dtCodeKey);
              this.loadItemDatesofEventsListControl(pyrBucket, clm);
              this.resetChangedBuckets(<claimbucket[]>data);
            }
          },
          error => {
            console.log(error);
          });
      }
    }
    else {
      if (fndDtCode.length > 0)
        this.doDatesPopup(pyrBucket, clm, "Item Date of Event", "", fndDtCode[0]);
    }
  }

  addItemProviderClick(event, pyrBucket: payerbucket, clm: claim): void {
    let cbucket = this.getSelectedClaimBucket(pyrBucket);
    if (cbucket == null || clm == null) return;

    let proref: provider_reference = new provider_reference(null);
    proref.offline_record_status = IceTypes.offlineRecStatus.offlineInsert;
    this.proSvc.doProviderPopup(this.dialog, this.practiceProviders, pyrBucket, proref).subscribe(result => {
      if (this.proSvc.processProvider(result) == true) {
        // save bucket
        if (proref.offline_record_status == IceTypes.offlineRecStatus.offlineInsert) {
          proref.provider_reference_key = Iceutility.guid(true);
          if (clm == null)
            cbucket.PROS.push(proref);
          else
            clm.PROS.push(proref);
        }

        if (clm.offline_record_status != IceTypes.offlineRecStatus.offlineInsert)
          clm.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;

        if (cbucket.offline_record_status != IceTypes.offlineRecStatus.offlineInsert)
          cbucket.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;

        this.autoSavePayerBuckets([cbucket]).subscribe(
          data => {
            if (data != null) {
              proref.offline_record_status = IceTypes.offlineRecStatus.offlineNoChange;
              this.loadItemProviderListControl(pyrBucket, clm);
              this.resetChangedBuckets(<claimbucket[]>data);
            }
          },
          error => {
            console.log(error);
          });;
      }
    });
  }

  itemProviderClick(event, pyrBucket: payerbucket, clm: claim): void {
    let cbucket = this.getSelectedClaimBucket(pyrBucket);
    if (cbucket == null || clm == null || event.item == null || event.action == null) return;

    let proRef = event.item.value;
    let fndPro = clm.PROS.filter(p => p.provider_reference_key == proRef);
    if (fndPro.length == 0) return;

    if (event.action.value == IceTypes.RecordActionType.oatRemove) {
      if (Iceutility.yesnomodal("Would you like to remove this provider?")) {
        if (fndPro.length > 0)
          for (let ipro = 0; ipro < fndPro.length; ipro++) fndPro[ipro].offline_record_status = IceTypes.offlineRecStatus.offlineDelete;

        if (clm.offline_record_status != IceTypes.offlineRecStatus.offlineInsert)
          clm.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;

        if (cbucket.offline_record_status != IceTypes.offlineRecStatus.offlineInsert)
          cbucket.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;

        this.autoSavePayerBuckets([cbucket]).subscribe(
          data => {
            if (data != null) {
              clm.PROS = clm.PROS.filter(p => p.provider_reference_key != fndPro[0].provider_reference_key);
              this.loadItemProviderListControl(pyrBucket, clm);
              this.resetChangedBuckets(<claimbucket[]>data);
            }
          },
          error => {
            console.log(error);
          });
      }
    }
    else {
      let proref: provider_reference = fndPro[0];
      this.proSvc.doProviderPopup(this.dialog, this.practiceProviders, pyrBucket, proref).subscribe(result => {
        if (this.proSvc.processProvider(result) == true) {
          // save bucket
          if (proref.offline_record_status != IceTypes.offlineRecStatus.offlineInsert)
            proref.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;

          if (clm.offline_record_status != IceTypes.offlineRecStatus.offlineInsert)
            clm.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;

          if (cbucket.offline_record_status != IceTypes.offlineRecStatus.offlineInsert)
            cbucket.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;

          this.autoSavePayerBuckets([cbucket]).subscribe(
            data => {
              if (data != null) {
                proref.offline_record_status = IceTypes.offlineRecStatus.offlineNoChange;
                this.loadItemProviderListControl(pyrBucket, clm);
                this.resetChangedBuckets(<claimbucket[]>data);
              }
            },
            error => {
              console.log(error);
            });
        }
      });
    }
  }

  addItemReferralAuthorizationClick(event, pyrBucket: payerbucket, clm: claim): void {
    let reflref: referralreference = new referralreference();
    reflref.offline_record_status = IceTypes.offlineRecStatus.offlineInsert;

    let refl: referral = new referral();
    refl.offline_record_status = IceTypes.offlineRecStatus.offlineInsert;
    refl.billing_provider_account_type = this.serviceCharges.from_account_type;
    refl.billing_provider_trans_account = this.serviceCharges.from_trans_account;
    this.doReferralAuthorizationPopup(pyrBucket, clm, reflref, refl);
  }

  itemReferralAuthorizationClick(event, pyrBucket: payerbucket, clm: claim): void {
    let cbucket = this.getSelectedClaimBucket(pyrBucket);
    if (cbucket == null || clm == null || event.item == null || event.action == null) return;

    let reflRefKey: string = event.item.value;
    let fndReflRef = clm.REFLREFS.filter(c => c.referral_reference_key == reflRefKey);

    if (event.action.value == IceTypes.RecordActionType.oatRemove) {
      if (Iceutility.yesnomodal("Would you like to remove this authorization?")) {
        if (fndReflRef.length > 0)
          fndReflRef[0].offline_record_status = IceTypes.offlineRecStatus.offlineDelete;

        if (clm.offline_record_status != IceTypes.offlineRecStatus.offlineInsert)
          clm.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;

        if (cbucket.offline_record_status != IceTypes.offlineRecStatus.offlineInsert)
          cbucket.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;

        this.autoSavePayerBuckets([cbucket]).subscribe(
          data => {
            if (data != null) {
              clm.REFLREFS = clm.REFLREFS.filter(c => c.referral_reference_key != reflRefKey);
              this.loadItemReferralAuthorizationListControl(pyrBucket, clm);
              this.resetChangedBuckets(<claimbucket[]>data);
            }
          },
          error => {
            console.log(error);
          });
      }
    }
    else {
      if (fndReflRef.length > 0) {
        let fndRefl = this.allReferrals.filter(r => r.referral_key == fndReflRef[0].referral_key);
        if (fndRefl.length > 0) {
          this.doReferralAuthorizationPopup(pyrBucket, clm, fndReflRef[0], fndRefl[0]);
        }
      }
    }
  }

  addItemOtherReferencesClick(event, pyrBucket: payerbucket, clm: claim): void {
    let refID: referenceidentification = new referenceidentification();
    refID.offline_record_status = IceTypes.offlineRecStatus.offlineInsert;
    this.doOtherReferencePopup(pyrBucket, clm, refID);
  }

  itemOtherReferencesClick(event, pyrBucket: payerbucket, clm: claim): void {
    let cbucket = this.getSelectedClaimBucket(pyrBucket);
    if (cbucket == null || clm == null || event.item == null || event.action == null) return;

    let refKey: string = event.item.value;
    let fndRef = clm.REFIDS.filter(c => c.reference_identification_key == refKey);

    if (event.action.value == IceTypes.RecordActionType.oatRemove) {
      if (Iceutility.yesnomodal("Would you like to remove this reference ID?")) {
        if (fndRef.length > 0)
          fndRef[0].offline_record_status = IceTypes.offlineRecStatus.offlineDelete;

        if (clm.offline_record_status != IceTypes.offlineRecStatus.offlineInsert)
          clm.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;

        if (cbucket.offline_record_status != IceTypes.offlineRecStatus.offlineInsert)
          cbucket.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;

        this.autoSavePayerBuckets([cbucket]).subscribe(
          data => {
            if (data != null) {
              clm.REFIDS = clm.REFIDS.filter(c => c.reference_identification_key != refKey);
              this.loadItemReferenceIDListControl(pyrBucket, clm);
              this.resetChangedBuckets(<claimbucket[]>data);
            }
          },
          error => {
            console.log(error);
          });
      }
    }
    else {
      if (fndRef.length > 0)
        this.doOtherReferencePopup(pyrBucket, clm, fndRef[0]);
    }
  }

  addItemAmountsClick(event, pyrBucket: payerbucket, clm: claim): void {
    let amtref: amount = new amount();
    amtref.offline_record_status = IceTypes.offlineRecStatus.offlineInsert;
    this.doAmountsPopup(pyrBucket, clm, amtref);
  }

  itemAmountsClick(event, pyrBucket: payerbucket, clm: claim): void {
    let cbucket = this.getSelectedClaimBucket(pyrBucket);
    if (cbucket == null || clm == null || event.item == null || event.action == null) return;

    let amtKey: string = event.item.value;
    let fndAmt = clm.COBS.filter(c => c.amount_key == amtKey);

    if (event.action.value == IceTypes.RecordActionType.oatRemove) {
      if (Iceutility.yesnomodal("Would you like to remove this COB Amount?")) {
        if (fndAmt.length > 0)
          fndAmt[0].offline_record_status = IceTypes.offlineRecStatus.offlineDelete;

        if (clm.offline_record_status != IceTypes.offlineRecStatus.offlineInsert)
          clm.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;

        if (cbucket.offline_record_status != IceTypes.offlineRecStatus.offlineInsert)
          cbucket.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;

        this.autoSavePayerBuckets([cbucket]).subscribe(
          data => {
            if (data != null) {
              clm.COBS = clm.COBS.filter(c => c.amount_key != amtKey);
              this.loadItemAmountsListControl(pyrBucket, clm);
              this.resetChangedBuckets(<claimbucket[]>data);
            }
          },
          error => {
            console.log(error);
          });
      }
    }
    else {
      if (fndAmt.length > 0)
        this.doAmountsPopup(pyrBucket, clm, fndAmt[0]);
    }
  }

  addItemAttachmentsClick(event, pyrBucket: payerbucket, clm: claim): void {
    let attchmt: claimsupplementalinformation = new claimsupplementalinformation();
    attchmt.offline_record_status = IceTypes.offlineRecStatus.offlineInsert;
    this.doAttachmentPopup(pyrBucket, clm, attchmt);
  }
  itemAttachmentsClick(event, pyrBucket: payerbucket, clm: claim): void {
    let cbucket = this.getSelectedClaimBucket(pyrBucket);
    if (cbucket == null || clm == null || event.item == null || event.action == null) return;

    let suppInfoKey: string = event.item.value;
    let fndsuppInfo = clm.SUPPL.filter(c => c.claim_supplemental_information_key == suppInfoKey);

    if (event.action.value == IceTypes.RecordActionType.oatRemove) {
      if (Iceutility.yesnomodal("Would you like to remove this Supplemental Information?")) {
        if (fndsuppInfo.length > 0)
          fndsuppInfo[0].offline_record_status = IceTypes.offlineRecStatus.offlineDelete;

        if (clm.offline_record_status != IceTypes.offlineRecStatus.offlineInsert)
          clm.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;

        if (cbucket.offline_record_status != IceTypes.offlineRecStatus.offlineInsert)
          cbucket.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;

        this.autoSavePayerBuckets([cbucket]).subscribe(
          data => {
            if (data != null) {
              clm.SUPPL = clm.SUPPL.filter(c => c.claim_supplemental_information_key != suppInfoKey);
              this.loadItemAttachmentsListControl(pyrBucket, clm);
              this.resetChangedBuckets(<claimbucket[]>data);
            }
          },
          error => {
            console.log(error);
          });
      }
    }
    else {
      if (fndsuppInfo.length > 0)
        this.doAttachmentPopup(pyrBucket, null, fndsuppInfo[0]);
    }
  }

  addItemNotesClick(event, pyrBucket: payerbucket, clm: claim): void {
    let clmnote: claimnote = new claimnote();
    clmnote.offline_record_status = IceTypes.offlineRecStatus.offlineInsert;
    this.doNotesPopup(pyrBucket, clm, clmnote);
  }
  itemNotesClick(event, pyrBucket: payerbucket, clm: claim): void {
    let cbucket = this.getSelectedClaimBucket(pyrBucket);
    if (cbucket == null || event.item == null || event.action == null) return;

    let clmNoteKey: string = event.item.value;
    let fndNote = clm.CLMNOTES.filter(c => c.claim_note_key == clmNoteKey);

    if (event.action.value == IceTypes.RecordActionType.oatRemove) {
      if (Iceutility.yesnomodal("Would you like to remove this Note?")) {
        if (fndNote.length > 0)
          fndNote[0].offline_record_status = IceTypes.offlineRecStatus.offlineDelete;

        if (clm.offline_record_status != IceTypes.offlineRecStatus.offlineInsert)
          clm.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;

        if (cbucket.offline_record_status != IceTypes.offlineRecStatus.offlineInsert)
          cbucket.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;

        this.autoSavePayerBuckets([cbucket]).subscribe(
          data => {
            if (data != null) {
              clm.SUPPL = clm.SUPPL.filter(c => c.claim_supplemental_information_key != clmNoteKey);
              this.loadItemNotesListControl(pyrBucket, clm);
              this.resetChangedBuckets(<claimbucket[]>data);
            }
          },
          error => {
            console.log(error);
          });
      }
    }
    else {
      if (fndNote.length > 0)
        this.doNotesPopup(pyrBucket, clm, fndNote[0]);
    }
  }

  onPostPaymentClick(event, pyrBucket: any, clm: claim): void {
    debugger;
    let paymt: payment = event["payment"];
    if (paymt != null) {
      this.acctSvc.postOneChargePayment(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), paymt).subscribe(
        postdata => {
        },
        posterror => {
        });
    }
  }

  // toolbar events
  onToolbarMenuItemClick(event) {
    //this.router.navigate([event.selectedItem.link]);

    if (this.previousPage === AppConstants.LedgerPage) {
      this.router.navigate([`/accounting/ledger`]);
    } else if (this.previousPage === AppConstants.ServiceChargeHistoryPage) {
      this.router.navigate([`/accounting/servicechargehistory`]);
    }
  }

  onToolbarMenuItemOpen(event) {
  }
}
